var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _polygon, _path7, _polygon2, _polygon3, _path8, _path9, _polygon4, _path10, _polygon5, _path11, _polygon6, _g2, _ellipse2, _ellipse3, _path12, _path13, _path14, _path15, _path16, _polygon7, _polygon8, _polygon9, _path17, _path18, _path19, _path20, _path21, _polyline, _path22, _line, _path23, _path24, _path25, _path26, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _polygon10, _path37, _path38, _path39, _g11, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _ellipse4, _polygon11, _path58, _polygon12, _polygon13, _path59, _path60, _polygon14, _path61, _polygon15, _path62, _polygon16, _g12, _ellipse5, _ellipse6, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _polygon17, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _g13, _path104, _path105, _path106, _path107, _path108, _g14, _path109, _path110, _path111, _path112, _path113, _ellipse7, _path114, _path115, _path116, _path117, _path118, _g15, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _g16, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _polygon18, _path155, _path156, _path157, _path158, _path159, _path160, _g17, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _polygon19, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _polygon20, _polygon21, _path179, _path180, _path181, _path182, _path183, _path184, _g18, _rect3, _text, _g19, _g20;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLargeDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3840 960",
    enableBackground: "new 0 0 3840 960",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "story-header-bg"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "white-bg",
    fill: "#FFFFFF",
    width: 3840,
    height: 960
  })), /*#__PURE__*/React.createElement("g", null, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3590,
    fill: "#1EBEE4",
    width: 250,
    height: 619
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "windpower_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3707.18,347.95c0,0,0.01,0,0.01,0C3707.19,347.95,3707.19,347.95,3707.18,347.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M3887.57,371.23c-0.31-0.02-0.63-0.04-0.96-0.07C3888.01,371.44,3888.4,371.4,3887.57,371.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M3796.93,330.24c0,0.02,0,0.04,0,0.06c0,0-1.08,0.5-2.87,0.5c-1.79,0-2.03-0.52-2.03-0.52 c-28.9,0.95-56.21,26.51-56.21,26.51s-13.08-8.44-28.63-8.84c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.01,0-0.01,0 c-0.11,0.08-1.01,1.29-5.35,1.29c-2.33,0-4.2-0.58-4.53-0.69c-22.12,3.29-36.51,18.75-50.38,23.09c0,0,12.9-4.05,35.87-5.69 c22.26-1.59,43.56,1.61,39.58-0.25c-3.98-1.86-12.18-6.65,6.18-3.96c18.55,2.72,30.23,10.56,44.74,12.11 c54.46,5.82,50.38-10.87,39.25-19.04c-23.14-16.97,8.16-13.36,32.28,0c16.64,9.21,32.7,15.52,41.77,16.34 c-4.04-0.82-16.5-4.41-32.39-16.01C3834.14,340.51,3820.92,330.66,3796.93,330.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M3707.18,347.95c0.01,0,0.01,0,0.01,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.35-6.13-2.5-82.88-3.02-101.6 c5.02,5.75,15.65,17.92,23.26,26.64l5.16-4.51c-5.08-8.13-11.24-18.01-13.08-21.15c-2.97-5.1-3.56-3.4-6.68-3.93 c-2.49-0.42-4.64-1.33-6.31-2.7c-0.38,2.36-2.42,4.17-4.89,4.17c-1.06,0-2.04-0.34-2.85-0.9l-1.55,104.57 c0,0,0.02,0.01,0.06,0.02c0.33,0.11,2.2,0.69,4.53,0.69C3706.17,349.24,3707.07,348.03,3707.18,347.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M3705.51,236.82c1.91-5.63,7.96-23.47,12.15-35.81l-6.49-2.2c-4.48,8.48-9.93,18.76-11.73,21.93 c-2.92,5.13-1.15,4.79-0.04,7.75c0.87,2.31,1.17,4.58,0.85,6.67c0.44-0.13,0.91-0.2,1.39-0.2 C3703.21,234.96,3704.61,235.69,3705.51,236.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M3721.73,189.02c1.33-3.92-2.31-5.68-4.43-1.77c-0.95,1.75-3.36,6.3-6.13,11.55l6.49,2.2 C3719.67,195.11,3721.24,190.47,3721.73,189.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M3735.76,282.52c2.72,3.12,6.07,0.86,3.75-2.94c-1.04-1.7-3.77-6.07-6.91-11.1l-5.16,4.51 C3731.53,277.68,3734.76,281.38,3735.76,282.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M3696.69,239.91c0-0.68,0.14-1.33,0.39-1.92c-6.17,1.26-24.19,4.93-36.71,7.49l1.37,6.72 c9.58-0.4,21.21-0.88,24.85-0.92c5.9-0.07,4.71-1.42,6.71-3.87c1.45-1.78,3.11-3.12,4.91-3.92 C3697.27,242.58,3696.69,241.31,3696.69,239.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M3647.95,248.01c-4.05,0.83-3.74,4.86,0.71,4.72c1.99-0.06,7.14-0.28,13.07-0.53l-1.37-6.72 C3654.25,246.72,3649.45,247.7,3647.95,248.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M3706.53,240.7c0.04-0.26,0.07-0.52,0.07-0.78c0-1.17-0.41-2.24-1.08-3.09 c-0.91-1.14-2.3-1.87-3.87-1.87c-0.48,0-0.95,0.07-1.39,0.2c-1.44,0.42-2.61,1.47-3.18,2.84c-0.25,0.59-0.39,1.24-0.39,1.92 c0,1.4,0.59,2.67,1.52,3.57c0.18,0.18,0.38,0.34,0.59,0.48c0.81,0.57,1.79,0.9,2.85,0.9 C3704.11,244.87,3706.15,243.06,3706.53,240.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M3794.06,330.8c1.79,0,2.87-0.5,2.87-0.5c0-0.02,0-0.04,0-0.06c-0.16-3.23-1.42-52.78-1.66-62.16 c-0.99,0.61-2.29,0.58-3.25-0.19c-0.34-0.28-0.59-0.62-0.77-0.99c-0.46,1.09-1.34,2.04-2.53,2.77c-1.3,0.8-1.87,0.15-2.28,2.95 c-0.25,1.73-1.23,7.25-2.03,11.79l3.12,1.08c1.48-4.25,3.43-9.86,4.76-13.69l-0.26,58.46 C3792.04,330.28,3792.28,330.8,3794.06,330.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M3783.34,290.61c-0.35,2.11,1.55,2.52,2.2,0.64c0.24-0.69,1.02-2.92,2-5.75l-3.12-1.08 C3783.92,287.23,3783.49,289.67,3783.34,290.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M3796.14,267.23c0.69,0.13,1.39,0.38,2.09,0.75c1.34,0.72,1.06,1.54,3.7,0.48 c1.63-0.65,6.88-2.58,11.22-4.16l-0.63-3.24c-5.29,1.03-12.61,2.44-16.34,3.17C3796.74,265.14,3796.74,266.3,3796.14,267.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M3819.06,262.13c2-0.76,1.4-2.61-0.55-2.23c-0.72,0.14-3.04,0.59-5.98,1.16l0.63,3.24 C3815.83,263.32,3818.16,262.47,3819.06,262.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M3791.61,263.93c0.25-0.3,0.54-0.54,0.86-0.71c-0.25-0.78-0.34-1.66-0.27-2.61 c0.11-1.52,0.97-1.6-1.07-3.57c-1.26-1.22-5.17-5.23-8.38-8.54l-2.7,1.9c3.75,5.34,9.5,13.6,10.97,15.71 C3790.91,265.36,3791.09,264.57,3791.61,263.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M3778.35,243.99c-1.51-1.52-2.95-0.21-1.81,1.42c0.42,0.6,1.78,2.53,3.5,4.99l2.7-1.9 C3780.76,246.45,3779.03,244.67,3778.35,243.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M3792.03,267.89c0.96,0.77,2.26,0.8,3.25,0.19c0.26-0.16,0.5-0.36,0.71-0.61 c0.06-0.08,0.11-0.16,0.16-0.24c0.6-0.92,0.6-2.09,0.04-3c-0.16-0.26-0.36-0.51-0.62-0.72c-0.91-0.73-2.13-0.81-3.09-0.29 c-0.32,0.17-0.62,0.41-0.86,0.71c-0.51,0.64-0.7,1.42-0.59,2.17c0.04,0.27,0.12,0.54,0.24,0.79 C3791.44,267.27,3791.69,267.61,3792.03,267.89z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3786.58,354.07c-6.76-12.88,8.89-14.42,18.18-16.33c7.04-1.44,8.88-4.25,3.54-5.7 c-3.82-1.04-7.63-1.58-11.4-1.73c-0.04,0.02-0.1,0.04-0.2,0.08c0.14-0.05,0.24-0.09,0.24-0.09l0-0.06l-1.64-62.17 c-0.55,0.35-1.2,0.5-1.84,0.42c-0.04,0.13-0.09,0.26-0.14,0.41c0.37,0.85,0.68,2.03,0.74,3.65c0.17,4.31,1.34,57.21,1.38,58.15 c-0.39,0.06-0.85,0.11-1.37,0.11c-1.42,0-1.86-0.33-1.98-0.47c-9.57,0.45-18.73,3.27-26.78,6.92 c-17.32,7.86-29.47,19.53-29.47,19.53c17.68,14.49,37.47,17.06,37.47,17.06C3787.69,373.62,3790.48,361.51,3786.58,354.07z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3700.61,356.3c2.86-6.82,13.51-7.21,15.83-7.21c0.29,0,0.46,0.01,0.46,0.01 c-1.76-0.35-3.48-0.61-5.15-0.8c-0.17-0.02-0.34-0.04-0.51-0.06c-0.09-0.01-0.18-0.02-0.27-0.03c-1.29-0.13-2.55-0.21-3.79-0.24 c0,0,0.01-0.01,0.01-0.01v0l0,0l-1.59-50.86l-1.65-52.8c-0.69,0.37-1.48,0.58-2.32,0.58c-0.69,0-1.34-0.14-1.94-0.4 c1.03,0.94,2.67,3.13,2.84,7.6c0.25,6.57,1.74,96.43,1.74,96.96c0.21-0.01,0.4-0.03,0.59-0.05c-0.75,0.16-1.74,0.27-3.04,0.27 c-2.21,0-4.01-0.53-4.47-0.67c-2.76,0.42-5.4,1.04-7.95,1.79c-5.01,1.48-9.67,3.48-14.22,5.85c-3.11,1.62-6.18,3.42-9.26,5.34 c-11.5,7.15-16.88,9.34-18.48,9.91c-0.15,0.05-0.26,0.09-0.35,0.12c-0.12,0.04-0.19,0.06-0.19,0.06l15.43-3.34l2.88-0.62 C3683.78,364.71,3697.09,364.68,3700.61,356.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ix3"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M3653.47,442.81c-21.14-21.7-43.9-47.33-105.48-51.88c-3.26-0.24-6.47-0.46-9.62-0.65l34.89,83.26 c0.27,0.02,0.52,0.05,0.75,0.07c11.38,1.03,90.79,10.17,99.94,10.79c9.15,0.62,10.65-6.06,10.65-6.06 S3674.6,464.51,3653.47,442.81z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M3199.27,673.14c0,0-30.5,1.69-52.26,3.07c-22.94,1.46-92.21,6.76-43.71,18.27 c7.11,1.69,51.88,12.31,101.77,20.51c64.4,10.58,95.89,5.56,106.54,4.32c60.1-6.99,113.03-13.06,166.78-20.16 c73.56-9.72,264.18-30.55,286.04-34.26c21.86-3.71-13.66-10.47-73.14-15.51c-43.51-3.69-117.7-10.49-145.03-5.9 C3492.89,652.46,3199.27,673.14,3199.27,673.14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M3717.99,633.97c3.07-1.27,76.65-23.38,76.65-23.38s13.8-81.06-24.53-78.46 C3731.78,534.72,3717.99,633.97,3717.99,633.97z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M3402.2,654.75c0,0,106.28-1.04,123.66-3.64c17.37-2.6,19.93-111.2-44.97-112.24 C3416,537.83,3402.2,654.75,3402.2,654.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M3483.35,562.6c14.74,0,41.46,16.61,38.55,71.49c-2.69,50.79-31.75,65.34-44.6,65.34 c-10.86,0-63.1-1.08-82.88-42.44c0,0,16.45-1.17,19.92-16.13C3418.17,624.39,3432.84,562.6,3483.35,562.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3438.44,637.33c-1-12.49-5.42-25.84-7.99-34.83c0,0,17.13-43.54,53.95-37.45 c42.44,7.03,38.16,75.09,35.68,85.64c-3.14,13.35-11.42,45.87-41.68,48.48C3448.14,701.77,3439.58,651.55,3438.44,637.33z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0288 -0.9996 0.9996 0.0288 2750.3103 4091.4338)",
    fill: "#FFFFFF",
    cx: 3480.67,
    cy: 630.37,
    rx: 56.33,
    ry: 34.97
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#191C1C",
    points: "3489.44,577.96 3492.76,599.15 3509.63,602.59 3513.26,625.37 3500.31,638.81 3504.78,664.58 3497.38,666.96 3492.34,678.76 3481.58,664.12 3466.64,679.36 3462.57,666.82 3454.93,664.99 3461.59,638.81 3447.86,625.78 3453.76,614.79 3453.11,601.36 3469.14,600.15 3474.71,577.55 3481.3,580.53  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3479.7771,
    y1: 680.144,
    x2: 3481.2725,
    y2: 576.0308
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6968,
    style: {
      stopColor: "#FCFCFC",
      stopOpacity: 0.8265
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7171,
    style: {
      stopColor: "#F3F3F3",
      stopOpacity: 0.7017
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    style: {
      stopColor: "#E3E3E3",
      stopOpacity: 0.5921
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7515,
    style: {
      stopColor: "#CDCDCD",
      stopOpacity: 0.4913
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7669,
    style: {
      stopColor: "#B0B0B0",
      stopOpacity: 0.3965
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7817,
    style: {
      stopColor: "#8D8D8D",
      stopOpacity: 0.3061
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7959,
    style: {
      stopColor: "#636363",
      stopOpacity: 0.2192
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8093,
    style: {
      stopColor: "#343433",
      stopOpacity: 0.1372
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8153,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_)",
    strokeMiterlimit: 10,
    d: "M3474.71,577.55l-6.46,18.47l-15.14,5.34 c0,0-4.64,14.98-5.25,24.43l9.69,16.42l-2.62,22.78c0,0,4.24,9.65,11.71,14.37l13.52-9.24l12.11,9.24 c0,0,8.68-7.59,12.51-14.78l-0.81-22.17l9.29-17.04c0,0,0-12.52-3.63-22.78l-13.52-4.52l-6.66-20.12 C3489.44,577.96,3484.6,575.08,3474.71,577.55z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "3489.44,577.96 3486.82,607.31 3491.26,612.03 3509.63,602.59 3496.11,598.07  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "3474.71,577.55 3472.49,606.28 3468.25,611.62 3453.11,601.36 3468.25,596.02  "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3453.11,601.36l3.63,9.03l-3.43,13.14l-5.45,2.26C3447.86,625.78,3448.87,612.24,3453.11,601.36z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3509.63,602.59l-4.44,8.01l2.02,12.32l6.06,2.46C3513.26,625.37,3513.26,613.26,3509.63,602.59z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "3513.26,625.37 3495.1,633.99 3493.08,642.2 3504.78,664.58 3503.98,642.41  "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3504.78,664.58l-6.06-3.9l-6.26,7.39l-0.2,11.29C3492.27,679.36,3502.16,671.15,3504.78,664.58z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "3492.27,679.36 3480.77,655.34 3476.32,654.31 3466.64,679.36 3480.16,670.12  "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3466.64,679.36l1.61-10.47c0,0-7.47-8.21-7.67-7.59s-5.65,3.69-5.65,3.69 S3460.38,675.66,3466.64,679.36z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "3454.93,664.99 3464.62,640.97 3463.41,633.17 3447.86,625.78 3457.55,642.2  "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "#191C1C",
    x1: 3503.98,
    y1: 642.41,
    x2: 3512.25,
    y2: 646.72
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 3496.11,
    y1: 598.07,
    x2: 3501.56,
    y2: 586.99
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 3480.16,
    y1: 670.12,
    x2: 3480.16,
    y2: 684.28
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 3457.55,
    y1: 642.2,
    x2: 3449.08,
    y2: 646.31
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 3468.25,
    y1: 596.02,
    x2: 3461.99,
    y2: 586.78
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 3474.77,
    cy: 629.78,
    rx: 3.29,
    ry: 5.65
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#1EBEE4",
    cx: 3474.77,
    cy: 629.78,
    rx: 2.15,
    ry: 3.69
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M3169.93,625.76c0,0-3.19,56.56,67.37,56.56c50.54,0,51.5-52.68,51.5-52.68L3169.93,625.76z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3170.22,632.23l30.46,8.11c0,0,1.93,31.23,26.59,41.56C3227.27,681.9,3176.22,681.31,3170.22,632.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 3170.2234,
    y1: 657.0697,
    x2: 3227.2656,
    y2: 657.0697
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4606,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.1908
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6335,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.3745
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7516,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.5
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M3170.22,632.23l30.46,8.11c0,0,1.93,31.23,26.59,41.56 C3227.27,681.9,3176.22,681.31,3170.22,632.23z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3409.35,655.27c0,0-28.65,4.65-88.11,2.44c-49.34-1.84-199.4-19.23-205.2-45.41l235.67,12.54 L3409.35,655.27z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 3282.4817,
    y1: 437.5905,
    x2: 3254.5078,
    y2: 715.0302
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6051,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.1908
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7148,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.3745
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7516,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.5
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M3409.35,655.27c0,0-28.65,4.65-88.11,2.44c-49.34-1.84-199.4-19.23-205.2-45.41l235.67,12.54 L3409.35,655.27z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#1EBEE4",
    points: "3464.54,389.69 3554.22,393.74 3581.67,475.45 3475.88,465.92 3464.83,459.11  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.63,
    fill: "#A1C8D9",
    points: "3464.54,389.69 3554.22,393.74 3581.67,475.45 3475.88,465.92 3464.83,459.11 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A59B91",
    points: "3664.97,482.45 3656.69,471.92 3594.75,470.98 3597.87,476.73 3665.44,484.56  "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3663.93,482.84c0,0-26.48-36.38-45.4-52.47s-61.22-31.83-158.56-26.58l-0.61-14.59 c0,0,54.61-1.85,95.54,2c40.93,3.85,70.85,18.54,104.56,57.01c33.71,38.47,31.3,36.38,31.3,36.38S3671.84,490.54,3663.93,482.84 z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M3151.82,446.66c-1.86,2.01-6.98,6.03,2.44,6.62c9.42,0.59,62.27,0.31,62.27,0.31s48.73,0,68.41-0.98 c19.68-0.98,53.29-0.98,59.77-9.76c6.48-8.79,14.16-22.95,14.16-22.95s-0.31-0.57-0.98-1.5c-2.96-4.09-13.02-15.1-35.5-15.1 c-27.6,0-103.69,0-111.61,0c-7.72,0-20.37,1.4-35.55,17.58c-0.39,0.42-0.79,0.84-1.18,1.28 C3158.33,439.57,3153.68,444.65,3151.82,446.66z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 3784.8457,
    y1: 512.9923,
    x2: 3802.9539,
    y2: 531.1004
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3653,
    style: {
      stopColor: "#FCFCFC",
      stopOpacity: 0.8265
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4743,
    style: {
      stopColor: "#F3F3F3",
      stopOpacity: 0.7017
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5701,
    style: {
      stopColor: "#E3E3E3",
      stopOpacity: 0.5921
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6582,
    style: {
      stopColor: "#CDCDCD",
      stopOpacity: 0.4913
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    style: {
      stopColor: "#B0B0B0",
      stopOpacity: 0.3965
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#8D8D8D",
      stopOpacity: 0.3061
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8959,
    style: {
      stopColor: "#636363",
      stopOpacity: 0.2192
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9675,
    style: {
      stopColor: "#343433",
      stopOpacity: 0.1372
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M3799.04,535.01c0,0,2.1-18.28-10.32-24.93c0,0-5.48,0.98-1.32,7.22 C3791.57,523.54,3799.04,535.01,3799.04,535.01z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M3801.99,545.18c-1.6-9.21-3.46-11.65-3.46-11.65s-4.26-8.13-8.52-13.81c-4.26-5.69-5.06-8.67-1.07-9.75 c0,0-13.05-18.15-87.36-34.4c0,0-2.33,2.62-8.79,3.79c0,0-0.48,0.42-1.32,0.96c-0.94,0.59-2.32,1.32-4.01,1.75 c0,0-5.33,4.6-13.32,4.33c-7.99-0.27-105.73-11.38-105.73-11.38s-49.54-4.06-63.39-5.42c-13.85-1.35-41.28-9.21-54.6-13.27 c-13.32-4.06-38.88-13.54-45.01-15.44c-6.13-1.9-8.52-5.69-6.92-14.9c1.6-9.21,7.19-24.92,9.32-30.06 c2.13-5.15,18.91-8.67,30.36-9.48c11.45-0.81,71.64-4.33,111.06,0.54c39.42,4.88,64.04,13.62,88.78,37.95 c24.75,24.34,39.43,41.17,39.43,41.17l0.55-1.52l1.35-3.15c0,0-49.76-56.41-78.04-66.92c-28.28-10.51-75.05-19.08-114.48-21.02 c-39.43-1.94-100.59,2.96-100.59,2.96l-26.04,7.7l-40.24,84.74l80.01,69.33l40.72,6.26l42.61-16.37l38.82,16.37l13.73,48.63 l184.65,1.93l27.46-62.11l26.51-7.7l15.15,9.63l9,21.18l1.42,32.74l1.69-4.63C3801.72,584.18,3803.59,554.39,3801.99,545.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 3223.9741,
    y1: 378.1872,
    x2: 3316.3955,
    y2: 378.1872
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2783,
    style: {
      stopColor: "#FBFBFB",
      stopOpacity: 0.9172
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3622,
    style: {
      stopColor: "#F0F0F0",
      stopOpacity: 0.8372
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    style: {
      stopColor: "#DCDCDC",
      stopOpacity: 0.7584
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    style: {
      stopColor: "#C1C1C1",
      stopOpacity: 0.6803
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    style: {
      stopColor: "#9E9E9E",
      stopOpacity: 0.6026
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    style: {
      stopColor: "#737372",
      stopOpacity: 0.5253
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.4498
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8212,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.4
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M3223.97,383.5c0,0,21.1-12.8,92.42-10.29"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "#FFFFFF",
    points: "3316.4,373.21 3231.87,384.25 3223.97,383.5  "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M3340.06,535.88c0,0-1.47,9.03-2.91,20.29c-1.15,9-1.93,17.15-7.95,19.11 c-6.02,1.96-30.11,6.86-39.26,7.1c-6.79,0.18-79.92-2.6-123.97-4.05c-15.31-0.5-27.1-0.85-31.39-0.85 c-16.62,0-18.31-5.63-19.75-11.02c-1.16-4.33-2.32-10.07-2.73-12.17c0,5.81,0,11.3,0,13.06c0,3.99-0.51,11.31-0.51,14.91 c0,3.6,0.76,11.31,0.76,11.31s1.44,3.32,12.86,4.42c4.47,0.43,28.45,1.92,56.95,3.58c44.37,2.58,99.7,5.55,109.47,5.55 c16.04,0,58.74-2.21,58.74-2.21s4.2-26.26,4.89-38.71C3356.17,549.7,3357.74,536.98,3340.06,535.88z"
  })), /*#__PURE__*/React.createElement("g", null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 3387.61,
    y1: 617.92,
    x2: 3351.89,
    y2: 614.53
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3353.24,603.51l-2.65-0.13c-0.15,0.99-0.24,1.54-0.24,1.54s-42.69,2.21-58.74,2.21 c-9.77,0-65.1-2.97-109.47-5.55c-28.51-1.65-52.49-3.15-56.95-3.58c-10.47-1.01-12.55-3.88-12.82-4.36l4.04,21.6 c0,0,18.25,6.58,53.84,8.46c35.58,1.88,139.09,8.46,157.35,8.46s22.64-4.23,22.64-4.23l1.65-13.42L3353.24,603.51z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#77514D",
    d: "M3119.48,597.36l-2.48,5.73c-0.06,0.14-0.24,0.19-0.37,0.1l-2.86-2.45c-0.06-0.04-0.1-0.11-0.1-0.18 c0,0-1.46-7.02-1.29-6.9c0.7,0.53,2.87,1.93,6.96,3.38C3119.47,597.08,3119.54,597.23,3119.48,597.36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 3112.3794,
    y1: 612.912,
    x2: 3350.356,
    y2: 612.912
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0648,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M3350.36,604.92c0,0-42.69,2.21-58.74,2.21c-9.77,0-65.1-2.97-109.47-5.55 c-28.51-1.65-52.49-3.15-56.95-3.58c-10.47-1.01-12.55-3.88-12.82-4.36l4.04,21.6c0,0,18.25,6.58,53.84,8.46 c35.58,1.88,139.09,8.46,157.35,8.46s21.16-3.5,21.16-3.5L3350.36,604.92z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M3125.2,598.01c4.47,0.43,28.45,1.92,56.95,3.58c44.37,2.58,99.7,5.55,109.47,5.55 c16.04,0,58.74-2.21,58.74-2.21s0.09-0.56,0.24-1.54c0.9-5.8,4.06-26.53,4.65-37.17c0.92-16.5,2.48-29.22-15.19-30.33 c0,0-1.47,9.03-2.91,20.29c-1.15,9-1.93,17.15-7.95,19.11c-6.02,1.96-30.11,6.86-39.26,7.1c-6.79,0.18-79.92-2.6-123.97-4.05 c-15.31-0.5-27.1-0.85-31.39-0.85c-16.62,0-18.31-5.63-19.75-11.02c-1.16-4.33-2.32-10.07-2.73-12.17c0,5.81,0,11.3,0,13.06 c0,3.99-0.51,11.31-0.51,14.91c0,2.5,0.37,6.99,0.59,9.5c0.06,0.71,0.12,1.26,0.14,1.56c0.02,0.16,0.02,0.25,0.02,0.25 s0.01,0.02,0.04,0.07C3112.65,594.12,3114.73,596.99,3125.2,598.01z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3129.67,536.53l-0.18-24.09c0,0,0,14.75,0,19.99C3129.49,533.61,3129.55,535.02,3129.67,536.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M3133.08,551.8c2.38,4.44,3.57,11.9,15.08,12.71c11.14,0.78,130.83,5.15,150.89,5.43 c9.22-8.31,12-24.69,13.78-33.33c2.45-11.89,5.98-19.91,5.98-19.91l4.86-0.06l0.13-0.6l-3.7-31.62c0,0-44.05,1.88-60.34,1.88 c-16.29,0-90.64-1.28-90.64-1.28L3158.09,499c0,0-19.11,3.81-18.71,3.81s-9.89,9.64-9.89,9.64l0.18,24.09 C3130.09,541.77,3131.23,548.36,3133.08,551.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M3148.15,564.51c-11.51-0.81-12.7-8.27-15.08-12.71c-1.85-3.44-2.98-10.04-3.4-15.27 c-0.12-1.52-0.18-2.92-0.18-4.09c0-5.25,0-19.99,0-19.99s-5.02,15.14-5.02,17.22c0,2.07,0.18,9.17,0.73,21.61 c0.54,12.44,2.18,16.32,8.7,17.15s131.34,6.64,151.74,6.64c4.29,0,7.87-1.18,10.87-3.15c0.9-0.59,1.75-1.24,2.54-1.96 C3278.98,569.67,3159.29,565.3,3148.15,564.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M3323.68,516.65l-4.86,0.06c0,0-3.53,8.02-5.98,19.91c-1.78,8.64-4.56,25.02-13.78,33.33 c-0.8,0.72-1.65,1.37-2.54,1.96c-3,1.97-6.58,3.15-10.87,3.15c-20.39,0-145.21-5.81-151.74-6.64s-8.16-4.7-8.7-17.15 c-0.54-12.44-0.73-19.54-0.73-21.61c0-2.07,5.02-17.22,5.02-17.22l-7.29-0.11c0,0-6.7,14.01-8.09,17.23s-2.02,5.53-2.02,8.1 c0,1.44,0,9.29,0,16.63c0.41,2.1,1.57,7.84,2.73,12.17c1.45,5.39,3.13,11.02,19.75,11.02s146.21,5.14,155.36,4.9 c9.15-0.24,33.24-5.14,39.26-7.1c6.02-1.96,6.79-10.11,7.95-19.11c1.45-11.27,2.91-20.29,2.91-20.29s10.3-14.75,23.62-19.72 L3323.68,516.65z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D25959",
    d: "M3381.84,480.35c-5.64-3.26-37.65-5.12-69.21-1.24c-23.71,2.91-37.95,6.09-43.57,7.48 c-1.41,0.35-2.1,1.97-1.4,3.26l5.18,9.53c0.38,0.69,1.08,1.13,1.86,1.15c3.65,0.11,14.26,0.52,17.65,1.67 c4.12,1.4,16.16,9.77,21.95,9.77c5.79,0,41.92,0,45.73,0c4.84,0,11.34-6.1,16.01-12.31c-7.15,0.23-49.16,1.54-57.67,1.25 c-9.31-0.32-13.89-2.73-19.1-4.33c-5.21-1.6-7.1-2.09-11.84-1.93c-3.84,0.13-8.92,0.37-10.71,0.45 c-0.4,0.02-0.76-0.21-0.91-0.58l-1.43-3.42c-0.24-0.58,0.12-1.24,0.74-1.33c8.4-1.24,59.04-8.23,109.48-4.84 C3384.9,483.16,3384.19,481.7,3381.84,480.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M3301.04,494.45c-0.53,0.01-0.71,0.73-0.24,0.99c1.98,1.1,5.4,2.8,8.15,3.07 c2.34,0.24,6.42,0.27,7.86,0.28c0.29,0,0.52-0.24,0.52-0.53v-3.65c0-0.3-0.24-0.54-0.53-0.53L3301.04,494.45z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#77514D",
    d: "M3130.34,503.25c0.29,0.02,0.58-0.07,0.82-0.25l8.85-6.82c0.18-0.14,0.4-0.23,0.63-0.25l10.69-0.9 c0.47-0.04,0.87-0.35,1.04-0.8l1.59-4.32c0.27-0.74-0.2-1.55-0.98-1.66l-27.72-3.8c0.18,0.12,0.28,0.32,0.28,0.55l-0.34,13.19 c0,0.16-0.07,0.32-0.18,0.44l-3.56,3.62c-0.11,0.11-0.17,0.26-0.18,0.41l-0.01,0.19c0.22-0.15,0.49-0.24,0.77-0.22 L3130.34,503.25z M3130.39,492.4c0-0.27,0.23-0.48,0.49-0.45l6.84,0.7c0.41,0.04,0.55,0.57,0.22,0.82l-3.52,2.65 c-0.08,0.06-0.18,0.09-0.29,0.09l-3.32-0.15c-0.24-0.01-0.43-0.21-0.43-0.46V492.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3381.84,480.35c-5.64-3.26-37.65-5.12-69.21-1.24c-23.71,2.91-37.95,6.09-43.57,7.48 c-1.41,0.35-2.1,1.97-1.4,3.26l5.18,9.53c0.38,0.69,1.08,1.13,1.86,1.15c3.65,0.11,14.26,0.52,17.65,1.67 c4.12,1.4,16.16,9.77,21.95,9.77c5.79,0,41.92,0,45.73,0c4.84,0,11.34-6.1,16.01-12.31c-7.15,0.23-49.16,1.54-57.67,1.25 c-9.31-0.32-13.89-2.73-19.1-4.33c-5.21-1.6-7.1-2.09-11.84-1.93c-3.84,0.13-8.92,0.37-10.71,0.45 c-0.4,0.02-0.76-0.21-0.91-0.58l-1.43-3.42c-0.24-0.58,0.12-1.24,0.74-1.33c8.4-1.24,59.04-8.23,109.48-4.84 C3384.9,483.16,3384.19,481.7,3381.84,480.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3301.04,494.45c-0.53,0.01-0.71,0.73-0.24,0.99c1.98,1.1,5.4,2.8,8.15,3.07 c2.34,0.24,6.42,0.27,7.86,0.28c0.29,0,0.52-0.24,0.52-0.53v-3.65c0-0.3-0.24-0.54-0.53-0.53L3301.04,494.45z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M3133.66,465.23c-1.43,0.91-1.93,1.84-1.93,2.72c0,1.23,0,2.32,0,3.26c0.03,0.08,0.05,0.16,0.05,0.25 v3.06c0,0.28,0.18,0.53,0.44,0.61l29.66,9.58c0.06,0.02,0.11,0.03,0.17,0.03l9.71,0.32c0.18,0.01,0.32,0.08,0.43,0.19 c0.2,0.21,0.26,0.56,0.06,0.83l-0.83,1.13l92.77-0.32c0.5-0.57,1.35-1,2.38-1.35c0.4-0.14,0.83-0.26,1.28-0.38 c13.71-3.57,43.7-7.53,51.22-8.56c1.07-0.15,2.05-0.68,2.76-1.51c2.37-2.74,5.97-5.93,8.11-7.74 c0.18-0.15,0.34-0.29,0.5-0.42c0.73-0.61,1.62-0.97,2.56-1.04c0.11-0.01,0.22-0.01,0.32-0.01c0,0-0.1-0.01-0.29-0.04 c-4.21-0.59-54.42-7.36-120.49-7.36C3157.84,458.48,3139.09,461.76,3133.66,465.23z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#77514D",
    d: "M3393,477.58c-10.91-7.13-30.05-11.54-59.68-11.7c-1.05-0.01-2.07,0.37-2.89,1.05 c-2.03,1.71-6.04,5.2-8.61,8.17c-0.71,0.82-1.69,1.36-2.76,1.51c-7.51,1.03-37.51,4.99-51.22,8.56 c-0.44,0.12-0.87,0.24-1.28,0.38c-1.03,0.35-1.88,0.77-2.38,1.35c-0.58,0.67-0.67,1.55,0.04,2.74l8.59,13.73 c0.83,1.38,2.31,2.2,3.89,2.18c1.03-0.02,2.29-0.01,3.62,0.05c0.69,0.03,1.4,0.08,2.1,0.15c0.89,0.03,1.53,0.12,1.96,0.25 c1.18,0.2,2.25,0.47,3.09,0.85c3.97,1.82,14.28,9.68,23.01,9.68s54.35,0,60.31,0s13.09-5.65,18.45-14.32 C3394.58,493.52,3404.11,484.85,3393,477.58z M3384.61,484.94c-50.44-3.39-101.08,3.6-109.48,4.84 c-0.61,0.09-0.98,0.75-0.74,1.33l1.43,3.42c0.15,0.37,0.52,0.6,0.91,0.58c1.79-0.08,6.87-0.32,10.71-0.45 c4.73-0.16,6.63,0.32,11.84,1.93c5.21,1.6,9.78,4.01,19.1,4.33c8.51,0.29,50.53-1.02,57.67-1.25 c-4.67,6.2-11.17,12.31-16.01,12.31c-3.81,0-39.94,0-45.73,0c-5.79,0-17.84-8.37-21.95-9.77c-3.39-1.15-14-1.56-17.65-1.67 c-0.78-0.02-1.48-0.46-1.86-1.15l-5.18-9.53c-0.7-1.29-0.01-2.91,1.4-3.26c5.62-1.4,19.86-4.57,43.57-7.48 c31.55-3.88,63.57-2.02,69.21,1.24C3384.19,481.7,3384.9,483.16,3384.61,484.94z M3317.33,498.26c0,0.29-0.23,0.53-0.52,0.53 c-1.44,0-5.52-0.04-7.86-0.28c-2.75-0.28-6.17-1.97-8.15-3.07c-0.47-0.26-0.29-0.98,0.24-0.99l15.76-0.36 c0.29-0.01,0.53,0.23,0.53,0.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M3301.06,494.5c-0.53,0.01-0.71,0.73-0.24,0.99c1.98,1.1,5.41,2.79,8.17,3.07 c2.35,0.24,6.44,0.27,7.89,0.28c0.29,0,0.52-0.24,0.52-0.53v-3.64c0-0.3-0.24-0.53-0.53-0.53L3301.06,494.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#77514D",
    d: "M3172.19,485.26c-0.11-0.11-0.25-0.19-0.43-0.19l-9.71-0.32c-0.06,0-0.12-0.01-0.17-0.03l-29.66-9.58 c-0.26-0.08-0.44-0.33-0.44-0.61v-3.06c0-0.09-0.02-0.18-0.05-0.25c-0.18-0.45-0.83-0.56-1.12-0.09l-2.85,4.66 c-0.05,0.08-0.11,0.14-0.19,0.19l-2.87,1.95c0,0-0.01,0.01-0.01,0.01c0.04,0.01,0.08,0.01,0.12,0.02l32.78,7.78 c0.71,0.17,1.12,0.94,0.86,1.64l-3.75,10.16c-0.18,0.48-0.63,0.8-1.14,0.8h-11.04c-0.3,0-0.58,0.11-0.8,0.31l-9.7,8.68 c-0.22,0.2-0.51,0.31-0.8,0.31h-9.13c-0.46,0-0.86-0.26-1.06-0.64l-0.08,1.3c0,0.08,0.01,0.16,0.03,0.24l1.08,3.38 c0.08,0.26,0.33,0.44,0.6,0.44h13.03c0.11,0,0.21-0.03,0.31-0.08l13.58-7.76c0.08-0.05,0.17-0.07,0.26-0.08l8.16-0.61l1-0.08 c0.18-0.01,0.35-0.11,0.46-0.26l11.94-16.25l0.83-1.13C3172.45,485.82,3172.39,485.47,3172.19,485.26z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D25959",
    d: "M3122.1,507.62h9.13c0.3,0,0.58-0.11,0.8-0.31l9.7-8.68c0.22-0.2,0.51-0.31,0.8-0.31h11.04 c0.51,0,0.96-0.32,1.14-0.8l3.75-10.16c0.26-0.7-0.15-1.47-0.86-1.64l-32.78-7.78c-0.04-0.01-0.08-0.01-0.12-0.02 c-0.13,0.09-0.22,0.23-0.25,0.38l-1.07,4.81c-0.07,0.31,0.1,0.63,0.39,0.74l1.38,0.54c0.04,0.02,0.09,0.04,0.12,0.07l27.72,3.8 c0.77,0.11,1.25,0.92,0.98,1.66l-1.59,4.32c-0.17,0.45-0.57,0.76-1.04,0.8l-10.69,0.9c-0.23,0.02-0.45,0.1-0.63,0.25 l-8.85,6.82c-0.23,0.18-0.53,0.27-0.82,0.25l-8.29-0.59c-0.29-0.02-0.55,0.06-0.77,0.22l-0.24,4.1 C3121.24,507.36,3121.64,507.62,3122.1,507.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1CAB7",
    d: "M3130.82,496.06l3.32,0.15c0.1,0,0.2-0.03,0.29-0.09l3.52-2.65c0.33-0.25,0.19-0.78-0.22-0.82 l-6.84-0.7c-0.26-0.03-0.49,0.18-0.49,0.45v3.2C3130.39,495.85,3130.58,496.05,3130.82,496.06z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9992 -0.0398 0.0398 0.9992 -16.3088 128.2352)",
    fill: "#1EBEE4",
    cx: 3208.82,
    cy: 473.25,
    rx: 6.99,
    ry: 9.53
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9992 -0.0401 0.0401 0.9992 -16.4189 129.1819)",
    fill: "#141616",
    cx: 3208.23,
    cy: 473.4,
    rx: 5.73,
    ry: 8.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9992 -0.0401 0.0401 0.9992 -16.4189 129.1819)",
    fill: "#FFFFFF",
    cx: 3208.23,
    cy: 473.4,
    rx: 3.55,
    ry: 5.08
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M3208.02,468.32v5h-3.33C3204.68,473.32,3204.53,468.74,3208.02,468.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M3208.02,473.32v5.16c0,0,3.68,0.38,3.75-5.16L3208.02,473.32z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M3138.76,542.53l2.17-0.05c0,0-1.43,6.04-1.5,6.34s-0.21,0.56-0.88,0.5s-1.6-0.2-1.6-0.2 s1.18-5.6,1.35-6.09C3138.49,542.52,3138.76,542.53,3138.76,542.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M3139.26,544.37c0,0,0.8,0.16,0.94-0.26c0.15-0.42,0.24-0.93,0.24-0.93l-0.91,0.03L3139.26,544.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M3140.04,544.74c0,0-0.32,0-0.58,0c-0.26,0.01-0.36,0.22-0.42,0.47s-0.79,3.64-0.79,3.64 s0.46,0.02,0.65,0.04s0.31-0.2,0.42-0.69C3139.42,547.71,3140.04,544.74,3140.04,544.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M3141.6,543.3l0.77-0.02c0.04,0,0.08,0.02,0.1,0.06l0.68,1.53c0.03,0.07,0.11,0.08,0.17,0.03l1.7-1.61 c0.02-0.02,0.04-0.03,0.07-0.03l1.22,0c0.09,0,0.14,0.11,0.07,0.18l-2.57,2.64c-0.03,0.03-0.04,0.08-0.02,0.12l1.39,2.79 c0.04,0.07-0.02,0.16-0.1,0.15l-1.09-0.07c-0.04,0-0.07-0.02-0.09-0.06l-0.96-1.91c-0.03-0.06-0.12-0.08-0.17-0.03 c-0.34,0.36-1.45,1.51-1.58,1.62c-0.14,0.13-0.18,0.11-0.46,0.1c-0.16-0.01-0.38-0.03-0.54-0.05 c-0.08-0.01-0.12-0.11-0.07-0.18l2.27-2.6c0.03-0.03,0.03-0.07,0.02-0.11l-0.91-2.44 C3141.48,543.37,3141.52,543.3,3141.6,543.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M3147.49,544.26l3.74,0.03c0.05,0,0.09,0.05,0.08,0.11l-0.38,1.37c-0.01,0.04-0.04,0.06-0.08,0.06 c-0.33,0-1.9-0.03-2.19-0.04c-0.31-0.01-0.44,0.39-0.53,0.78c-0.01,0.05,0.03,0.1,0.08,0.1l2.28,0.11 c0.05,0,0.09,0.05,0.08,0.1c-0.06,0.28-0.24,1.11-0.31,1.27c-0.08,0.2-0.16,0.15-0.43,0.14c-0.27-0.02-2.49-0.1-2.96-0.09 c-0.44,0-0.68,0.44-0.79,0.92c-0.01,0.05,0.02,0.1,0.07,0.1c0.61,0.04,4.05,0.29,4.52,0.32c0.51,0.03,0.89-0.22,1.08-1.02 c0.18-0.81,1.43-4.67,1.54-5.11c0.12-0.44-0.42-0.32-0.63-0.34c-0.22-0.02-3.98,0.05-4.4,0.07c-0.4,0.02-0.74,0.44-0.84,1.02 C3147.4,544.22,3147.44,544.26,3147.49,544.26z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M3357.92,418.39c0.67,0.93,0.98,1.5,0.98,1.5s-7.68,14.16-14.16,22.95 c-6.48,8.79-40.09,8.79-59.77,9.76s-68.41,0.98-68.41,0.98s-52.85,0.28-62.27-0.31c-9.42-0.59-4.3-4.61-2.44-6.62 c1.86-2.01,6.51-7.1,22.22-24.49c0.4-0.44,0.79-0.86,1.18-1.28l-1.55,0.02c0,0-14.73,16.26-28.21,30.92 c-6.58,7.16-10.01,11.17-11.79,13.4c5.43-3.47,24.18-6.75,78.87-6.75c66.07,0,116.27,6.78,120.49,7.36 c2.37-3.57,8.12-12.34,11.78-18.8c4.7-8.29,16.3-28.69,16.3-28.69L3357.92,418.39z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F1",
    d: "M3417.02,370.07c0.95-0.01,1.5-0.01,1.61-0.01C3418.08,370.05,3417.55,370.06,3417.02,370.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F1",
    d: "M3418.62,370.05c0.01,0,0.01,0,0.02,0C3418.64,370.05,3418.64,370.05,3418.62,370.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M3368.26,402.16c-3.13-1.81-17.76-9.98-30.92-12.22c-14.84-2.51-32.56-2.51-33.39-2.72 c-0.76-0.19-6.62,1.58-7.51,1.85c-0.08,0.02-0.15,0.03-0.23,0.03c-2.89-0.08-58.25-1.57-87.77,2.09 c-0.07,0.01-0.14,0.01-0.22-0.01l-5.76-1.01c-0.07-0.01-0.14-0.01-0.22-0.01c-1.33,0.16-14.53,1.81-18.44,4.6 c-0.9,0.64-1.67,1.44-2.33,2.32c-2.37,3.16-3.32,7.4-3.64,9.2c-0.35,1.94,0.04,4.62,0.17,5.42c0.03,0.16,0,0.32-0.07,0.46 l-3.68,7.61c-0.25,0.51,0.12,1.1,0.68,1.1c0.2,0,0.39-0.09,0.53-0.23c15.08-15.95,27.64-17.34,35.32-17.34 c7.92,0,84.01,0,111.61,0c21.94,0,32.05,10.49,35.28,14.79c0.14,0.19,0.37,0.3,0.61,0.3l2.42-0.04c0.28,0,0.53-0.17,0.66-0.42 l7.21-14.77C3368.73,402.8,3368.6,402.36,3368.26,402.16z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464648",
    d: "M3255.5,442.38c0,0,0.21,0.94,2.66,1.19c1.83,0.19,14.34,0.2,20.3,0.31c2.66-0.46,4.24-1.54,3-2.17 c-1.69-0.86-20.69,0-23.44-1.5s-29.56-2.36-35.47-2.15c-5.91,0.21-10.23,0.93-9.03,5.1c0.04,0.14,0.3-0.2,0.35-0.06 c2.15-0.89,5.58-1.74,14.07-1.74C3240.45,441.37,3255.5,442.38,3255.5,442.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M3224.8,447.84c0.37-0.22,0.61-0.6,0.65-1.03c0.07-0.63,0.52-1.58,2.57-1.79 c6.33-0.64,23.86-0.64,29.56-0.64c2.78,0,13.51-0.64,17.95-0.43c1.2,0.06,2.34-0.03,3.33-0.2c-5.96-0.12-18-0.37-19.83-0.56 c-1.42-0.14-2.02-0.62-2.27-1c-0.22-0.33-0.59-0.53-0.98-0.56c-3.35-0.26-16.62-1.22-27.45-1.22c-6.91,0-11.32,0.32-13.88,0.92 c-0.8,0.19-1.24,1.06-0.93,1.83c0.7,1.75,1.46,3.52,1.82,4.36c0.14,0.33,0.4,0.59,0.73,0.72 C3220.3,449.94,3223.47,448.62,3224.8,447.84z"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#D25959",
    d: "M3223.87,393.13c-0.43,0-0.79-0.34-0.82-0.77c-0.03-0.46,0.31-0.86,0.76-0.89 c0.21-0.02,21.25-1.49,46.74-0.82c0.45,0.01,0.81,0.39,0.8,0.85c-0.01,0.46-0.38,0.83-0.84,0.81 c-25.41-0.67-46.38,0.8-46.59,0.82C3223.9,393.13,3223.89,393.13,3223.87,393.13z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M3366.44,381.11l6.73,2.28c0,0,126.06-25.58,232.16,12.92c0,0-3.44-9.65-30.64-16.49 c-22.65-5.7-75.87-18.96-162.61-9.96C3396.53,371.48,3381.28,374.98,3366.44,381.11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 3366.4417,
    y1: 381.5639,
    x2: 3605.332,
    y2: 381.5639
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9641,
    style: {
      stopColor: "#1C1C1A",
      stopOpacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M3366.44,381.11l6.73,2.28c0,0,126.06-25.58,232.16,12.92c0,0-3.44-9.65-30.64-16.49 c-22.65-5.7-75.87-18.96-162.61-9.96C3396.53,371.48,3381.28,374.98,3366.44,381.11z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M3362.78,516.47c-12.87,5.29-22.7,19.36-22.7,19.36c17.68,1.11,16.11,13.82,15.19,30.33 c-0.12,2.21-0.36,4.86-0.66,7.72l0.46-3.37c0,0,37.92,4.73,40.25,4.73s12.1,3.31,18.38-6.15c3.3-4.97,11.72-19.71,25.5-31.57 c-8.09-2.16-26.4-7.12-39.18-11.15c-10.63-3.35-16.95-9.47-20.16-13.52c-3.08,2.32-6.21,3.62-9.07,3.62 C3369.59,516.47,3366.69,516.47,3362.78,516.47z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#C7C9C6",
    d: "M3678.31,464.83l-0.55,1.28c0,0-14.68-16.59-39.43-40.93c-24.75-24.33-49.37-33.08-88.78-37.95 c-39.42-4.88-99.61-1.35-111.06-0.54c-11.45,0.81-28.23,4.33-30.36,9.48c-2.13,5.15-7.72,20.85-9.32,30.06 c-1.6,9.21,0.8,13,6.92,14.9c6.13,1.9,31.69,11.38,45.01,15.44c13.32,4.06,40.75,11.92,54.6,13.27 c13.85,1.35,63.39,5.42,63.39,5.42s97.74,11.1,105.73,11.38s13.32-4.33,13.32-4.33c1.68-0.43,2.86-1.44,3.8-2.03L3678.31,464.83 z M3673.93,484.39c-9.15-0.62-88.55-9.76-99.94-10.79c-11.38-1.03-64.63-6.2-72.56-7.44c-7.93-1.24-37.6-7.85-48.58-11.57 c-10.98-3.72-35.36-12.4-41.06-14.47c-5.69-2.07-5.08-9.51-4.06-14.05c1.02-4.55,4.88-19.43,4.88-19.43 c1.63-4.75,4.27-10.75,18.29-13.43c14.02-2.69,55.49-6.82,117.07-2.27c61.58,4.55,84.35,30.18,105.48,51.88 c21.14,21.7,31.12,36.42,31.12,36.42S3683.08,485.01,3673.93,484.39z"
  })), /*#__PURE__*/React.createElement("g", null, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M3430.91,393.2c-14.02,2.69-16.67,8.68-18.29,13.43c0,0-3.86,14.88-4.88,19.43 c-1.02,4.55-1.63,11.99,4.06,14.05c5.69,2.07,30.08,10.75,41.06,14.47c4.56,1.55,12.35,3.59,20.47,5.54 c-0.78-14.14-3.14-48.13-8.8-70.44C3448.47,390.57,3437.06,392.03,3430.91,393.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 3414.1663,
    y1: 447.3278,
    x2: 3476.9019,
    y2: 411.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M3430.91,393.2c-14.02,2.69-16.67,8.68-18.29,13.43c0,0-3.86,14.88-4.88,19.43 c-1.02,4.55-1.63,11.99,4.06,14.05c5.69,2.07,30.08,10.75,41.06,14.47c4.56,1.55,12.35,3.59,20.47,5.54 c-0.78-14.14-3.14-48.13-8.8-70.44C3448.47,390.57,3437.06,392.03,3430.91,393.2z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    fill: "#A1C8D9",
    d: "M3653.47,442.81c-21.14-21.7-43.9-47.33-105.48-51.88c-3.26-0.24-6.47-0.46-9.62-0.65 l34.89,83.26c0.27,0.02,0.52,0.05,0.75,0.07c11.38,1.03,90.79,10.17,99.94,10.79c9.15,0.62,10.65-6.06,10.65-6.06 S3674.6,464.51,3653.47,442.81z"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M3464.54,389.69c0,0,7.03,43.54,7.32,69.96l1.48,0.49c0,0,1.78-24.42-6.97-70.55L3464.54,389.69z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M3538.36,390.28l34.89,83.26l25.01,2.72l-40.81-84.19C3557.44,392.07,3549.9,390.83,3538.36,390.28z"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "3543.43,390.62 3581.13,474.29 3598.26,476.26 3557.44,392.07  "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M3659.06,448.68l14.88,35.71c0,0,5.43,0.82,9.05-2.66C3686.6,478.26,3674.75,465.45,3659.06,448.68z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#77514D",
    d: "M3301.17,606.96l11.87,6.86c0.58,0.33,1.24,0.49,1.9,0.45c4.5-0.25,22.72-1.25,28.63-1.25 c6.77,0,6.78-8.11,6.78-8.11S3321.48,606.63,3301.17,606.96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 3301.1733,
    y1: 609.6033,
    x2: 3350.356,
    y2: 609.6033
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.0763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.1498
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.2
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_9_)",
    d: "M3301.17,606.96l11.87,6.86c0.58,0.33,1.24,0.49,1.9,0.45c4.5-0.25,22.72-1.25,28.63-1.25 c6.77,0,6.78-8.11,6.78-8.11S3321.48,606.63,3301.17,606.96"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3773.78,529.23c-37.04-7.3-49.51,78.03-49.51,78.03c-54.16,1.53-191.03,6.87-192.37,8.05 c-0.01,0.03-0.01,0.04-0.01,0.02c0-0.01,0-0.01,0.01-0.02c0.36-1.6,9.53-73.16-44.61-80.7c-55.18-7.69-77.38,77.5-77.38,77.5 l-59.55-7.19c0,0-1.62,11.55-2.66,18.9c-0.45,3.18,0.94,7.97,4.18,9.32c14.74,6.16,57.47,22.13,57.47,22.13 s6.48-38.02,15-61.58c8.52-23.56,24.84-46.73,46.85-48.84c20.1-1.93,58.35,0.93,55.43,59.94c-0.52,10.55-1.6,33.86-2.4,38.46 c-0.8,4.6-4.26,8.13-4.26,8.13s161.13-17.88,201.08-18.69c0,0,1.33-0.27,2.93-3.25c1.6-2.98,5.86-32.5,10.65-50.38 s15.18-46.86,39.95-41.71c24.77,5.15,23.44,40.63,20.77,62.84l-1.86,7.85l-0.27,7.85c0,0,7.27-3.54,7.76-15.18l-3.78,0.38 C3797.21,601.11,3810.82,536.54,3773.78,529.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M3773.4,520.78c-35.61-5.85-45.3,52.04-53.01,63.9c-2.66,4.09-2.93,5.38-10.28,5.03 c-6.87-0.33-18.19-0.2-18.19-0.2c-4.55,0-143.7-4.5-149.13-5.23c-5.44-0.74-4.63-1.42-5.56-7.57 c-0.93-6.15-2.09-47.79-47.23-54.89c-45.14-7.1-70.03,37.86-76.31,47.32c-6.28,9.46-16.05,6.15-18.38,6.15 c-2.33,0-40.25-4.73-40.25-4.73l-4.7,34.37l59.55,7.19c0,0,22.2-85.18,77.38-77.5c54.14,7.54,44.97,79.09,44.61,80.7 c1.34-1.19,138.21-6.52,192.37-8.05c0,0,12.47-85.33,49.51-78.03c37.04,7.3,23.43,71.88,23.43,71.88l3.78-0.38 C3800.99,600.72,3811.18,526.99,3773.4,520.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M3531.88,615.33c0,0.02,0,0.01,0.01-0.02C3531.89,615.32,3531.88,615.32,3531.88,615.33z"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M3574.14,631.98l6.71,0.13c0.57,0.01,0.93,0.65,0.64,1.15l-0.4,0.71c-0.3,0.53,0.1,1.19,0.7,1.15 l11.61-0.71c0.11-0.01,0.23-0.04,0.33-0.1l5.55-3.2c0.12-0.07,0.25-0.1,0.39-0.1l5.57,0.13c0.59,0.01,0.94,0.69,0.61,1.19 l-0.02,0.04c-0.34,0.52,0.03,1.21,0.64,1.19l12.01-0.28c0.14,0,0.27-0.04,0.38-0.12l5.99-3.81c0.12-0.08,0.27-0.12,0.41-0.12 l6.1,0.12c0.64,0.01,0.97,0.78,0.55,1.27l0,0c-0.44,0.51-0.06,1.3,0.6,1.27l9.22-0.4c0.1,0,0.2-0.03,0.28-0.07l6.25-2.95 c0.09-0.04,0.18-0.06,0.27-0.07l6.4-0.38c0.66-0.04,1.04,0.74,0.63,1.25l-0.05,0.06c-0.42,0.51-0.04,1.28,0.62,1.25l8.61-0.4 c0.12-0.01,0.24-0.04,0.34-0.1l6.03-3.53c0.11-0.06,0.23-0.1,0.36-0.1l6.38-0.13c0.6-0.01,0.97,0.65,0.66,1.17l-0.29,0.48 c-0.32,0.53,0.08,1.2,0.68,1.17l8.24-0.41c0.13-0.01,0.25-0.04,0.36-0.11l6.17-3.83c0.12-0.07,0.25-0.11,0.39-0.11h5.16 c0.61,0,0.97,0.7,0.62,1.21c-0.69,1-1.51,2.22-1.22,2.03c0.41-0.28,4.41-0.32,5.57-0.32c0.2,0,0.39-0.08,0.53-0.23l5.27-5.49 c0.48-0.5,0.11-1.33-0.57-1.3c-16.14,0.78-129.05,6.26-133.48,6.86c-4.77,0.65-12.08-3.07-18.75-2.1 c-6.67,0.97-3.81,4.52-2.54,5.66s5.88,4.36,7.15,5.17c1.27,0.81,4.93,0.48,7.63-1.62c2.3-1.79,4.02-2.4,4.48-2.55 C3573.98,631.99,3574.06,631.98,3574.14,631.98z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M3574.41,630.96c-4.05,1.76-4.14,3.95-8.55,1.84c-4.4-2.11-2.91-1.27-4.4-2.11 c-1.49-0.83-2.77-3.18,2.66-3.3c5.43-0.12,118.25-5.15,143.27-6.81l-4.17,3.01c0,0-36.44,2.34-76.14,4.18 S3576.85,629.9,3574.41,630.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 3560.1704,
    y1: 627.1301,
    x2: 3707.3967,
    y2: 627.1301
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3466,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5959,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.2289
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.4494
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.6
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_)",
    d: "M3574.41,630.96c-4.05,1.76-4.14,3.95-8.55,1.84c-4.4-2.11-2.91-1.27-4.4-2.11 c-1.49-0.83-2.77-3.18,2.66-3.3c5.43-0.12,118.25-5.15,143.27-6.81l-4.17,3.01c0,0-36.44,2.34-76.14,4.18 S3576.85,629.9,3574.41,630.96z"
  })), /*#__PURE__*/React.createElement("g", null, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M3270.9,636.5c0.78,0.12,0,3.48,0,3.48l-20.82-3.75l-3.43-22.25 C3246.65,613.98,3248.5,633.01,3270.9,636.5z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M3246.65,613.98l33.21,1.88c0,0,23.72,14.21,26.62,16.62c2.9,2.41,2.64,8.31,2.64,8.31l-38.22-0.8 v-3.48c0,0-5.54-1.07-11.6-3.48C3253.24,630.6,3247.18,620.42,3246.65,613.98z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 3277.8909,
    y1: 613.983,
    x2: 3277.8909,
    y2: 640.7879
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1917,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.8
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M3246.65,613.98l33.21,1.88c0,0,23.72,14.21,26.62,16.62c2.9,2.41,2.64,8.31,2.64,8.31 l-38.22-0.8v-3.48c0,0-5.81-0.76-11.57-3.82C3252.51,629.06,3247.18,620.42,3246.65,613.98z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M3325.73,642.4l-16.61-1.61c0,0,0.91-5.82-3.44-8.47c-4.35-2.65-25.82-16.46-25.82-16.46l2-3 c0,0,21.39,14.68,25.39,17.51c4,2.83,4.7,8.49,4.7,8.49l13.74,2.48L3325.73,642.4z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M3246.38,612.16l0.27,1.83l3.43,22.25l-2.65-0.02C3247.43,636.21,3243.78,612.69,3246.38,612.16z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M3246.38,612.16c0,0,27.65,0.18,35.48,0.71l-2,3l-33.21-1.88L3246.38,612.16z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M3281.86,612.86l43.82,28.47l-14.61-2.12c0,0-0.52-4.95-2.96-7.25s-27.13-17.51-27.13-17.51 L3281.86,612.86z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 3280.991,
    y1: 627.0989,
    x2: 3325.6833,
    y2: 627.0989
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_12_)",
    d: "M3281.86,612.86l43.82,28.47l-14.61-2.12c0,0-0.52-4.95-2.96-7.25s-27.13-17.51-27.13-17.51 L3281.86,612.86z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M3118.32,626.63l-1.43-6.12c0,0,5.08-11.92,6.37-14.4c0.4-0.77,0.37-1.48,0.37-1.48 s-2.09,1.65-3.87,4.95c-2.58,4.81-3.87,8.01-4.01,9.9c-0.14,1.89,1.15,6.85,1.15,6.85L3118.32,626.63z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M3123.62,604.63c0,0,19.76,0.73,22.92,1.6c3.15,0.87,3.58,2.04,4.58,7.57c1,5.53,2.29,10.05,2.29,10.05 l6.02,6.7l-9.6-0.87l-0.43-1.6l-8.88-0.44l-0.29,1.89l-21.91-2.91l-1.43-6.12L3123.62,604.63z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M3123.62,604.63c0,0-3.01,6.41-3.87,9.76s1.29,3.06,3.87,3.5s6.59,7.14,16.9,9.76l8.88,0.44 c0,0-2.72-15-3.01-17.33c-0.29-2.33-0.86-4.37,0.14-4.52C3146.53,606.23,3130.06,604.78,3123.62,604.63z"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M3149.83,629.68h1.86c0,0-3.29-18.93-3.87-20.97c-0.57-2.04-2.15-1.75-1.72,0.44 S3149.83,629.68,3149.83,629.68z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3474.71,577.55c0.91,1.32,4.01,5.83,4.01,5.83l7.35-0.13l3.37-5.29 C3489.44,577.96,3484.78,575.05,3474.71,577.55z"
  })), /*#__PURE__*/React.createElement("g", null, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M3767.62,544.57c9.89,0,27.83,14.63,25.87,62.97c-1.81,44.73-21.31,57.55-29.93,57.55 c-7.29,0-45.34,8.46-54.44-32.33c0,0,15.17,3.77,18.2-15.77C3729.57,602.46,3733.71,544.57,3767.62,544.57z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3737.47,610.39c-0.67-11-2.03-20.78-3.75-28.71c0,0,9.88-40.32,34.59-34.95 c28.48,6.19,25.61,66.14,23.95,75.43c-2.11,11.76-7.66,40.4-27.97,42.7C3743.99,667.15,3738.24,622.92,3737.47,610.39z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0174 -0.9998 0.9998 0.0174 3096.2024 4359.0034)",
    fill: "#FFFFFF",
    cx: 3765.81,
    cy: 604.26,
    rx: 49.61,
    ry: 23.47
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#191C1C",
    points: "3771.7,558.1 3773.93,576.77 3785.25,579.79 3787.69,599.86 3779,611.7 3782,634.39 3777.03,636.49 3773.65,646.88 3766.43,633.98 3756.4,647.41 3753.67,636.36 3748.54,634.75 3753.01,611.7 3743.8,600.22 3747.76,590.54 3747.32,578.71 3758.08,577.64 3761.82,557.73 3766.24,560.36  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 3765.051,
    y1: 648.1934,
    x2: 3766.3704,
    y2: 556.3474
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6968,
    style: {
      stopColor: "#FCFCFC",
      stopOpacity: 0.8265
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7171,
    style: {
      stopColor: "#F3F3F3",
      stopOpacity: 0.7017
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    style: {
      stopColor: "#E3E3E3",
      stopOpacity: 0.5921
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7515,
    style: {
      stopColor: "#CDCDCD",
      stopOpacity: 0.4913
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7669,
    style: {
      stopColor: "#B0B0B0",
      stopOpacity: 0.3965
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7817,
    style: {
      stopColor: "#8D8D8D",
      stopOpacity: 0.3061
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7959,
    style: {
      stopColor: "#636363",
      stopOpacity: 0.2192
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8093,
    style: {
      stopColor: "#343433",
      stopOpacity: 0.1372
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8153,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_13_)",
    strokeMiterlimit: 10,
    d: "M3761.82,557.73l-4.33,16.27l-10.16,4.7 c0,0-3.12,13.2-3.52,21.51l6.5,14.46l-1.76,20.07c0,0,2.84,8.5,7.86,12.66l9.08-8.14l8.13,8.14c0,0,5.82-6.69,8.4-13.02 l-0.54-19.53l6.23-15.01c0,0,0-11.03-2.44-20.07l-9.08-3.98l-4.47-17.72C3771.7,558.1,3768.45,555.57,3761.82,557.73z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "3771.7,558.1 3769.94,583.95 3772.92,588.11 3785.25,579.79 3776.17,575.81  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "3761.82,557.73 3760.33,583.05 3757.48,587.75 3747.32,578.71 3757.48,574.01  "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3747.32,578.71l2.44,7.96l-2.3,11.57l-3.66,1.99C3743.8,600.22,3744.48,588.29,3747.32,578.71z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3785.25,579.79l-2.98,7.05l1.35,10.85l4.06,2.17C3787.69,599.86,3787.69,589.19,3785.25,579.79z"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "3787.69,599.86 3775.5,607.45 3774.14,614.69 3782,634.39 3781.46,614.87  "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3782,634.39l-4.06-3.44l-4.2,6.51l-0.14,9.94C3773.6,647.41,3780.24,640.18,3782,634.39z"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "3773.6,647.41 3765.88,626.26 3762.9,625.35 3756.4,647.41 3765.47,639.27  "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3756.4,647.41l1.08-9.22c0,0-5.01-7.23-5.15-6.69c-0.14,0.54-3.79,3.25-3.79,3.25 S3752.2,644.15,3756.4,647.41z"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "3748.54,634.75 3755.04,613.6 3754.23,606.73 3743.8,600.22 3750.3,614.69  "
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 3776.17,
    y1: 575.81,
    x2: 3779.83,
    y2: 566.05
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 3781.46,
    y1: 614.87,
    x2: 3787.01,
    y2: 618.66
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 3765.47,
    y1: 639.27,
    x2: 3765.47,
    y2: 651.75
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 3750.3,
    y1: 614.69,
    x2: 3744.61,
    y2: 618.3
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5E5D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 3757.48,
    y1: 574.01,
    x2: 3753.28,
    y2: 565.87
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 3761.86,
    cy: 603.74,
    rx: 2.21,
    ry: 4.98
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#1EBEE4",
    cx: 3761.86,
    cy: 603.74,
    rx: 1.44,
    ry: 3.25
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 3111.5854,
    y1: 571.5052,
    x2: 3355.7488,
    y2: 571.5052
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0648,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8896,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.185
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9911,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0242
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_14_)",
    d: "M3340.06,535.88c0,0-1.47,9.03-2.91,20.29c-1.15,9-1.93,17.15-7.95,19.11 c-6.02,1.96-30.11,6.86-39.26,7.1c-6.79,0.18-79.92-2.6-123.97-4.05c-15.31-0.5-27.1-0.85-31.39-0.85 c-16.62,0-18.31-5.63-19.75-11.02c-1.16-4.33-2.32-10.07-2.73-12.17c0,5.81,0,11.3,0,13.06c0,3.99-0.51,11.31-0.51,14.91 c0,3.6,0.79,11.38,0.79,11.38s1.4,3.25,12.82,4.36c4.47,0.43,28.45,1.92,56.95,3.58c44.37,2.58,99.7,5.55,109.47,5.55 c16.04,0,58.74-2.21,58.74-2.21s4.2-26.26,4.89-38.71C3356.17,549.7,3357.74,536.98,3340.06,535.88z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 3226.6511,
    y1: 484.4204,
    x2: 3226.6511,
    y2: 569.9468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0425
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#0C0C0C",
      stopOpacity: 0.073
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9984,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.0998
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_15_)",
    d: "M3133.08,551.8c2.38,4.44,3.57,11.9,15.08,12.71c11.14,0.78,130.83,5.15,150.89,5.43 c9.22-8.31,12-24.69,13.78-33.33c2.45-11.89,6-20.09,6-20.09l4.79-0.01l0.2-0.47l-3.7-31.62c0,0-44.05,1.88-60.34,1.88 c-16.29,0-90.64-1.28-90.64-1.28L3158.09,499c0,0-19.11,3.81-18.71,3.81s-9.89,9.64-9.89,9.64l0.18,24.09 C3130.09,541.77,3131.23,548.36,3133.08,551.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 3112.0911,
    y1: 547.3602,
    x2: 3363.6804,
    y2: 547.3602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.0763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.1498
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.2
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_16_)",
    d: "M3323.61,516.51l-4.84,0.01c0,0-3.49,8.2-5.94,20.09c-1.78,8.64-4.56,25.02-13.78,33.33 c-0.8,0.72-1.65,1.37-2.54,1.96c-3,1.97-6.58,3.15-10.87,3.15c-20.39,0-145.21-5.81-151.74-6.64s-8.16-4.7-8.7-17.15 c-0.54-12.44-0.73-19.54-0.73-21.61c0-2.07,5.02-17.22,5.02-17.22l-7.29-0.11c0,0-6.7,14.01-8.09,17.23s-2.02,5.53-2.02,8.1 c0,1.44,0,9.29,0,16.63c0.41,2.1,1.57,7.84,2.73,12.17c1.45,5.39,3.13,11.02,19.75,11.02s146.21,5.14,155.36,4.9 c9.15-0.24,33.24-5.14,39.26-7.1c6.02-1.96,6.79-10.11,7.95-19.11c1.45-11.27,2.91-20.29,2.91-20.29s10.3-14.75,23.62-19.72 L3323.61,516.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 3121.2778,
    y1: 493.861,
    x2: 3154.0449,
    y2: 493.861
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_17_)",
    d: "M3122.05,502.66l8.29,0.59c0.29,0.02,0.58-0.07,0.82-0.25l8.85-6.82 c0.18-0.14,0.4-0.23,0.63-0.25l10.69-0.9c0.47-0.04,0.87-0.35,1.04-0.8l1.59-4.32c0.27-0.74-0.2-1.55-0.98-1.66l-27.72-3.8 c0.18,0.12,0.28,0.32,0.28,0.55l-0.34,13.19c0,0.16-0.07,0.32-0.18,0.44l-3.56,3.62c-0.11,0.11-0.17,0.26-0.18,0.41l-0.01,0.19 C3121.5,502.72,3121.76,502.64,3122.05,502.66z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 3120.9548,
    y1: 491.5748,
    x2: 3172.373,
    y2: 491.5748
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_18_)",
    d: "M3171.76,485.06l-9.71-0.32c-0.06,0-0.12-0.01-0.17-0.03l-29.66-9.58 c-0.26-0.08-0.44-0.33-0.44-0.61v-3.06c0-0.65-0.83-0.89-1.17-0.34l-2.85,4.66c-0.05,0.08-0.11,0.14-0.19,0.19l-2.87,1.95 c0,0-0.01,0.01-0.01,0.01c0.04,0.01,0.08,0.01,0.12,0.02l32.78,7.78c0.71,0.17,1.12,0.94,0.86,1.64l-3.75,10.16 c-0.18,0.48-0.63,0.8-1.14,0.8h-11.04c-0.3,0-0.58,0.11-0.8,0.31l-9.7,8.68c-0.22,0.2-0.51,0.31-0.8,0.31h-9.13 c-0.46,0-0.86-0.26-1.06-0.64l-0.08,1.3c0,0.08,0.01,0.16,0.03,0.24l1.08,3.38c0.08,0.26,0.33,0.44,0.6,0.44h13.03 c0.11,0,0.21-0.03,0.31-0.08l13.58-7.76c0.08-0.05,0.17-0.07,0.26-0.08l9.16-0.69c0.18-0.01,0.35-0.11,0.46-0.26l12.78-17.38 C3172.55,485.67,3172.27,485.08,3171.76,485.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 3121.0332,
    y1: 492.7729,
    x2: 3158.5327,
    y2: 492.7729
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_19_)",
    d: "M3122.1,507.62h9.13c0.3,0,0.58-0.11,0.8-0.31l9.7-8.68c0.22-0.2,0.51-0.31,0.8-0.31h11.04 c0.51,0,0.96-0.32,1.14-0.8l3.75-10.16c0.26-0.7-0.15-1.47-0.86-1.64l-32.78-7.78c-0.04-0.01-0.08-0.01-0.12-0.02 c-0.13,0.09-0.22,0.23-0.25,0.38l-1.07,4.81c-0.07,0.31,0.1,0.63,0.39,0.74l1.38,0.54c0.04,0.02,0.09,0.04,0.12,0.07l27.72,3.8 c0.77,0.11,1.25,0.92,0.98,1.66l-1.59,4.32c-0.17,0.45-0.57,0.76-1.04,0.8l-10.69,0.9c-0.23,0.02-0.45,0.1-0.63,0.25l-8.85,6.82 c-0.23,0.18-0.53,0.27-0.82,0.25l-8.29-0.59c-0.29-0.02-0.55,0.06-0.77,0.22l-0.24,4.1 C3121.24,507.36,3121.64,507.62,3122.1,507.62z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 3124.4722,
    y1: 543.7498,
    x2: 3299.0479,
    y2: 543.7498
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.0763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.1498
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.2
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_20_)",
    d: "M3148.15,564.51c-11.51-0.81-12.7-8.27-15.08-12.71c-1.85-3.44-2.98-10.04-3.4-15.27 c-0.12-1.52-0.18-2.92-0.18-4.09c0-5.25,0-19.99,0-19.99s-5.02,15.14-5.02,17.22c0,2.07,0.18,9.17,0.73,21.61 c0.54,12.44,2.18,16.32,8.7,17.15s131.34,6.64,151.74,6.64c4.29,0,7.87-1.18,10.87-3.15c0.9-0.59,1.75-1.24,2.54-1.96 C3278.98,569.67,3159.29,565.3,3148.15,564.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 3263.7178,
    y1: 491.1974,
    x2: 3398.1489,
    y2: 491.1974
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1719,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2965,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.185
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4706,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0242
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4968,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_21_)",
    d: "M3393,477.58c-10.91-7.13-30.05-11.54-59.68-11.7c-1.05-0.01-2.07,0.37-2.89,1.05 c-2.03,1.71-6.04,5.2-8.61,8.17c-0.71,0.82-1.69,1.36-2.76,1.51c-7.51,1.03-37.51,4.99-51.22,8.56 c-0.44,0.12-0.87,0.24-1.28,0.38c-2.23,0.75-3.66,1.89-2.34,4.08l8.59,13.73c0.83,1.38,2.31,2.2,3.89,2.18 c1.03-0.02,2.29-0.01,3.62,0.05c0.69,0.03,1.4,0.08,2.1,0.15c0.89,0.03,1.53,0.12,1.96,0.25c1.18,0.2,2.25,0.47,3.09,0.85 c3.97,1.82,14.28,9.68,23.01,9.68s54.35,0,60.31,0s13.09-5.65,18.45-14.32C3394.58,493.52,3404.11,484.84,3393,477.58z  M3384.61,484.94c-50.44-3.39-101.08,3.6-109.48,4.84c-0.61,0.09-0.98,0.75-0.74,1.33l1.43,3.42c0.15,0.37,0.52,0.6,0.91,0.58 c1.79-0.08,6.87-0.32,10.71-0.45c4.73-0.16,6.63,0.32,11.84,1.93c5.21,1.6,9.78,4.01,19.1,4.33c8.51,0.29,50.53-1.02,57.67-1.25 c-4.67,6.2-11.17,12.31-16.01,12.31c-3.81,0-39.94,0-45.73,0c-5.79,0-17.84-8.37-21.95-9.77c-3.39-1.15-14-1.56-17.65-1.67 c-0.78-0.02-1.48-0.46-1.86-1.15l-5.18-9.53c-0.7-1.29-0.01-2.91,1.4-3.26c5.62-1.4,19.86-4.57,43.57-7.48 c31.55-3.88,63.57-2.02,69.21,1.24C3384.19,481.7,3384.9,483.16,3384.61,484.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 3267.3926,
    y1: 494.4557,
    x2: 3384.6716,
    y2: 494.4557
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1719,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2963,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.185
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4703,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0242
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4964,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5444,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_22_)",
    d: "M3381.84,480.35c-5.64-3.26-37.65-5.12-69.21-1.24c-23.71,2.91-37.95,6.09-43.57,7.48 c-1.41,0.35-2.1,1.97-1.4,3.26l5.18,9.53c0.38,0.69,1.08,1.13,1.86,1.15c3.65,0.11,14.26,0.52,17.65,1.67 c4.12,1.4,16.16,9.77,21.95,9.77c5.79,0,41.92,0,45.73,0c4.84,0,11.34-6.1,16.01-12.31c-7.15,0.23-49.16,1.54-57.67,1.25 c-9.31-0.32-13.89-2.73-19.1-4.33c-5.21-1.6-7.1-2.09-11.84-1.93c-3.84,0.13-8.92,0.37-10.71,0.45 c-0.4,0.02-0.76-0.21-0.91-0.58l-1.43-3.42c-0.24-0.58,0.12-1.24,0.74-1.33c8.4-1.24,59.04-8.23,109.48-4.84 C3384.9,483.16,3384.19,481.7,3381.84,480.35z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 3219.7671,
    y1: 484.8323,
    x2: 3219.7671,
    y2: 530.7999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6474,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7973,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0425
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9049,
    style: {
      stopColor: "#0C0C0C",
      stopOpacity: 0.073
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.0998
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_23_)",
    d: "M3283.97,505.77c-0.63-0.11-1.29-0.19-1.96-0.25c-0.3-0.01-0.63-0.02-0.98-0.02 c-0.37,0-0.75-0.04-1.11-0.13c-1.32-0.06-2.58-0.06-3.62-0.05c-1.59,0.02-3.07-0.8-3.89-2.18l-8.59-13.73 c-1.32-2.2,0.11-3.33,2.34-4.08c-0.11-0.32-0.17-0.5-0.17-0.5h-93.43l-0.36,0.42c0.2,0.21,0.26,0.56,0.06,0.83l-12.78,17.38 c-0.11,0.15-0.28,0.24-0.46,0.26l-1,0.08l-2.54,0.33c0,0-6.02,26.59,19.12,26.59c16.67,0,68.7,0.08,77.64,0.08 s20.73-9.18,25.2-15.79C3281.12,509.55,3286.71,506.62,3283.97,505.77z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 3131.7295,
    y1: 472.8504,
    x2: 3333.3162,
    y2: 472.8504
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4317,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.1526
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6631,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.2996
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8212,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.4
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_24_)",
    d: "M3266.57,485.55c0.4-0.14,0.83-0.26,1.28-0.38c13.71-3.57,43.7-7.53,51.22-8.56 c1.07-0.15,2.05-0.68,2.76-1.51c2.57-2.97,6.58-6.46,8.61-8.17c0.81-0.68,1.83-1.05,2.89-1.05c0,0-51.72-7.41-120.78-7.41 s-80.81,5.23-80.81,9.47c0,1.23,0,2.32,0,3.26c0.03,0.08,0.05,0.16,0.05,0.25v3.06c0,0.28,0.18,0.53,0.44,0.61l29.66,9.58 c0.06,0.02,0.11,0.03,0.17,0.03l9.71,0.32c0.18,0.01,0.32,0.08,0.43,0.19c0.2,0.21,0.26,0.56,0.06,0.83l-0.83,1.13l92.77-0.32 C3264.68,486.32,3265.54,485.89,3266.57,485.55z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 3181.4668,
    y1: 386.6141,
    x2: 3417.0156,
    y2: 386.6141
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6704,
    style: {
      stopColor: "#020202",
      stopOpacity: 0.1742
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8349,
    style: {
      stopColor: "#090908",
      stopOpacity: 0.237
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9517,
    style: {
      stopColor: "#141414",
      stopOpacity: 0.2816
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_25_)",
    d: "M3367.79,380.83c0,0,20.81-10.37,49.22-10.76c-11.25,0.1-78.58,0.85-129.1,5.37 c-55.3,4.96-93.23,12.07-99.58,14.87c-5.02,2.21-6.47,5.5-6.86,6.78c0.66-0.88,1.43-1.68,2.33-2.32 c3.91-2.79,17.11-4.44,18.44-4.6c0.07-0.01,0.14-0.01,0.22,0.01l5.76,1.01c0.07,0.01,0.14,0.01,0.22,0.01 c29.53-3.66,84.88-2.17,87.77-2.09c0.08,0,0.16-0.01,0.23-0.03c0.89-0.27,6.75-2.05,7.51-1.85c0.82,0.21,18.55,0.21,33.39,2.72 c13.16,2.23,27.79,10.4,30.92,12.22c0.34,0.2,0.47,0.64,0.3,1C3368.55,403.16,3383.53,380.56,3367.79,380.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 3133.6985,
    y1: 442.0927,
    x2: 3361.1414,
    y2: 442.0927
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.0617
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.008066498
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2198,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.256,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8928,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_26_)",
    d: "M3357.92,418.39c0.67,0.93,0.98,1.5,0.98,1.5s-7.68,14.16-14.16,22.95 c-6.48,8.79-40.09,8.79-59.77,9.76s-68.41,0.98-68.41,0.98s-52.85,0.28-62.27-0.31c-9.42-0.59-4.3-4.61-2.44-6.62 c1.86-2.01,6.51-7.1,22.22-24.49c0.4-0.44,0.79-0.86,1.18-1.28l-1.55,0.02c0,0-14.73,16.26-28.21,30.92 c-6.58,7.16-10.01,11.17-11.79,13.4c5.43-3.47,24.18-6.75,78.87-6.75c66.07,0,116.27,6.78,120.49,7.36 c2.37-3.57,8.12-12.34,11.78-18.8c4.7-8.29,16.3-28.69,16.3-28.69L3357.92,418.39z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 3350.356,
    y1: 567.8526,
    x2: 3802.2422,
    y2: 567.8526
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A1C1D",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2017,
    style: {
      stopColor: "#161819",
      stopOpacity: 0.0631
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4078,
    style: {
      stopColor: "#0B0C0D",
      stopOpacity: 0.0253
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5458,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6405,
    style: {
      stopColor: "#0A0A09",
      stopOpacity: 0.0208
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8316,
    style: {
      stopColor: "#171716",
      stopOpacity: 0.0629
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_27_)",
    d: "M3350.36,604.92l59.55,7.19c0,0,22.2-85.18,77.38-77.5s44.6,81.87,44.6,80.72 s137.95-6.53,192.38-8.07c0,0,12.47-85.33,49.51-78.03s23.43,71.88,23.43,71.88l3.78-0.38c0,0,10.19-73.73-27.59-79.95 c-35.61-5.85-45.3,52.04-53.01,63.9c-2.66,4.09-2.93,5.38-10.28,5.03c-6.87-0.33-18.19-0.2-18.19-0.2 c-4.55,0-143.7-4.5-149.13-5.23c-5.44-0.74-4.63-1.42-5.56-7.57c-0.93-6.15-2.09-47.79-47.23-54.89s-70.03,37.86-76.31,47.32 s-16.05,6.15-18.38,6.15s-40.25-4.73-40.25-4.73L3350.36,604.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 3631.8523,
    y1: 526.229,
    x2: 3631.8523,
    y2: 578.7313
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001784581,
    style: {
      stopColor: "#F6F6F6",
      stopOpacity: 0.9026
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1228,
    style: {
      stopColor: "#F2F2F2",
      stopOpacity: 0.8041
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2576,
    style: {
      stopColor: "#E4E4E4",
      stopOpacity: 0.696
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    style: {
      stopColor: "#CFCFCE",
      stopOpacity: 0.5832
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5424,
    style: {
      stopColor: "#B0B0B0",
      stopOpacity: 0.4673
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6899,
    style: {
      stopColor: "#888888",
      stopOpacity: 0.3489
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8399,
    style: {
      stopColor: "#585858",
      stopOpacity: 0.2285
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9894,
    style: {
      stopColor: "#20201F",
      stopOpacity: 0.1085
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_28_)",
    d: "M3541.52,578.73c0,0,17.39-10.17,75.61-10.95c58.22-0.78,108.1,4.61,108.1,4.61l16.38-36.16 c0,0-154.72-8.34-181.94-9.13c-8.44-0.24-42.19-2.88-37.05,2.35C3546.05,553.3,3541.52,578.73,3541.52,578.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 3423.3787,
    y1: 476.2133,
    x2: 3408.0295,
    y2: 502.7987
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_29_)",
    d: "M3397.31,482.06c0,0,20.07,0.96,39.54,1.93l1.77,5.16c-5.01,0.43-10.43,0.6-14.3,1.09 c-15.08,1.89-28.97,4.47-30.02,4.63C3393.89,494.92,3400.26,487.29,3397.31,482.06"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 3502.4167,
    y1: 494.3567,
    x2: 3523.3933,
    y2: 494.3567
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    style: {
      stopColor: "#BABABA",
      stopOpacity: 0.7399
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7814,
    style: {
      stopColor: "#494948",
      stopOpacity: 0.2968
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_30_)",
    d: "M3516.36,491.13l7.03-0.43c0,0-2.2,5.76-7.66,6.84c-5.32,1.05-8.77,0.34-13.32-2.42 c0,0,0.22-0.1,0.91-0.8c0.69-0.7,0,0,0,0s1.37,1.46,5.38,1.4C3512.92,495.67,3516.36,494.64,3516.36,491.13L3516.36,491.13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 3495.0674,
    y1: 483.7653,
    x2: 3520.1951,
    y2: 483.7653
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    style: {
      stopColor: "#BABABA",
      stopOpacity: 0.7399
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7814,
    style: {
      stopColor: "#494948",
      stopOpacity: 0.2968
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_31_)",
    d: "M3520.04,486.15c0,0-22.8-5.16-23.52,0l-1.4-0.14c0,0-0.86-4.24,4.99-4.61 S3521.94,485.55,3520.04,486.15z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 3496.3694,
    y1: 491.1833,
    x2: 3523.3933,
    y2: 491.1833
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0795,
    style: {
      stopColor: "#222222",
      stopOpacity: 0.1786
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1909,
    style: {
      stopColor: "#353534",
      stopOpacity: 0.2887
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3212,
    style: {
      stopColor: "#525252",
      stopOpacity: 0.4174
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4658,
    style: {
      stopColor: "#7C7C7B",
      stopOpacity: 0.5603
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6222,
    style: {
      stopColor: "#B1B1B1",
      stopOpacity: 0.7148
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7862,
    style: {
      stopColor: "#F1F1F1",
      stopOpacity: 0.8769
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7903,
    style: {
      stopColor: "#F3F3F3",
      stopOpacity: 0.881
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8928,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_32_)",
    d: "M3498.83,487.24c0,0,3.4,3.27,10.39,3.46s14.17,0,14.17,0s-13.61,0.58-16.82,1.73 s-4.16,2.69-4.16,2.69s-4.91-3.07-6.05-7.5L3498.83,487.24z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 3662.7961,
    y1: 554.1584,
    x2: 3601.3496,
    y2: 447.7299
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0127,
    style: {
      stopColor: "#1A1C1D",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2536,
    style: {
      stopColor: "#818283",
      stopOpacity: 0.4996
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5553,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6818,
    style: {
      stopColor: "#B7B7B6",
      stopOpacity: 0.7439
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#646463",
      stopOpacity: 0.4305
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9465,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.2083
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_33_)",
    d: "M3527.38,490.44l209.38,21.02c0,0-16.32,5.53-48.4,3.32s-104.96-8.85-120.19-11.06 C3552.94,501.5,3527.38,490.44,3527.38,490.44z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 3618.6387,
    y1: 505.9551,
    x2: 3635.5237,
    y2: 505.9551
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    style: {
      stopColor: "#BABABA",
      stopOpacity: 0.7399
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7814,
    style: {
      stopColor: "#494948",
      stopOpacity: 0.2968
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_34_)",
    d: "M3629.87,502.23l5.66-0.5c0,0-1.77,6.65-6.17,7.9c-4.28,1.22-7.06,0.39-10.72-2.8 c0,0,0.18-0.12,0.73-0.92c0.55-0.81,0,0,0,0s1.1,1.68,4.33,1.62C3627.09,507.47,3629.87,506.28,3629.87,502.23L3629.87,502.23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 3612.7229,
    y1: 493.725,
    x2: 3632.9492,
    y2: 493.725
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    style: {
      stopColor: "#BABABA",
      stopOpacity: 0.7399
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7814,
    style: {
      stopColor: "#494948",
      stopOpacity: 0.2968
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_35_)",
    d: "M3632.82,496.48c0,0-18.35-5.96-18.93,0l-1.13-0.16c0,0-0.69-4.9,4.01-5.32 C3621.48,490.57,3634.36,495.79,3632.82,496.48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 3613.771,
    y1: 502.2907,
    x2: 3635.5237,
    y2: 502.2907
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0795,
    style: {
      stopColor: "#222222",
      stopOpacity: 0.1786
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1909,
    style: {
      stopColor: "#353534",
      stopOpacity: 0.2887
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3212,
    style: {
      stopColor: "#525252",
      stopOpacity: 0.4174
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4658,
    style: {
      stopColor: "#7C7C7B",
      stopOpacity: 0.5603
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6222,
    style: {
      stopColor: "#B1B1B1",
      stopOpacity: 0.7148
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7862,
    style: {
      stopColor: "#F1F1F1",
      stopOpacity: 0.8769
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7903,
    style: {
      stopColor: "#F3F3F3",
      stopOpacity: 0.881
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8928,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_36_)",
    d: "M3615.75,497.74c0,0,2.74,3.77,8.37,3.99s11.41,0,11.41,0s-10.95,0.67-13.54,2 s-3.35,3.11-3.35,3.11s-3.95-3.55-4.87-8.65L3615.75,497.74z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 3543.427,
    y1: 433.4373,
    x2: 3598.2554,
    y2: 433.4373
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_37_)",
    points: "3543.43,390.62 3581.13,474.29 3598.26,476.26 3557.44,392.07  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 3364.7856,
    y1: 579.748,
    x2: 3401.6785,
    y2: 515.8477
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2364,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2393,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.1275
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6941,
    style: {
      stopColor: "#0C0C0C",
      stopOpacity: 0.2191
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8608,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.2994
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.185
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0242
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9823,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_38_)",
    d: "M3362.78,516.47c-12.87,5.29-22.7,19.36-22.7,19.36c17.68,1.11,16.11,13.82,15.19,30.33 c-0.12,2.21-0.36,4.86-0.66,7.72l0.46-3.37c0,0,37.92,4.73,40.25,4.73s12.1,3.31,18.38-6.15c3.3-4.97,11.72-19.71,25.5-31.57 c-8.09-2.16-26.4-7.12-39.18-11.15c-10.63-3.35-16.95-9.47-20.16-13.52c-3.08,2.32-6.21,3.62-9.07,3.62 C3369.59,516.47,3366.69,516.47,3362.78,516.47z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3721.61,550.82c0,0-0.46,8.33-1.15,16.06c-0.69,7.74-3.01,18.72-3.28,20.27 c-0.28,1.55,0.55,2.11,2.49-0.28c1.94-2.39,7.89-16.6,10.38-22.65s4.15-10.97,4.98-13.22c0.83-2.25-0.54-2.49-3.18-2.53 c-2.09-0.03-4.18-0.1-7.63-0.02C3722.87,548.47,3721.61,548.61,3721.61,550.82z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4B",
    d: "M3721.61,549.9c0,0-2.99,7.1-3.72,17.24s-0.54,20.46-0.54,20.46s3.35-14.56,3.99-22.95 C3721.97,556.26,3721.61,549.9,3721.61,549.9z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M3346.32,372.77c0,0-6.85-10.72-24.95-10.9l-3.34,7.33c0,0-2.46,2.14-2.46,4.82 C3315.57,374.02,3333.49,377.59,3346.32,372.77z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 3330.9436,
    y1: 361.8654,
    x2: 3330.9436,
    y2: 375.2902
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1379,
    style: {
      stopColor: "#151514",
      stopOpacity: 0.0837
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    style: {
      stopColor: "#050505",
      stopOpacity: 0.0372
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9784,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1717
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.2
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_39_)",
    d: "M3346.32,372.77c0,0-6.85-10.72-24.95-10.9l-3.34,7.33c0,0-2.46,2.14-2.46,4.82 C3315.57,374.02,3333.49,377.59,3346.32,372.77z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 3659.0564,
    y1: 466.5793,
    x2: 3683.6379,
    y2: 466.5793
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_40_)",
    d: "M3659.06,448.68l14.88,35.71c0,0,5.43,0.82,9.05-2.66 C3686.6,478.26,3674.75,465.45,3659.06,448.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 3679.3716,
    y1: 462.0695,
    x2: 3702.6023,
    y2: 462.0695
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A1C1D",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0143,
    style: {
      stopColor: "#393A3C",
      stopOpacity: 0.1258
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364,
    style: {
      stopColor: "#626364",
      stopOpacity: 0.1657
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0612,
    style: {
      stopColor: "#888989",
      stopOpacity: 0.2106
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0883,
    style: {
      stopColor: "#A8A9A9",
      stopOpacity: 0.2595
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1182,
    style: {
      stopColor: "#C4C4C4",
      stopOpacity: 0.3135
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    style: {
      stopColor: "#DADADA",
      stopOpacity: 0.3745
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    style: {
      stopColor: "#EAEBEB",
      stopOpacity: 0.4456
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2402,
    style: {
      stopColor: "#F6F6F6",
      stopOpacity: 0.5337
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3085,
    style: {
      stopColor: "#FDFDFD",
      stopOpacity: 0.6572
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4984,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6895,
    style: {
      stopColor: "#FDFDFD",
      stopOpacity: 0.657
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7584,
    style: {
      stopColor: "#F6F6F6",
      stopOpacity: 0.5334
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8075,
    style: {
      stopColor: "#EBEBEA",
      stopOpacity: 0.4453
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8472,
    style: {
      stopColor: "#DADADA",
      stopOpacity: 0.3741
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8812,
    style: {
      stopColor: "#C4C4C4",
      stopOpacity: 0.3131
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9114,
    style: {
      stopColor: "#A9A9A8",
      stopOpacity: 0.259
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9386,
    style: {
      stopColor: "#888888",
      stopOpacity: 0.2101
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9637,
    style: {
      stopColor: "#636362",
      stopOpacity: 0.1651
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    style: {
      stopColor: "#3A3A39",
      stopOpacity: 0.1252
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_41_)",
    d: "M3679.41,453.24c-0.52-1.62,3.89-1.82,5.54-1.54c0.9,0.15,1.98,0.44,3.25,0.94 c3.45,1.38,6.98,3.42,8.41,4.28c0.43,0.26,0.76,0.65,0.94,1.12l5,13.2c0.6,1.54-5.96,1.31-7.59,1.24l-6.03-2.41 c-0.93-0.04-1.75-0.67-2.04-1.57L3679.41,453.24z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M3673.53,472.94h3.62c0,0,0-13.91,0-15.95s1.21-7.77,9.45-3.48s9.05,12.27,9.25,17.18h6.64 c0,0,0.4,8.39-3.02,8.39s-6.03-0.41-8.65,1.64c-2.61,2.05-5.03,1.02-7.84,1.02c-2.82,0-3.42,2.66-9.05,2.66L3673.53,472.94z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    fill: "#A1C8D9",
    d: "M3681.62,456.58c0-0.98,0.93-1.68,1.85-1.39c3.2,1.03,10.03,4.6,10.03,17.04 c0,4.39-7.47,6.71-10.56,6.31c-0.71-0.09-1.23-0.7-1.24-1.43L3681.62,456.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 3681.6169,
    y1: 466.8538,
    x2: 3693.5029,
    y2: 466.8538
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1909,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9838,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_42_)",
    d: "M3681.62,456.58c0-0.98,0.93-1.68,1.85-1.39c3.2,1.03,10.03,4.6,10.03,17.04 c0,4.39-7.47,6.71-10.56,6.31c-0.71-0.09-1.23-0.7-1.24-1.43L3681.62,456.58z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M3677.21,460.55c0,0,0,10.04,0,11.34s-1.19,1.54-3.37,1.54v-0.59c0,0,2.91,0.25,2.91-2.13 c0-3.43,0.52-10.11,0-9.58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 3246.6531,
    y1: 626.9833,
    x2: 3270.9026,
    y2: 626.9833
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.0763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.1498
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.2
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_43_)",
    d: "M3270.9,636.5v3.48l-20.82-3.75l-3.43-22.25C3246.65,613.98,3248.5,633.01,3270.9,636.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 3134.4766,
    y1: 604.6328,
    x2: 3134.4766,
    y2: 628.0817
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.8
    }
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_44_)",
    d: "M3123.62,604.63c0,0-3.01,6.41-3.87,9.76s1.29,3.06,3.87,3.5s6.59,7.14,16.9,9.76l8.88,0.44 c0,0-2.72-15-3.01-17.33c-0.29-2.33-0.86-4.37,0.14-4.52C3146.53,606.23,3130.06,604.78,3123.62,604.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 3263.7185,
    y1: 640.6426,
    x2: 3264.2305,
    y2: 604.9916
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7309,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.085
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7757,
    style: {
      stopColor: "#0C0C0C",
      stopOpacity: 0.1461
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1996
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8153,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.2
    }
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_45_)",
    d: "M3246.38,612.16c0,0,27.65,0.18,35.48,0.71l-1.57,2.96l-33.64-1.84L3246.38,612.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 3733.7227,
    y1: 605.3486,
    x2: 3793.5747,
    y2: 605.3486
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4595,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.1908
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8643,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.3745
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.5
    }
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_46_)",
    d: "M3737.44,610.18c-0.68-11.06-1.98-20.53-3.71-28.49c0,0,9.89-40.87,34.77-35.48 c28.67,6.22,25.78,66.46,24.11,75.79c-2.12,11.82-7.71,40.59-28.16,42.91C3743.99,667.21,3738.21,622.76,3737.44,610.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 3400.5261,
    y1: 538.9824,
    x2: 3334.0049,
    y2: 548.3334
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5619,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7054,
    style: {
      stopColor: "#0C0C0C",
      stopOpacity: 0.1561
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8377,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.185
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9519,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0242
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9619,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_47_)",
    d: "M3352.81,541.76c0,0,13.18-19.72,18-25.28c4.82-5.56-7.51,40.09-8.13,54.89l-7.6-0.86 C3355.08,570.51,3359.59,556.56,3352.81,541.76z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M3473.36,458.73c0.17-0.06,94.06,0.61,94.06,0.61l5.82,14.19c0,0-71.67-7.38-81.82-9.47 c-10.15-2.09-18.1-3.93-18.1-3.93L3473.36,458.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 3508.3037,
    y1: 438.5547,
    x2: 3539.6868,
    y2: 492.9117
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005137858,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0133,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0225,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0325,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0435,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0705,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1138,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.94
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#282827",
      stopOpacity: 0.9457
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464645",
      stopOpacity: 0.9559
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787877",
      stopOpacity: 0.9694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCBCBC",
      stopOpacity: 0.9855
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_48_)",
    d: "M3473.36,458.73c0.17-0.06,94.17,0.26,94.17,0.26l5.71,14.55c0,0-67.55-5.19-82.73-9.24 c-10.01-2.67-17.19-4.16-17.19-4.16L3473.36,458.73z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3189.36,508.52c0.43-2.07,0.85-4.14,1.29-6.21c0.06-0.29,0.37-0.64-0.02-0.82 c-0.44-0.2-0.62,0.22-0.76,0.55c-0.25,0.58-0.46,1.17-0.71,1.75c-0.11,0.26-0.3,0.5-0.6,0.45c-0.35-0.06-0.32-0.38-0.33-0.65 c-0.01-0.45,0.02-0.9-0.02-1.35c-0.03-0.32,0.16-0.83-0.4-0.82c-0.42,0-0.52,0.4-0.59,0.79c-0.34,1.85-0.52,3.73-1.03,5.56 c-0.17,0.63-0.37,1.03-1.06,0.85c-0.7-0.18-0.36-0.69-0.28-1.1c0.59-3.04,1.19-6.09,1.78-9.13c0.26-0.91,0.23-1.87,0.53-2.78 l0,0.01c0.84-0.46,1.55-0.04,1.58,0.52c0.16,1.14,0.21,2.29,0.29,3.44c0.05,0.66,0.25,0.98,0.86,0.37l-0.01,0.02 c0.58-1.05,0.69-1.66,1.1-2.46c0,0,0,0.01,0,0.01c0.4-0.73,0.48-1.2,0.87-1.79c0.21-0.31,0.57-0.47,0.96-0.34 c0.44,0.15,0.48,0.38,0.41,0.74c-0.77,3.92-1.54,7.83-2.3,11.75C3190.73,508.95,3190,508.61,3189.36,508.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3238.83,509.38c-1.06,0.07-0.84-0.58-0.65-1.47c0.79-3.69,1.73-7.35,2.16-11.11 c0.1-0.85,0.48-1.28,1.41-1.23c1.26,0.06,2.23,0,3.49,0.05c0.39,0.02,1.48-0.15,1.38,0.72c-0.07,0.64-0.16,1.25-1.17,1.2 c-0.85-0.04-1.73,0.11-2.57-0.05c-1.01-0.18-1.03,0.83-1.21,2.17c-0.04,0.33,0.18,0.65,0.51,0.67 c0.86,0.07,2.25-0.42,2.07,0.88c-0.22,1.22-0.82,0.96-1.53,0.96c-1.96,0.01-1.61,0.05-1.93,1.98 c-0.5,2.97-0.99,3.03,2.11,3.01c0.85,0,1.95-0.33,1.67,1.26c-0.14,0.76-0.55,0.95-1.22,0.94c-0.72-0.01-1.44,0-2.16,0 C3241.2,509.32,3239.5,509.34,3238.83,509.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3225.67,509.12c-0.23,0-0.47,0.05-0.67-0.01c-1.06-0.03-1.83,0.18-2.11-0.75 c-0.27-0.93-0.03-1.69,0.62-2.5c0.3-0.38,0.83-1.02,1.23-1.3c1.3-1.6,2.39-2.5,3.53-3.84c0.43-0.36,0.67-1.09,0.74-1.71 c0.08-0.66,0.09-1.24-0.65-1.4c-0.7-0.15-1.52-0.09-1.79,0.68c-0.09,0.25-0.12,0.53-0.24,0.77c-0.16,0.32-0.48,0.38-0.82,0.34 c-0.41-0.04-0.5-0.32-0.49-0.67c0.04-1.16,0.2-2.32,1.31-2.94c1.17-0.65,2.79-0.66,3.64-0.01c0.85,0.5,0.83,1.55,0.81,2.32 c-0.07,2.58-1.4,4.35-3.17,6.11c-0.67,0.66-1.38,1.29-2.06,1.94c-0.19,0.18-0.46,0.59-0.35,0.9c0.12,0.35,0.44,0.22,0.77,0.21 c0.63-0.02,1.26-0.08,1.89-0.09c0.45-0.01,1.02-0.04,0.97,0.62c-0.04,0.55-0.09,1.26-0.87,1.32c-0.76,0.06-1.53,0.01-2.3,0.01 C3225.67,509.12,3225.67,509.12,3225.67,509.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3232.95,509.12c-0.23,0-0.47,0.05-0.67-0.01c-1.06-0.03-1.83,0.18-2.11-0.75 c-0.27-0.93-0.03-1.69,0.62-2.5c0.3-0.38,0.83-1.02,1.23-1.3c1.3-1.6,2.39-2.5,3.53-3.84c0.43-0.36,0.67-1.09,0.74-1.71 c0.08-0.66,0.09-1.24-0.65-1.4c-0.7-0.15-1.52-0.09-1.79,0.68c-0.09,0.25-0.12,0.53-0.24,0.77c-0.16,0.32-0.48,0.38-0.82,0.34 c-0.41-0.04-0.5-0.32-0.49-0.67c0.04-1.16,0.2-2.32,1.31-2.94c1.17-0.65,2.79-0.66,3.64-0.01c0.85,0.5,0.83,1.55,0.81,2.32 c-0.08,2.58-1.4,4.35-3.17,6.11c-0.67,0.66-1.38,1.29-2.06,1.94c-0.19,0.18-0.45,0.59-0.35,0.9c0.12,0.35,0.44,0.22,0.77,0.21 c0.63-0.02,1.26-0.08,1.89-0.09c0.45-0.01,1.02-0.04,0.97,0.62c-0.04,0.55-0.09,1.26-0.87,1.32c-0.76,0.06-1.53,0.01-2.3,0.01 C3232.95,509.12,3232.95,509.12,3232.95,509.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3211.71,495.25c0.62,0.18,1.57-0.15,1.79,0.96c0.23,1.1-0.08,1.95-0.61,2.94 c-0.15,0.29-0.57,0.23-0.88,0.14c-0.41-0.11-0.41-0.43-0.32-0.76c0.18-0.69,0.38-1.39-0.69-1.5c-0.91-0.09-1.6,0.15-1.81,1.18 c-0.45,2.25-0.95,4.49-1.38,6.74c-0.14,0.72,0.1,1.41,0.89,1.61c0.92,0.23,1.73-0.1,2.15-0.98c0.33-0.68,0.53-1.76,1.49-1.2 c0.77,0.45,0.2,1.39-0.13,2.06c-0.62,1.25-1.43,2.29-2.99,2.42c-2.13,0.18-3.29-0.97-2.95-3.09c0.34-2.13,0.81-4.25,1.22-6.37 c0.06-0.31,0.17-0.61,0.22-0.92C3208.14,495.91,3208.95,495.24,3211.71,495.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3202.35,504.47c-0.08-0.64-0.54-0.03-0.7,0.28c-0.56,1.12-1.13,2.23-1.71,3.34 c-0.24,0.45-0.56,0.93-1.14,0.62c-0.66-0.35-0.2-0.83-0.01-1.25c0.79-1.7,1.7-3.16,2.47-5.03c0.42-0.81,0.45-1.21,0.38-1.86 c-0.16-1.39-0.35-2.77-0.54-4.15c-0.08-0.59-0.04-1.14,0.68-1.24c0.73-0.1,0.93,0.43,0.97,1.02c0.06,0.76,0.08,1.53,0.12,2.3 c0.01,0.27,0.01,0.58,0.36,0.63c0.31,0.05,0.51-0.16,0.63-0.41c0.43-0.89,0.82-1.8,1.26-2.69c0.24-0.49,0.61-1.07,1.23-0.74 c0.67,0.35,0.25,0.88-0.02,1.37c-0.67,1.22-1.22,2.51-1.94,3.7c-0.61,1.01-0.6,2.05-0.46,3.13c0.18,1.43,0.39,2.86,0.56,4.29 c0.06,0.5,0.09,1.05-0.65,1.08c-0.66,0.03-0.96-0.28-1.02-0.96C3202.75,506.74,3202.63,505.93,3202.35,504.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3216.94,508.05c0.17-2.28,1.2-4.21,2.43-6.07c0.67-1.01,1.27-2.06,1.85-3.12 c0.26-0.47,0.97-1.65-0.03-1.7c-1.27-0.04-1.61-0.09-1.95,0.93c-0.07,0.21-0.06,0.45-0.13,0.66 c-0.18,0.52-0.62,0.45-1.02,0.39c-0.48-0.07-0.56-0.45-0.44-0.82c0.21-0.69,0.35-1.39,0.43-2.11 c0.07-0.66,0.55-0.89,1.15-0.89c1.31,0,2.61,0.01,3.92,0.03c0.77,0.01,0.96,0.38,0.87,1.14c-0.25,2.02-1.6,3.48-2.51,5.16 c-1.15,2.11-2.87,3.94-2.96,6.54c-0.02,0.59-0.51,0.82-1.08,0.75C3216.91,508.87,3216.88,508.46,3216.94,508.05z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M3186.67,492.79c-1.8,0-3.26,0.01-4.28,0.01c-0.99,0-1.84,0.69-2.05,1.65l-3.44,15.41 c-0.29,1.31,0.7,2.56,2.04,2.57l2.95,0.02l0.75-0.2L3186.67,492.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3181.41,512.12l-0.92-0.02l64.47,0.28c1.02,0,1.9-0.45,2.11-1.09c0,0-0.89,1.97-4.16,1.97 c-3.27,0-57.79,0-61.19,0c-4.83,0-4.4-1.38-4.4-1.38l3.84,0.21l0.59,0.05"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0978 -0.9952 0.9952 0.0978 2378.1453 3636.6289)",
    fill: "#5E5D5B",
    cx: 3194.9,
    cy: 506.62,
    rx: 3.48,
    ry: 2.27
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1278 -0.9918 0.9918 0.1278 2294.1177 3604.3296)",
    fill: "#D25959",
    cx: 3196.33,
    cy: 497.83,
    rx: 3.11,
    ry: 2.03
  })))))), /*#__PURE__*/React.createElement("g", null, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3435.11,478c0,0,0.72,2.44,1.74,5.98c1.01,3.55,3.8,12.42,4.82,14.7c1.01,2.28,3.55,4.56,8.11,4.56 s18.97-0.51,22.3-0.51c4.01,0,3.61-5.82,0.56-12.91c-3.04-7.1-4.33-12.78-14.25-13.7c-8.38-0.78-16.34-1.09-19.38-1.09 C3435.96,475.04,3434.48,475.43,3435.11,478z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M3474.32,480.53c1.29,3.49,3.43,9.32,4.9,13.61c0.75,2.2,3.28,3.21,5.34,2.14l22.58-11.79 c1.61-0.84,2.39-2.69,1.88-4.43c0,0-1.11-7.54-3.97-13.62c-1.77-3.78-5.03-4.3-7.16-3.11l-21.88,12.59 C3474.4,476.84,3473.68,478.79,3474.32,480.53z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 3474.0889,
    y1: 479.7353,
    x2: 3509.1741,
    y2: 479.7353
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.0382
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.0749
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_49_)",
    d: "M3474.32,480.53c1.29,3.49,3.43,9.32,4.9,13.61c0.75,2.2,3.28,3.21,5.34,2.14l22.58-11.79 c1.61-0.84,2.39-2.69,1.88-4.43c0,0-1.11-7.54-3.97-13.62c-1.77-3.78-5.03-4.3-7.16-3.11l-21.88,12.59 C3474.4,476.84,3473.68,478.79,3474.32,480.53z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#C7C9C6",
    d: "M3470.45,485.3l7.19-2.95c0,0,0-2.03,3.69-3.69c3.69-1.66,15.12-8.67,17.7-9.77s7.38,7.38,5.16,11.8 l-21.58,11.99l-2.95-3.87l-7.19,2.95L3470.45,485.3z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M3443.02,486.17c0,0-0.98-2.35-1.86-5.58c-0.88-3.23,9.3-2.06,14.59-1.76c5.29,0.29,6.27,1.66,7.05,3.13 L3443.02,486.17z"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3443.02,486.17l3.98,10.34c0,0,4.31-2.48,6.68-4.2c2.37-1.72,2.26-3.55,2.69-4.95 c0.31-1.02,1.14-3.04,2.64-4.2c-3.55-0.77-8.76-0.89-11.01-0.9C3444.61,483.75,3443.02,486.17,3443.02,486.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3443.02,486.17l3.98,10.34c0,0,4.31-2.48,6.68-4.2c2.37-1.72,2.26-3.55,2.69-4.95 c0.31-1.02,1.14-3.04,2.64-4.2c-3.55-0.77-8.76-0.89-11.01-0.9C3444.61,483.75,3443.02,486.17,3443.02,486.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBFFFB",
    d: "M3464.77,485.09c-0.43-4.2-5.38-4.41-12.06-3.98c-1.85,0.12-3.41,0.57-4.71,1.14 c2.25,0.01,7.46,0.13,11.01,0.9c0.57-0.44,1.22-0.77,1.99-0.86C3463.8,481.97,3464.77,485.09,3464.77,485.09z"
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M3464.77,485.09l13.07,0.37c0,0-3.76,5.64,0.1,8.77l-14.72-0.94c0,0-3.03,4.59-6.47,7.1 c0,0-3.76,0.42-6.16,0.1c-2.4-0.31-3.13-2.65-3.6-3.99l10.07-13.03c0,0,1.98-1.88,4.38-1.46S3464.77,485.09,3464.77,485.09z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFFFB",
    d: "M3464.77,485.09c0,0-1.12-2.55-3.21-2.13c-2.09,0.42-3.44,3.65,3.24,3.65c6.68,0,12.31,0.21,12.31,0.21 s-0.21-0.94,1.25-1.46L3464.77,485.09z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 3448.001,
    y1: 483.0977,
    x2: 3464.7717,
    y2: 483.0977
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2213,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4937,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0425
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6893,
    style: {
      stopColor: "#0C0C0C",
      stopOpacity: 0.073
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8607,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.0998
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.0617
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.00806646
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9823,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_50_)",
    d: "M3452.71,481.11c-1.85,0.12-3.41,0.57-4.71,1.14c2.25,0.01,7.46,0.13,11.01,0.9 c0.57-0.44,1.22-0.77,1.99-0.86c2.8-0.32,3.77,2.8,3.77,2.8"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3479.14,495.36c-1.86,0-3.38-2.38-3.38-5.32s1.51-5.32,3.38-5.32h2.33v10.63H3479.14z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 3475.769,
    y1: 490.039,
    x2: 3481.478,
    y2: 490.039
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1725,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1
    }
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_51_)",
    d: "M3479.14,495.36c-1.86,0-3.38-2.38-3.38-5.32s1.51-5.32,3.38-5.32h2.33v10.63H3479.14z"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5E5D5B",
    cx: 3481.48,
    cy: 490.04,
    rx: 3.38,
    ry: 5.32
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M3442.92,485.91l3.29,8.4c0,0-2.42-7.8-2.2-9.5"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 3116.8853,
    y1: 617.5953,
    x2: 3159.4211,
    y2: 617.5953
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1913,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.8
    }
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_52_)",
    d: "M3123.62,604.63c0,0,19.76,0.73,22.92,1.6c3.15,0.87,3.58,2.04,4.58,7.57 c1,5.53,2.29,10.05,2.29,10.05l6.02,6.7l-9.6-0.87l-0.43-1.6l-8.88-0.44l-0.29,1.89l-21.91-2.91l-1.43-6.12L3123.62,604.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 3167.5569,
    y1: 483.8727,
    x2: 3338.7373,
    y2: 385.0417
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008980082,
    style: {
      stopColor: "#F2F2F1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    style: {
      stopColor: "#C5C5C5",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0782,
    style: {
      stopColor: "#9D9D9C",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1171,
    style: {
      stopColor: "#7A7A79",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1592,
    style: {
      stopColor: "#5D5D5C",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2056,
    style: {
      stopColor: "#454544",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2581,
    style: {
      stopColor: "#323232",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3204,
    style: {
      stopColor: "#262625",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4017,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7091,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9317
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7692,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9458
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8144,
    style: {
      stopColor: "#323231",
      stopOpacity: 0.9564
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8523,
    style: {
      stopColor: "#444443",
      stopOpacity: 0.9653
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8855,
    style: {
      stopColor: "#5B5B5B",
      stopOpacity: 0.9731
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9155,
    style: {
      stopColor: "#787877",
      stopOpacity: 0.9801
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    style: {
      stopColor: "#9A9A9A",
      stopOpacity: 0.9866
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9686,
    style: {
      stopColor: "#C2C2C2",
      stopOpacity: 0.9926
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9918,
    style: {
      stopColor: "#EEEEEE",
      stopOpacity: 0.9981
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_53_)",
    d: "M3151.82,446.66c-1.86,2.01-6.98,6.03,2.44,6.62c9.42,0.59,62.27,0.31,62.27,0.31 s48.73,0,68.41-0.98c19.68-0.98,53.29-0.98,59.77-9.76c6.48-8.79,14.16-22.95,14.16-22.95s-0.31-0.57-0.98-1.5 c-2.96-4.09-13.02-15.1-35.5-15.1c-27.6,0-103.69,0-111.61,0c-7.72,0-20.37,1.4-35.55,17.58c-0.39,0.42-0.79,0.84-1.18,1.28 C3158.33,439.57,3153.68,444.65,3151.82,446.66z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 3177.7864,
    y1: 502.5254,
    x2: 3250.1167,
    y2: 502.5254
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2213,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2634,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.085
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7009,
    style: {
      stopColor: "#0C0C0C",
      stopOpacity: 0.1461
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8612,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.1996
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8971,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.1233
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9457,
    style: {
      stopColor: "#030303",
      stopOpacity: 0.0161
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9823,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_54_)",
    d: "M3248.11,492.68c-11.54-0.3-46.74-0.28-60.73-0.25c-1.76,0-3.18,0.01-4.18,0.01 c-0.96,0-1.8,0.69-2,1.66l-3.36,15.5c-0.29,1.32,0.68,2.57,2,2.58l2.88,0.02l62.2,0.44c0.98,0.01,1.83-0.7,2.03-1.69l3.13-15.71 C3250.33,493.93,3249.39,492.72,3248.11,492.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 3435.9377,
    y1: 632.1732,
    x2: 3527.0181,
    y2: 632.1732
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4595,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#040404",
      stopOpacity: 0.1908
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8643,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.3745
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.5
    }
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_55_)",
    d: "M3443.93,637.64c-1-12.49-5.42-25.84-7.99-34.83c0,0,17.13-43.54,53.95-37.45 c42.44,7.03,38.16,75.09,35.68,85.64c-3.14,13.35-11.42,45.87-41.68,48.48C3453.64,702.09,3445.07,651.87,3443.93,637.64z"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3484.81,430l0.48-11.1c-0.08,0.03-0.16,0.05-0.24,0.08C3484.87,420.55,3484.68,424.54,3484.81,430z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3521.9,413.25c-0.04,0.41-0.02,2.33-0.04,2.71c-0.22,3.9-0.45,6.54-0.51,9.51 c-0.27,14.01-1.21,23.31-2.6,29.06c-0.09,0.37-0.18,0.66-0.26,0.89l-0.07,0.82c0.86-0.48,1.39-0.67,2.39-0.83 c1.26-0.2,1.92-0.66,3.03-1.26l0.07,0.02c2.51-7.62,1.98-17.83,1.32-20.6c-0.93-3.91-1.52-9.37-1.87-13.94 c-0.39-0.25-0.6-0.46-0.6-0.46L3521.9,413.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFC4AD",
    d: "M3533.53,417.64c-1.34,0.83-3.8,2.32-4.67,2.57c-2.73,0.78-4.6-0.02-5.49-0.59 c0.35,4.57,0.93,10.03,1.87,13.94c0.66,2.77,1.2,12.97-1.32,20.6l-0.07-0.02c-1.11,0.61-1.77,1.06-3.03,1.26 c-1,0.16-1.53,0.36-2.39,0.83c-0.22,0.12-0.46,0.26-0.74,0.43c-1.36,0.81-2.68-0.3-2.22,1.31c0.24,0.84,1.49,1.01,2.75,0.92 c1.18-0.08,2.37-0.38,2.76-0.57c0.81-0.4,1.11-0.15,0.91,0.61s-1.16,2.12-2.02,3.49c-0.86,1.36-1.06,2.68-1.21,4.65 c-0.15,1.97-0.35,2.73,0.76,2.78c1.11,0.05,1.67-2.68,2.22-4.29c0.56-1.62,1.87-3.59,1.87-3.59s-0.15,0.56-0.4,1.36 c-0.25,0.81-0.81,2.63-0.51,3.74c0.3,1.11,0.66,2.12,1.62,2.32c0.96,0.2,1.31-1.67,1.31-1.67c0.2,0.86,0.86,1.67,1.82,1.62 c0.96-0.05,1.52-2.07,1.82-3.18c0.3-1.11,0.91-2.07,0.91-2.07c-0.15,0.45,0,1.47-0.2,2.12c-0.2,0.66-0.4,1.72,0.3,1.77 c0.71,0.05,0.71,0.05,1.92-1.11s0.51-1.72,0.61-3.59c0.08-1.47-1.52-4.31-1.79-5.85c1.43-9.39,2.77-8.59,3.87-18.25 C3535.5,432.78,3534.53,424.03,3533.53,417.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFC4AD",
    d: "M3497.61,456.49c0,0-2.03-0.13-3.09-0.44c-2.02-0.59-3.71-1.31-4.96-1c-2.01,0.5-2.25-1.36-2.43-2.46 c-1.4-8.5-1.94-16.55-2.08-22.73c-0.13-5.46,0.45-9.95,0.64-11.52c-2.53,0.79-7.07,1.57-10.44-2.23 c-0.17,2.96-0.7,15.49,1.4,27.97c1.21,7.21,3.8,16.03,3.8,16.03s0.51,1.07,0.91,2.79c0.41,1.72,1.32,2.79,1.92,4.29 c0.61,1.5,1.83,3.04,3,2.27c0,0,1.17,2.36,2.4,2.07s1-1.18,1-1.18s1.06,0.83,1.95,0.41s0.73-2.3,0.73-2.3s1.17,0.24,1.56-0.47 s0.11-4.49,0.06-5.14c-0.06-0.65-1.22-4.11-1.22-4.11s3.07,0.22,3.73,0.06c0.22-0.06,0.41-0.13,0.57-0.21 C3498.35,457.94,3497.61,456.49,3497.61,456.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M3495.47,397.61c-0.15-0.05-0.29-0.1-0.42-0.16C3495.26,397.56,3495.4,397.6,3495.47,397.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M3532.02,404.3c-0.4-2.68-1.45-8.41-4.02-10.08c-2.5-1.62-7.15-1.48-11.26-0.96 c-2.38,0.3-4.76,0.67-6.25,0.95c-0.23,3.26-0.23,3.9-0.46,5.48c-0.88,6.01-2.7,8.14-6.6,8.14c-7.21,0-7.66-10.13-7.67-10.29 c0,0-0.2,0.06-0.23,0.05c-0.38-0.37-2.31-2.46-2.39-2.58c-0.24-0.36-0.75-1.03-1.28-1.97c-0.04-0.01-3.48-0.48-3.73-0.52 c-0.02-0.02-0.02-0.04-0.02-0.05c-4.56-0.74-10.73-1.23-11.9,2.58c-2.1,6.88-2.1,20.23-2.1,20.23c0.29,0.41,0.58,0.78,0.88,1.12 c3.37,3.79,7.52,3.36,10.05,2.56c0.08-0.03,0.16-0.05,0.24-0.08l-0.48,11.1c0.14,6.18,0.69,14.22,2.08,22.73 c0.18,1.1,0.4,3.12,2.4,2.62c1.25-0.31,2.95,0.39,4.97,0.99c1.05,0.31,3.16,0.5,3.16,0.5s0.48,1.34-0.83,1.98l21.59,0.34 l0.02-0.24c-1.26,0.08-2.52-0.09-2.75-0.92c-0.45-1.62,0.86-0.51,2.22-1.31c0.28-0.17,0.52-0.31,0.74-0.43l0.07-0.82 c0.08-0.22,0.17-0.51,0.26-0.89c1.39-5.74,2.33-15.05,2.6-29.06c0.06-2.97,0.29-5.61,0.51-9.51c0.02-0.38,0.01-2.3,0.04-2.71 l0.87,5.91c0,0,0.2,0.2,0.6,0.46c0.89,0.57,2.76,1.37,5.49,0.59c0.87-0.25,3.33-1.74,4.67-2.57c0.54-0.33,0.9-0.56,0.9-0.56 S3532.71,408.99,3532.02,404.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFC4AD",
    d: "M3512.14,388.51c0,0-0.01-0.58,0.08-1.62c0.08-0.03,0.11-0.05,0.21-0.08c1.68-0.55,2.88-3.07,3.34-4.39 c0.45-1.32,0.62-3.49-1.3-3.52c-0.59-0.01-8.25-11.75-8.25-11.75c-1.35,1.07-9.44,0.07-9.4-1.81c-0.29,1.87-8.19,2.72-7.35,0.91 c0,0-0.1,0.21-0.24,0.59c-0.29,0.79-0.95,2.29-0.85,3.97c-0.23,2.42-0.48,4.09-0.24,5c0,0.21,0.03,0.15,0.03,0.57 c-0.03,0.77-0.14,1.21-0.05,1.94c0.45,3.63-0.25,6.7,0.51,9.33c0.09,0.31,0.15,0.57,0.28,0.92c0.01,0.03,0.1,0.16,0.11,0.18 c0.58,1.49,1.55,3.01,2.31,4.35c0.53,0.94,0.98,1.74,1.22,2.1c0.09,0.13,0.23,0.31,0.33,0.46c0.92,1.15,1.59,1.82,2.11,1.95 c0.13,0.06,0.34-0.06,0.49-0.01c0.04,0.01,0.06,0.01,0.06,0.01c0,0,0,0.01,0,0.01c0.01,0.16,0.69,10.52,7.9,10.52 c3.9,0,5.93-2.44,6.82-8.45c0.23-1.58,0.19-2.14,0.42-5.39c0.07-0.91,0.51-1.92,0.64-3.34 C3512.28,389.58,3512.14,388.51,3512.14,388.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFC4AD",
    d: "M3489.81,378.52c-0.59,0.32-0.65,0.86-0.65,0.86s0.19,0.01,0.69-0.02c0.07,0,0.16-0.01,0.26-0.01 C3490.09,379.34,3489.62,379.12,3489.81,378.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M3495.12,387.66c-0.65-0.02-1.22,0.08-1.55,0.33c0.18-0.09,0.65-0.27,1.47-0.32 C3495.06,387.66,3495.09,387.66,3495.12,387.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M3498.47,389.8c0.01-0.02,0.02-0.03,0.03-0.05C3498.49,389.76,3498.49,389.78,3498.47,389.8 C3498.47,389.79,3498.47,389.79,3498.47,389.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M3494.35,391.25c0.51,0.49,1.2,0.69,2.06,0.39c-0.19,0.05-0.38,0.09-0.59,0.09 C3495.12,391.74,3494.65,391.51,3494.35,391.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M3492.96,388.43l0.09-0.03c0,0,0.23,1.23,0.81,2.22c0,0-0.03-1.27,1.53-1.51 c1.56-0.24,2.57-0.22,3.22,0.13c0,0,0.16,0.13,0.02,0.35c0.27-0.41,0.46-0.76,0.56-0.95l-0.24-0.23 c-0.36-0.1-1.1-0.44-1.73-0.59c-1.89,0.76-3.18,0.15-3.36,0.08c-0.01,0.01-0.37,0.15-0.38,0.15 C3493.31,388.23,3493.12,388.35,3492.96,388.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M3497.1,382.89c-0.13-0.23-0.21-0.37-0.21-0.37C3496.94,382.62,3497.01,382.75,3497.1,382.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M3497.32,388c-0.44-0.1-0.74-0.44-1.08-0.49c-0.34-0.05-0.81,0.01-1.12,0c-0.03,0-0.04,0-0.06,0 c-0.82,0.05-1.3,0.23-1.48,0.32c-0.02,0.02-0.05,0.2-0.08,0.22C3493.67,388.11,3495.43,388.75,3497.32,388z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFD7C6",
    d: "M3496.07,390.93c-1.34,0.04-2.21-0.32-2.21-0.32s0.01,0.46,0.37,0.76c0.3,0.26,0.84,0.58,1.55,0.57 c0.21,0,0.56-0.02,0.75-0.08c1.2-0.35,1.82-1.82,1.95-2.07c0,0,0,0,0-0.01C3498.07,390.34,3497.41,390.89,3496.07,390.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D25959",
    d: "M3495.32,388.85c-1.56,0.24-1.46,1.76-1.46,1.76s0.75,0.54,2.09,0.5c1.34-0.04,2.13-0.78,2.53-1.32 c0.01-0.02,0.02-0.03,0.03-0.04c0.04-0.06,0.08-0.11,0.11-0.16c0.14-0.22,0.2-0.38,0.2-0.38 C3498.17,388.85,3496.87,388.61,3495.32,388.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M3514.05,370.06L3514.05,370.06c0.02-0.04,0.04-0.1,0.05-0.17L3514.05,370.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M3492.32,389.39c-0.02-0.09-0.05-0.18-0.07-0.28C3492.29,389.46,3492.43,389.78,3492.32,389.39z"
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M3483.8,461.99c0,0,0.95,3.13,1.28,4.9c0.25,1.33,0.44,2.42,0.52,2.89c0.03,0.16,0.04,0.24,0.04,0.24 l0.45-0.24c0,0,0-0.04-0.01-0.12c-0.06-0.45-0.29-2.15-0.82-3.72C3484.64,464.12,3483.8,461.99,3483.8,461.99z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M3487.65,464.65c0.15,1.01,1.39,5.63,1.63,6.52c0.03,0.1,0.04,0.15,0.04,0.15l0.17-0.65 c0,0-0.02-0.07-0.04-0.18c-0.29-1.19-1.91-7.95-2.52-9.62C3486.93,460.87,3487.48,463.53,3487.65,464.65z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M3490.36,461.11c-0.27-0.98-0.45-1.66-0.42-1.95c0,0-0.19,0.11,0.04,1.27c0.22,1.16,0.9,3.42,1.04,4.37 c0.14,0.91,0.97,3.75,1.06,4.89c0,0.05,0.01,0.09,0.01,0.13l0.09-1.04c0,0-0.01-0.07-0.04-0.19c-0.11-0.55-0.46-2.29-0.97-4.42 C3490.88,462.98,3490.59,461.94,3490.36,461.11z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M3494.11,379.72c0.01-0.12,0.01-0.24,0.01-0.36c-0.01-0.19-0.02-0.39-0.03-0.59 c-0.09-1.03-0.38-1.91-0.38-1.91c0.02,0.03,0.03,0.07,0.05,0.1c-0.38-0.85-0.99-1.26-0.99-1.26c-2.04-1.27-3.3,0.14-3.3,0.14 c0.07,0,0.13,0,0.2,0C3493.2,375.8,3493.96,378.41,3494.11,379.72z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M3493.02,458.28c-0.45-0.21-1.98-0.9-2.37-1.08c1.69,0.86,2.1,1.57,2.1,1.57l1.35,0.08 c0,0,0.13,0.03-0.1-0.1C3493.86,458.66,3493.57,458.52,3493.02,458.28z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M3483.65,434.26c-0.15,3.8-2.18,4.5-2.68,4.62c0.58-0.09,3.24-0.32,3.55,3.56 c0.35,4.35,1.22,8.7,1.39,10.96c0.17,2.26,2.48,1.93,2.48,1.93s0,0,0,0c-0.02-0.11-0.97-1.99-1.43-4.42 c0.08-1.96,0.23-5.34,0.4-9.25c0.03-0.03,0.07-0.07,0.1-0.14c0.92-1.61,4.31,0.52,6.29,2c-3.7-3.45-9.6-11.72,1.24-5.37 c11.49,6.73,15.65,6.34,11.29,4.75c-4.36-1.58-11.29-4.75-14.06-9.9c-2.77-5.15-4.16-9.51-3.41-16.9c0,0-0.09,0.91-0.24,2.38 c0.09-1.2,0.17-2.04,0.24-2.38c0.54-2.69,1.75-4.17,0.54-2.96c-1.21,1.21-2.15,2.15-2.42-0.13s-1-8.34-1-8.34 s0.05,4.03-0.08,7.53c-0.09,2.47-0.56,6.04-0.83,6.77c-0.41,0.16-1.97,0.43-1.97,0.47 C3483.12,420.23,3483.82,430.09,3483.65,434.26z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M3531.02,456.51c0.05-0.32,0.12-0.69,0.21-1.1c0.33-1.58,0.81-3.82,1.48-6.18 c0.78-2.76,1.17-4.14,1.7-7.3c0.29-1.75,0.6-3.28,0.65-4.42c0.21-4.8,0.32-10.38-1.5-19.88c-0.01-0.03,0,0-0.02-0.08 c-4.02,3.07-7.02,2.98-7.02,2.98l-0.21,0.09c3.34,7.16,4.91,10.86,3.87,15.17c-0.66,2.74-0.74,5.06-0.15,8.03 c0.96,4.78-0.49,10.02-0.58,12.2c0,0,0,0.01,0,0.01c-0.47,4.12,0,4.56-0.94,8.36c-0.24,0.96-0.46,1.61-0.65,2.06 c-0.67,0.07-1.88,0.12-1.92-0.46c-0.06-0.8,0.98-4.19,0.46-3.39c-0.52,0.8-0.86,3.73-1.49,3.73c-0.59,0-1.5,0.01-2.41-0.08 c-0.07-0.01,0.07,0.01,0,0c-0.06,1.38,0.82,3.49,2.03,3.12c0.87-0.27,0.99-1.63,0.99-1.63c-0.04,0.28,0.32,0.83,0.57,1.09 c0.33,0.35,0.49,0.48,0.89,0.54c0.69,0.11,1.03-0.16,1.61-1.32c0,0,0.21-0.68,0.21-0.62c0.09-0.28,0.13-0.49,0.36-1.26 c0.12-0.38,0.56-1.42,0.85-1.89c-0.01,0.52-0.01,1.32-0.16,1.99c-0.05,0.21-0.12,0.43-0.15,0.64c-0.08,0.63,0.02,1.11,0.65,1.09 c0.89-0.04,0.66-0.17,0.97-0.4c0.19-0.14,0.36-0.29,0.49-0.42c0.88-0.74,1.17-1.31,0.93-2.7c-0.05-0.28-0.03-1.04-0.05-1.36 c-0.08-0.92-0.27-1.5-0.65-2.51c-0.14-0.41-0.27-0.55-0.37-0.86c-0.16-0.52-0.54-1.43-0.66-1.8c-0.24-0.77-0.02-0.75-0.04-0.9 c0-0.05,0.01-0.1,0.02-0.15C3530.99,456.75,3531,456.63,3531.02,456.51z M3530.48,463.98c0-0.03,0-0.06,0-0.09c0,0,0,0,0-0.01 C3530.48,463.92,3530.48,463.95,3530.48,463.98z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M3523.39,461.06c0.06-0.62-0.56,0.5-1.42,2.04c-0.87,1.55-1.36,2.23-1.61,3.84 c-0.23,1.52-0.8,2.53-1.65,2.64c-0.05,0.01,0.05,0,0,0c0,0,0.61,0.57,1.15,0.21c0.59-0.39,1.04-1.78,1.29-2.71 c0.25-0.93,0.85-2.62,1.28-3.36c0.43-0.74,1.05-1.74,1.05-1.74S3523.33,461.67,3523.39,461.06z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M3502.82,379.34c0.06,0,0.1,0,0.1,0l-0.2-0.1c-0.43-0.4-1.66-1.43-2.83-1.35 c-1.45,0.1-2.11,1.42-2.11,1.42s0.63-0.9,1.62-1.14c-0.09,0.03-0.17,0.07-0.27,0.12c0,0-0.22,0.56,0.16,1l1.4,0.02 c0,0,0.49-0.25,0.34-0.93c0.64,0.26,1.26,0.63,1.59,0.85c-0.18,0.01-0.83,0.06-1.69,0.07c-0.89,0.01,1.3,0.04,1.86,0.05 c0.06,0.04,0.09,0.06,0.09,0.06S3502.86,379.38,3502.82,379.34z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M3491.54,378.4c0.82,0.24,1.44,0.77,1.44,0.77s-0.79-1.26-2.52-1.01c-1.2,0.18-1.56,1.3-1.56,1.3 s1.52-0.01,2.2-0.09c0.11-0.01,0.16-0.02,0.18-0.03c0.01,0,0-0.01-0.02-0.01l0.17,0C3491.71,379.03,3491.59,378.57,3491.54,378.4 z M3489.16,379.38c0,0,0.06-0.54,0.65-0.86c-0.19,0.59,0.28,0.82,0.3,0.83c-0.1,0-0.19,0.01-0.26,0.01 C3489.35,379.39,3489.16,379.38,3489.16,379.38z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M3500.7,377.72c0.49,0.1,0.97,0.28,1.44,0.47c0.47,0.19,0.94,0.4,1.39,0.64 c-0.81-0.62-1.75-1.09-2.77-1.35c-0.51-0.11-1.06-0.15-1.59-0.02c-0.52,0.13-1,0.49-1.16,0.97c0.25-0.44,0.73-0.7,1.2-0.78 C3499.7,377.56,3500.21,377.59,3500.7,377.72z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M3504.28,376.74c0,0-1.59-2.13-3.66-2.09c-2.07,0.04-3.12,1.4-3.12,1.4s1.36-0.39,3.14-0.42 C3502.43,375.6,3504.28,376.74,3504.28,376.74z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M3492.33,384.75c0.14-0.3,0.25-0.5,0.35-0.67c0,0.13,0.05,0.28,0.17,0.45c0,0.01-0.01,0.01-0.01,0.02 c-0.03,0.11,0.06,0.16,0.18,0.18c0.03,0.03,0.05,0.05,0.07,0.07c-0.02-0.02-0.04-0.05-0.06-0.07c0.2,0.02,0.48-0.03,0.62-0.06 c0.18,0.17,0.44,0.25,0.79,0.12c0,0-1.06,0.08-0.97-1.18c0.04-0.66,0.52-2.01,0.66-3.17s0.17-2.5-0.43-3.58 c0,0,0.6,1.82,0.34,3.3c-0.26,1.49-0.66,3.33-0.72,3.63c-0.03,0.15,0.03,0.5,0.22,0.75c-0.29-0.15-0.55-0.26-0.66-0.12 c-0.11-0.34-0.06-0.8,0.51-1.07c0,0-0.32,0.1-0.53,0.31c0.05-0.16,0.08-0.36,0.08-0.66c0,0-0.66,1.32-1,2.6 c-0.12,0.44-0.12,0.93-0.08,1.37C3491.84,386.1,3492.09,385.31,3492.33,384.75z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M3496.74,384.2c-0.07-0.38-1.35,0.43-1.35,0.43C3496.43,384.75,3496.81,384.58,3496.74,384.2z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M3497.2,383.78c-0.11-0.67-0.78-0.69-0.78-0.69c0.24-0.03,0.56,0.28,0.65,0.74 c0.05,0.25-0.05,0.46-0.22,0.62C3497.07,384.3,3497.25,384.08,3497.2,383.78z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M3496.86,384.45c-0.25,0.18-0.54,0.25-0.54,0.25"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M3496.86,384.45c-0.14,0.14-0.34,0.23-0.54,0.25"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M3489.25,377.99c0.33-0.23,0.75-0.34,1.18-0.35c0.43-0.03,0.87,0.03,1.28,0.13 c0.41,0.12,0.81,0.29,1.13,0.56c-0.51-0.66-1.51-0.94-2.42-0.9c-0.46,0.03-0.95,0.16-1.29,0.44c-0.35,0.27-0.56,0.64-0.62,1.02 C3488.65,378.54,3488.91,378.22,3489.25,377.99z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M3492.25,389.11c-0.03-0.28,0.01-0.57,0.28-0.54c0.26,0.44,0.69,1.98,1.18,2.76s0.95,1.5,2.63,1.23 c1.67-0.27,1.7-1.4,2.25-2.18c0.42-0.6,0.59-1.38,0.64-1.71c0.32,0.05,0.44,1.03,0.44,1c0-0.02-0.1-0.88-0.15-1.36 c0-0.26-0.04-1.07-0.39-2c-0.07-0.2-0.18-0.43-0.31-0.66c-0.49-0.93-1.29-2.04-1.72-2.75c0.36,0.64,1.11,2,1.57,3.01 c0.41,0.92,0.65,1.72,0.76,2.16c-0.2,0.3-0.5,0.2-0.59,0.26l0.02,0.02c-0.81-0.34-2.65-1.1-3.07-1.23 c-0.55-0.17-0.75-0.03-1.15,0.1c-0.4,0.14-0.35-0.61-1.3,0c-0.66,0.42-0.79,0.91-0.81,1.17c-0.08,0.17-0.26,0.07-0.44-0.39 c-0.03-0.09-0.06-0.13-0.07-0.14c-0.06-0.25-0.11-0.54-0.14-0.85c0.01,0.3,0.05,0.61,0.13,0.93 C3492.02,388.12,3492.14,388.66,3492.25,389.11z M3493.5,388.04c0.02-0.02,0.05-0.04,0.08-0.06c0.32-0.25,0.89-0.34,1.55-0.33 c0.32,0.01,0.65,0.04,0.99,0.09c0.34,0.05,0.78,0.15,1.21,0.25c0.63,0.15,1.26,0.32,1.62,0.42l0.24,0.23 c-0.1,0.19-0.3,0.54-0.56,0.95c-0.03,0.05-0.07,0.1-0.11,0.16c-0.01,0.02-0.02,0.03-0.03,0.05c-0.13,0.25-0.86,1.5-2.06,1.85 c-0.86,0.29-1.55,0.1-2.06-0.39c-0.36-0.3-0.5-0.64-0.5-0.64c-0.58-0.99-0.81-2.22-0.81-2.22l-0.09,0.03 c0.16-0.08,0.35-0.19,0.52-0.37C3493.48,388.05,3493.49,388.05,3493.5,388.04z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M3512.48,384.09c-0.4,0.56-0.28,0.95,0.04,0.64c0.32-0.31,0.99-1.14,0.9-1.41 c-0.09-0.27-0.46-0.18-0.57-0.74c0,0-0.15,0.06-0.12,0.41S3512.88,383.52,3512.48,384.09z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M3513.9,382.85c-0.03,0.41-0.06,0.74-0.06,0.74s0.33-0.34,0.37-0.78c0.04-0.44-0.02-0.7-0.22-1.32 c-0.2-0.62,0.24-1.2,0.62-1.22c0.54-0.04,0.63,1.34,0.63,1.34c0.04-0.61,0.14-1.48-0.34-1.77s-0.88,0.14-1.1,0.41 s-0.8,1.55-0.58,2.1C3513.43,382.9,3513.93,382.44,3513.9,382.85z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M3512.59,385.86c1.33-0.34,2.17-3.01,2.17-3.01C3514.26,384.35,3512.59,385.86,3512.59,385.86z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFC4AD",
    d: "M3491.25,364.52c0,0,1.39-1.18,3.61-1.5c2.35-0.34,4.34-0.52,7.77,0.34c3.92,0.98,5.51,3.24,5.51,3.24 s2.45,2.36,3.67,5.14c0.75,1.72,2.01,5.02,2.49,7.29c0.48,2.26-9.28-11.17-9.28-11.17l-12.36-0.28l-3.5-0.21l0.3-1.11 L3491.25,364.52z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD7D62",
    d: "M3488.07,393.56c-0.3,3.65,0.27,6.52,0.66,8.61c0.29,2.97,0.8,5.92,1.54,8.8 c-0.31-1.79-0.35-3.62-0.11-5.41c0.41,1.34,0.81,2.67,1.22,4.01c0.17,0.56,0.61,1.25,1.15,1.02c-1.03-1.42,0.21-1.14,0.63,0.78 c0.24-2.14,1.2-3.16,1.8-1.63c-0.12-1.95-0.05-3.91,0.19-5.84c0.03-0.01,0.05-0.02,0.08-0.03c0.21,1.9,0.54,3.78,1.01,5.63 c0.27-2.12-0.66-10.39-0.69-11.34c0-0.19-0.01-0.38-0.01-0.57c0,0,0,0,0-0.01c0,0-0.02,0-0.06-0.01 c-0.07-0.02-0.22-0.06-0.42-0.16c-0.44-0.22-1.24-0.67-2.08-1.87c-0.48-0.68-0.83-1.28-1.44-2.35c0.05,0.01-1.74-3.18-2.31-4.67 c-0.01-0.03-0.02-0.06-0.03-0.09c-0.13-0.35-0.25-0.68-0.34-0.99c-0.76-2.63,0-5.48-0.45-9.11c-0.09-0.73-0.11-1.14-0.08-1.91 c0.28-0.25,0.73-0.52,1.47-0.64c1.5-0.24,2.97-0.12,2.97-0.12s-1.28-0.95-2.91-0.79c-0.07,0.01-0.15,0.01-0.22,0.02 c-0.63,0.08-1.03,0.35-1.28,0.67c0.05-0.96,0.14-2.39,0.24-4.79c-0.15-2.48,0.86-4.55,0.86-4.55c-0.85,1.82-0.68,4.06-0.68,4.06 l0.64,2.42c0.03,0.04,0.06,0.1,0.09,0.14l1.63,0.12c0,0,0.87-0.26,0.87-0.03c0,0.06,0.19,0.12,0.46,0.17 c-0.01-0.21,0.12-0.44,0.33-0.5c0.01-0.2,0.02-0.4,0.02-0.61c0.13,0.21,0.21,0.44,0.24,0.69c0.01-0.34,0.02-0.69,0.03-1.03 c0.2,0.54,0.39,1.07,0.59,1.61c0.01,0,0.02,0,0.03,0c-0.26-1.17-0.23-1.64-0.32-2.92c-0.03-0.49-0.22-0.68-0.04-1.14 c0.1,1.79,0.33,2.55,0.82,4.1c0.05,0,0.1,0.01,0.14,0.01c0-0.35,0-0.71,0-1.06c0.11,0.22,0.19,0.46,0.23,0.7 c-0.12-0.43-0.16-0.89-0.11-1.34c0.13,0.41,0.27,0.82,0.4,1.23c0.02-0.01,0.04-0.01,0.05-0.01c-0.18-0.77-0.34-1.55-0.44-2.34 c0.27,0.9,0.57,1.79,0.91,2.67c0,0,0,0.01,0.01,0.01l0.02,0c-0.47-1.83-0.92-3.72-0.62-5.59c-0.04,1.87,0.39,3.76,1.23,5.43 l0.09,0.12L3498,373l1.2,0.23l4.86,0.15c0,0-0.14-2.92,1.22-3.99c0,0,0,0.22,0.39,2.56c0.32,1.95,3.07,3.72,3.62,5.08 c0.79,1.95,2.1,1.95,2.42,2.34c0.06,0.59,0.15,1.18,0.3,1.75l0.83-1.64c0.39-0.29,0.88-0.5,1.47-0.49 c1.92,0.03,1.69,1.96,1.23,3.28c-0.45,1.32-1.67,3.82-3.36,4.36c-0.09,0.03-0.18,0.06-0.27,0.09c-0.1,1.04-0.15,1.67-0.15,1.67 s0.15,1.03-0.81,2.41c-0.12,1.42-0.21,2.54-0.28,3.46c1.49-0.29,3.68-0.71,6.06-1.01c0.83-2.3,1.34-4.4,1.03-5.58 c-0.95-3.65-1.52-4.57-0.76-10.41c0.69-5.28-0.8-8.92-2.96-13.1c-0.8-2.29-3.04-4.14-8.17-5.25c-6.59-1.43-11.24-0.92-14.4,1.66 c-4.06,2.69-5.29,4.6-5.83,9.04c-0.7,5.78,2.19,9.02,1.24,12.46c-0.17,0.6-0.27,1.14-0.33,1.65l-0.06,0.01 c-0.02,0.26-0.01,0.52,0,0.77c-0.06,1.97,0.62,3.35,1.23,5.03c0.06,0.16,0.11,0.32,0.16,0.48c0.14,0.73,0.24,1.54,0.24,2.44 C3488.11,392.81,3488.1,393.17,3488.07,393.56z M3514.05,370.01l0.05-0.17C3514.09,369.92,3514.07,369.98,3514.05,370.01 L3514.05,370.01z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M3498.85,361.92c-2.4,2.5-1.64,7.34-1.49,10.86c0.1,0.02,0.32,0.13,0.59,0.26 c0.67,0.35,1.64,0.92,1.64,0.92s1.95,0,3.88,0.09c1.78,0.08,3.95,2.43,4.18,3.49c0.68,3.14-1.56,5.07-2.78,8.44 c-0.84,2.31-0.69,6.24-2.75,9.98c-0.84,0.95-2.14,1.45-2.86,1.62c-2.17,0.52-3.72,0.04-3.72,0.04c0,0.2,0.01,0.39,0.01,0.58 c0.01,0.36,0.03,0.88,0.08,1.53c-0.12-1.22-0.11-1.88-0.1-2.11c0-0.07,0.01-0.1,0.01-0.1s-1.56-0.32-2.85-2.47 c-0.9-1.51-2.1-3.67-2.74-4.83c-0.27-0.49-0.44-0.81-0.44-0.81c0.93,1.93,1.5,3.65,1.22,7.23c-0.29,3.58,0.21,4.72,0.79,6.66 s0.86,6.44,0.86,6.44s0.18,0.22,0.36,0.53c0,0.01,0.01,0.01,0.01,0.02c0.17,0.29,0.35,0.65,0.41,1.02 c0.01-0.06,0.03-0.15,0.05-0.26c0.02-0.09,0.04-0.19,0.07-0.3l-0.11,0.66c0,0,4.46-1.3,6.4-4.56c-0.61-0.48-1.13-1.05-1.57-1.69 c0.3-0.87,1.5-4.17,3.45-6.19c1.7-1.77,4.66-4.07,6.02-5.1c1.06-0.66,2.09-1.39,2.83-2.14c0,0,0.42-0.5,0.78-1.06 c0,0,0.03-0.04,0.08-0.12c-0.03,0.05-0.05,0.09-0.08,0.14l0,0.08l0-0.08c-0.03,0.05-0.07,0.1-0.11,0.15 c-0.12,1.42-0.21,2.54-0.28,3.46c0.07-0.01-0.02,0.28,0.04,0.26l-0.18,2.48c0.68-0.23,7.23-3.75,11.93-4.09 c0.14-0.01,0.28-0.02,0.42-0.02c-1.58-0.08-3.58-0.01-6.13,0.29c0.81-2.27,1.31-4.34,1-5.51c-0.95-3.65-1.52-4.57-0.76-10.41 c0.46-3.5-0.05-6.28-1.07-8.98c-0.44-1.96-1.22-3.82-2.49-5.33c-0.04-0.05-0.08-0.11-0.13-0.16 C3510.89,360.05,3501.57,359.08,3498.85,361.92z M3515.84,380.41c0.06,0.61-0.1,1.32-0.3,1.91c-0.17,0.5-0.46,1.18-0.84,1.85 C3515.31,382.9,3515.92,381.51,3515.84,380.41z M3515.82,380.23c0-0.01,0-0.03-0.01-0.04 C3515.81,380.2,3515.81,380.21,3515.82,380.23z M3494.41,409.09C3494.42,409.09,3494.42,409.09,3494.41,409.09 C3494.42,409.09,3494.42,409.09,3494.41,409.09z M3496.68,402.67c0.05,0.12,0.1,0.25,0.15,0.37 C3496.78,402.92,3496.73,402.79,3496.68,402.67z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4BDAF",
    d: "M3532.91,336.87l1.59-7.79c0,0,4.74-5.88,7.34-7.07c2.6-1.19,7.88-3.62,10.98-3.23 c3.1,0.39,8.52,0.2,12.83,3.14s5.6,2.85,6.52,6.43s1.19,4.32,1.01,6.7c-0.18,2.39-3.61,21.49-3.61,21.49s-13.83,2.56-14.11,2.56 c-0.14,0-3.88-2.35-6.34-5.97c-2.28-3.36-3.3-8.01-3.3-8.01l-1.72-3.92l-5.36,1.38L3532.91,336.87"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3600.62,706.3c0,0,2.56,3.37-4.42,8.04c-6.98,4.67-8.35,3.84-11.22,6.29 c-2.87,2.44-23.79,6.33-58.63,10.98c-35.95,4.79-42.62,2.49-59.84-5.24c-17.37-7.8-1.32-4.82,64.79-15.08"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3590.72,487.61l-0.02,0.08c2.11,0.01,4.26,0.14,6.36,0.43C3597.07,488.12,3595.03,487.56,3590.72,487.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3549.7,373.05c0.08-0.18,0.16-0.36,0.25-0.53c-0.1,0.04-0.19,0.09-0.29,0.13 C3549.68,372.78,3549.69,372.91,3549.7,373.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4BDAF",
    d: "M3598.57,424.16c-1.39,5.34-2.29,26.36-3.42,33.62c-0.31,1.99-0.59,2.81-0.23,3.41 c0.36,0.6,1.31,0.98,0.81,3.49c-0.35,1.73-0.56,2.98-0.23,3.96c2.7-4.43,8.83-19.81,8.8-23.05c-0.04-5.38,0.19-13.97,0.4-22.35 C3604.21,423.57,3602.31,424.58,3598.57,424.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4BDAF",
    d: "M3590.7,487.69c0,0-1.27-0.05-2-0.02C3588.71,487.68,3590.03,487.68,3590.7,487.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4BDAF",
    d: "M3529.5,433.84c-4.16-1.84-10.49-4.51-12.32-8.93c-1.38,4.41-3.68,11.73-5.81,20.38 c0,0-8.5,9.44-17.35,17.03c-8.67,7.45-15.52,12.01-17.94,13.55c-0.79,0.23-1.51,0.42-2.18,0.58c-2.52,0.47-5.39,1.04-6.07,1.34 c-1.27,0.57-3.8,3.71-4.36,4.66c0,0,0.25,0.23,0.76,1.05c-0.05,0.17-0.11,0.33-0.18,0.46c-0.56,1.14-1.34,8.22-0.72,10.74 c0.34,1.37,0.08,0.38,1.18,2.6c1.1,2.21,2.48-0.24,2.97-0.43c0,0,1.04,1.2,1.8,1.71s3.02,0.24,3.02,0.24s1.63,0.99,2.56,0.51 c0.94-0.47,2.06-1.33,2.06-1.33s0.45,0.29,1.96-0.13c1.12-0.31,2-2.32,2.1-2.56l-1.18-0.71c-1.83,0-1.65-2.08-1.65-4.96 s0.65-3.86,2.48-3.86l1.38-0.91c0.41,0,0.79,0.12,1.15,0.33c0.66-0.59,1.58-1.2,2.87-1.73c5.3-2.14,16.98-8.98,23.64-13.05 c0.61-0.37,1.16-0.5,1.7-0.85c13.29-8.77,16.76-15.37,20.43-22.45c2.72-5.26,4.9-10.15,6.58-14.29 C3535.88,435.4,3533.8,435.35,3529.5,433.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M3584.34,695.08c1.12,1.81,4.28,6.4,7.32,5.64c3.78-0.94,7.71-3.05,7.71-3.05s0,0.53,0.11,1.32 c-0.2-2.16-0.04-4.19,0.06-5.12c-1.96,1.15-4.74,2.44-8.17,3.09C3588.51,697.5,3586.14,696.48,3584.34,695.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M3583.73,694.57c0,0.37,0.01,0.74,0.01,1.09l0.14-0.97C3583.82,694.65,3583.77,694.61,3583.73,694.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M3591.66,700.72c-3.04,0.76-6.21-3.82-7.32-5.64c-0.16-0.13-0.32-0.25-0.47-0.39l-0.14,0.97 c0.04,6.01,0.05,9.89,0.05,9.89c-0.52,0.19-1.04,0.36-1.55,0.52c0.01,0.1,0.02,0.19,0.03,0.29c0.5,0.23,3.99,1.8,7.03,2.9 c2.89,0.63,5.47,1.01,6.78,0.77c2.65-0.5,3.98-1.79,4.58-2.62c0.18-0.53,0.26-1.07,0.28-1.6c0.08-1.9-0.64-3.73-0.96-4.69 c-0.26-0.78-0.4-1.52-0.49-2.12c-0.11-0.79-0.11-1.32-0.11-1.32S3595.44,699.77,3591.66,700.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M3596.08,713.3c2.41-0.21,3.61-1.25,4.18-2.39C3599.55,712.09,3598.29,713.11,3596.08,713.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M3596.08,710.01c-1.31,0.25-3.89-0.14-6.78-0.77c-3.04-1.1-6.53-2.67-7.03-2.9 c-0.01-0.09-0.02-0.19-0.03-0.29c-8.33,2.56-15.53,1.11-20.95-1.27c0.6,1.9,2.03,4.52,5.39,5.49c3.89,1.13,7.49,0.9,10.27,0.23 c4.9-1.19,5.55-2.03,5.55-2.03l0.21,1.08c3.58,1.37,9.19,4.1,13.37,3.74c2.22-0.19,3.47-1.21,4.18-2.39 c1.14-1.92,0.84-4.27,0.84-4.27s-0.04,0.11-0.14,0.29c0.03-0.37,0.02-0.75-0.01-1.14c-0.02,0.54-0.11,1.07-0.28,1.6 C3600.05,708.22,3598.73,709.52,3596.08,710.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M3575.83,720.12c-5.55-0.23-12.77-0.6-30.81-2.85c-18.04-2.25-19.43-7.89-19.43-7.89 c-0.17-0.58-0.26-1.1-0.28-1.56c-0.08-0.01-0.14-0.01-0.14-0.01s-0.91,3.81,2.7,6.74c5.55,4.51,13.54,4.53,22.42,6.1 c8.88,1.58,24.14,2.4,29.14,1.73s5.83-1.8,5.55-5.18C3584.44,719.45,3581.38,720.35,3575.83,720.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M3582.49,708.48c0,0-0.65,0.83-5.55,2.03c-2.78,0.68-6.38,0.9-10.27-0.23 c-3.37-0.98-4.79-3.59-5.39-5.49c-2.16-0.95-4.04-2.05-5.59-3.1c-0.72,0.25-1.6,0.6-2.61,1.13c0,0-2.52,0.9-11.93,1.16 c-6.44,0.18-16.09-1.69-15.82,3.84c0.02,0.47,0.11,0.98,0.28,1.56c0,0,1.39,5.63,19.43,7.89c18.04,2.25,25.25,2.63,30.81,2.85 c5.55,0.23,8.6-0.68,9.16-2.93c0.56-2.25-1.67-4.43-1.67-4.43l-0.62-3.2L3582.49,708.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M3590.74,488.35c2.14-0.02,3.71,0.1,4.76,0.23c0.97,0.12,1.87-0.52,2.09-1.47 c0.35-1.57,0.63-3.94-0.17-5.95c-1.34-3.35-1.34-5.69-0.33-7.7c0.66-1.32-0.55-2.21-1.18-4.07c-0.33-0.98-0.51-2.23-0.16-3.96 c1-5.02-1.28-2.94-0.57-6.9c1.17-6.55,2.02-24.68,3.1-31.9c0.14-0.95,0.97-1.64,1.93-1.63c2.68,0.02,4.1-0.74,4.52-1.01 c0.09-0.06,0.14-0.1,0.14-0.1s0.57-11.26,0.26-18.97c-0.01-0.13,0-0.25,0.02-0.38c0.09-0.54,0.14-1.01,0.14-1.4 c0-4.02-6.68-26.11-12.6-27.69c-10.07-2.67-9.89-3.82-13.02-4.85c-1.02-0.33-2.05-0.69-3.09-1.03 c-0.27-0.09-0.51-0.24-0.72-0.43c-0.54-0.5-0.88-1.02-0.93-1.53c-0.12-1.51-2.44-3.12-4.63-3.08c-1.73,0.03-3.65-0.21-6.15,0.83 c-5.32,2.2-12.27,2.72-14.46,6.61c-0.1,0.17-0.25,1.49-0.32,1.68c-0.04,0.1-0.13,0.31-0.16,0.41c-0.35,1.04-0.25,1.23-0.47,2.05 c-0.06,0.21-0.1,0.66-0.15,1.06c-0.05,0.48-0.28,0.92-0.64,1.24c-0.36,0.32-0.72,0.63-1.08,0.95c-0.15,0.13-0.31,0.23-0.49,0.31 c-8.13,3.57-19.05,8.36-21.44,16.72c-3.9,13.66-6.19,18.12-8.28,24.49c-0.68,2.06-0.53,3.9,0.15,5.53 c1.82,4.39,7.52,7.3,11.67,9.14c0.06,0.03,0.13,0.05,0.19,0.07c4.25,1.46,7.26,0.46,9.74-2.06c0.23-0.23,0.45-0.47,0.67-0.72 c-0.69,5.6-3.21,26.54-3.21,33.47c0,7.37,0.22,18.03,0.31,27.91c0.01,1.29,1.28,2.19,2.51,1.79 c19.62-6.31,50.05-7.85,50.05-7.85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M3588.71,487.67c0,0-33.14,1.45-52.55,8.48c0,0-0.01,0.15-0.03,0.44l0.03-0.44c0,0-1.58,1.06-1.38,10.25 s0,12.52,0,12.52l0.11,0.09c-0.35,6.52-0.73,13.74-1.07,20.65c-1,20.41,7.03,64.58,9.03,78.3c2.01,13.72,9.42,54.32,8.08,65.7 c-1.34,11.38-0.28,13.87-0.28,13.87s1.81,1.98,5.04,4.17c1.55,1.05,3.43,2.15,5.59,3.1c5.42,2.38,12.62,3.83,20.95,1.27 c0.51-0.16,1.03-0.33,1.55-0.52c0,0-0.01-3.88-0.05-9.89c0-0.36,0-0.72-0.01-1.09c0.05,0.04,0.1,0.09,0.15,0.13 c0.15,0.13,0.31,0.26,0.47,0.39c1.8,1.4,4.16,2.42,7.04,1.87c3.43-0.65,6.21-1.94,8.17-3.09c2.06-1.21,3.21-2.26,3.21-2.26 c-1.67-15.73-13.72-99.08-13.72-99.08s1.34-34.13,5.35-58.9c4.02-24.76,2.68-45.51,2.68-45.51c-2.11-0.29-4.25-0.42-6.36-0.43 C3590.03,487.68,3588.71,487.67,3588.71,487.67z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3543.88,346.45c0.45,2.52-0.64,5.9-0.64,5.9C3544.72,350.9,3543.88,346.45,3543.88,346.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4BDAF",
    d: "M3569.57,356.54c-5.14-3.01-13.31,1.09-13.31,1.09s-9.03-3.71-9.23-10.86 c-0.19-7.11-4.94-7.63-6.56-5.21c-1.34,2.01-0.76-0.81-1.91-1.55c-2.69-1.73-4.97-3.16-5.66-3.14 c-0.29,2.8-0.06,5.69,0.75,8.52c0.16,0.56,0.2,1.12,0.21,1.66c-0.01,0.67-0.03,1.62,0.04,2.06c0.06,0.53,0.22,1.02,0.56,1.46 c1.09,1.38-0.35,3.78,1.26,7.57c0.86,2.02,1.24,3.94,1.48,5.41c0.05-0.61,12.51,9.82,12.45,9.1c0.1-0.04,0.19-0.09,0.29-0.13 c2.19-3.89,9.46-4.05,14.78-6.25c2.5-1.03,4.73-1.56,6.46-1.59C3569.86,362.02,3569.46,359.28,3569.57,356.54z M3543.88,346.45 c0,0,0.84,4.45-0.64,5.9C3543.24,352.35,3544.32,348.97,3543.88,346.45z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M3543.24,352.35c1.48-1.45,0.64-5.9,0.64-5.9C3544.32,348.97,3543.24,352.35,3543.24,352.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3479.01,490.11c0-2.88,1.48-5.22,3.31-5.22h-2.29c-1.83,0-3.31,2.34-3.31,5.22 c0,2.88,1.48,5.22,3.31,5.22h1.26h1.03C3480.49,495.33,3479.01,492.99,3479.01,490.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3482.01,484.9c-1.83,0-3.31,2.34-3.31,5.22c0,2.88,1.48,5.22,3.31,5.22c1.83,0,3.31-2.34,3.31-5.22 c0-2.24-0.9-4.15-2.16-4.89C3482.8,485.02,3482.42,484.9,3482.01,484.9z M3482.14,495.1c-2.41,0.83-2.01-5.23-2.01-5.23 l3.14,1.59C3483.27,491.45,3483.64,494.58,3482.14,495.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M3480.13,489.86c0,0-0.4,6.06,2.01,5.23c1.5-0.51,1.13-3.65,1.13-3.65L3480.13,489.86z"
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3466.25,480.54c-1.06,0.21-2.44,2.24-2.48,2.3c0,0,0,0.01,0,0.01c0.18,0.29,0.18,0.29,0.45,0.66 c0,0,0,0,0,0C3464.23,483.51,3464.88,481.84,3466.25,480.54z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3591.66,700.72c-3.04,0.76-6.21-3.82-7.32-5.64c-0.16-0.13-0.32-0.25-0.47-0.39l-0.14,0.97 c0.04,6.01,0.05,9.89,0.05,9.89c-0.52,0.19-1.04,0.36-1.55,0.52c0.01,0.1,0.02,0.19,0.03,0.29c0.5,0.23,3.99,1.8,7.03,2.9 c2.89,0.63,5.47,1.01,6.78,0.77c2.65-0.5,3.98-1.79,4.58-2.62c0.18-0.53,0.26-1.07,0.28-1.6c0.08-1.9-0.64-3.73-0.96-4.69 c-0.26-0.78-0.4-1.52-0.49-2.12c-0.11-0.79-0.11-1.32-0.11-1.32S3595.44,699.77,3591.66,700.72z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3582.49,708.48c0,0-5.6,3.04-11.59,2.27c-3.91-0.5-6.8-3.45-8.35-5.44c-2.57-1.01-4.79-2.25-6.59-3.45 c-1.63,1.23-6.53,4.55-12.66,5.17c-7.4,0.75-17.51,0.16-17.96,0.13c-0.01,0-0.02,0-0.02,0s-0.12,0.36-0.18,0.95 c-0.19,1.85,0.22,6,6.81,8.78c0.91,0.38,1.82,0.72,2.74,1.02c6.74,2.19,13.71,2.33,19.68,3.46c6.78,1.28,19.54,1.71,22.85,1.32 s7.73,0,8.04-3.71c0.32-3.71-0.51-4.66-1.65-6.4c-0.25-0.39-0.46-1-0.63-1.63C3582.66,709.76,3582.49,708.48,3582.49,708.48z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3543.81,445.2c8.32-8.42,16.9-18.54,11.99-15.96c-4.91,2.57-18.52,19.62-12.74,6.95 c5.78-12.66,18.78-21.3,11.6-17.29s-12.43,13.64-12.43,13.64s2.3-8.15,5.87-18.03c3.56-9.88,3.88-17.6-0.31-6.69 c-2.66,6.94-4.93,11.75-6.23,14.34c1.55-7.6,3.43-17.05,2.93-15.53c-0.83,2.49-3.33,9.88-3.12,6.65 c0.21-3.23-1.04-15.99-1.04-12.88c0,3.12-1.62,7.12-4.55,14.57c-3.8,9.65-6.27,14.96-9.4,19.65c-0.75-0.36-1.69-0.89-2.46-1.32 c-1.74,2.67-3.42,5.8-5.49,10.51c-2.43,6.34-37.49,31.16-40.39,31.9c-2.9,0.74-2.84,1.48-9.51,4.36 c-2.93,1.26-4.19,4.8-4.74,6.14c-0.2,0.49-0.34,1.05-0.45,1.68c-0.2,1.18-0.25,2.69-0.25,4.28c0,1.58,0.02,2.88,1.24,4.76 c0.4,0.61,0.46,1.17,1.27,1.3c0.55,0.09,1.89-1.38,1.89-1.38c1.26,1.33,1.51,1.6,2.17,1.88c0.69,0.29,2.66,0.08,2.66,0.08 s1.34,0.88,2.38,0.56c1.03-0.31,2.24-1.38,2.24-1.38s1.14,0.41,2.46-0.41c0.82-0.51,1.61-2.31,1.61-2.31s-0.55,0.1-1.27,0.02 c-1.21-0.13-2.73-1.62-2.95-4.38c-0.34-4.45,2.13-6,2.89-6.03c0.97-0.03,2.02-0.04,2.43-0.04c0.12,0,0.24,0.02,0.35,0.07 l0.71,0.27c0,0,1-0.82,1.82-1.24c0.53-0.27,0.65-0.29,4.06-1.86c1.31-0.6,2.82-1.47,4.69-2.44c0.21-0.11,0.43-0.22,0.65-0.34 c3.71-1.93,11-6.12,16.16-9.33c0.33-0.21,0.66-0.41,0.97-0.61c1.11-0.7,2.02-1.3,2.79-1.83c1.15-0.79,1.99-1.43,2.69-2 c0.88-0.72,1.51-1.3,2.35-1.89c2.67-1.91,5.63-5.57,8.48-9.52c0.67-0.93,1.26-1.76,1.61-2.45c0.43-0.85,0.9-1.75,1.37-2.67 c1-1.95,2.04-3.98,2.96-5.83c0.66-1.33,1.26-2.57,1.74-3.62c0.47-1.04,1.03-2.34,1.56-3.61c0.41-0.98,0.43-0.97,0.77-1.8 c0.01-0.01,0.7-0.68,0.71-0.69c0.19-0.21,0.36-0.42,0.51-0.62c-0.49,4.31-1.32,9.1-1.79,14.66c-0.45,5.26-1.09,10.63-1.36,16.4 c-0.12,2.68,0.02,5.68-0.04,8.37c-0.11,5.07-0.09,10.12,0.11,14.95c0.05,1.12,0.09,2.1,0.13,2.96 C3537.08,511.93,3535.81,453.31,3543.81,445.2z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3547.49,467.6C3545.57,468.95,3545.32,469.48,3547.49,467.6L3547.49,467.6z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3586.51,472.26c-9.37-2.01-26.1-5.35-36.47,3.01c0,0,23.09-6.02,34.13-0.33 c10.4,5.36,12.08,3.56,12.27,3.3c0.01-0.02,0,0,0,0s0.09-0.32,0.05-0.46c-0.06-0.23-0.07-0.69-0.1-1.26 c-0.05-0.91,0.13-1.88,0.84-3.42c0.09-0.19,0.07-1.11-0.2-1.32C3596.61,471.44,3593.73,473.81,3586.51,472.26z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3590.81,487.69l-0.1,0l-1.96-0.01c0,0-19.18,0.66-36.98,4.33c-5.33,1.1-11.08,2.38-15.6,4.13 c0,0,23.13,1.13,31.36,3.71c11.08,3.47,13.82,20.11,14.44,31.87c-0.23,1.25-0.46,2.62-0.71,4.17 c-1.21,7.43-2.96,30.21-4.88,36.14c-1.37,4.24-2,7.74-2.2,10.58c-0.65,2.55-3.07,11.93-5.5,19.45c-2.83,8.78,2.83-2.83,5.38-5.38 c2.55-2.55,2.27,6.52,3.12,13.88c0.85,7.37,4.25,11.05,4.25,11.05s-0.01-0.51-0.04-1.36c0,0.01,0,0.02,0,0.02 c1.49,10.76,1.33,42.54,1.77,50.51c0.44,7.98,0.8,23.81,0.8,23.81s0.22,0.42,0.73,0.94c1.4,1.43,4.75,2.95,12.47-0.19 c1.74-0.71,3.49-2.24,5.59-3.75c0,0-1.8-14-4.16-31.76c-3.45-25.92-7.99-59.36-9.51-67.08c-0.11-0.58,0.06-3.71,0.41-8.24 c0.93-11.97,2.01-33.84,3.93-44.07c2.88-15.36,4.75-41.13,3.64-52.32l-4.32-0.38l-0.76-0.03L3590.81,487.69z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3540.86,514.18c-4.47-10.97-4.73-16.39-4.7-17.91c0-0.04,0-0.08,0-0.11c0,0.04-0.01,0.08-0.01,0.12 C3535.02,513.13,3546.19,527.25,3540.86,514.18z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3605.34,403.18c0.01-0.4-0.02-0.43-0.02-0.43c0,0,0.04-0.4,0-0.32c-0.06-0.97-0.26-1.37-0.45-2.36 c-0.8-4.06-2.43-8.58-3.99-12.58c-1.02-2.62-1.88-4.34-2.13-4.8c-0.85-1.6-0.59,6.15-0.25,15.27 c0.93,25.3-21.51,32.06-14.07,57.88c0.32,1.11,0.25,1.93-0.08,2.52c-8.02-1.55-22.32-4.59-33.85,6.35 c-1.39,1.32-2.45,2.27-3.21,2.93c3.72-2.6,13.66-8.23,24.29-5.27c18.07,5.02,24.76,8.02,24.76,8.02s-0.19-0.18-0.38-0.97 c-0.04-0.19-0.26-0.76-0.3-1.02c0.11-0.24,0.51-0.79,1.21-2.33c0.47-1.05,1.2-2.51,1.8-3.9c2.37-5.5,5.59-13.71,5.64-16.57 c0.07-4.67,0.14-12.61,0.39-21.56c0-0.06,0.17-0.14,0.17-0.14c0.01-0.13,0.05-0.87,0.05-1c0.14-6.5,0.45-12.33,0.32-16.25 c-0.01-0.29-0.07-1.62-0.06-1.88C3605.28,403.96,3605.34,404.02,3605.34,403.18z"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.3,
    points: "3605.27,402.41 3605.27,402.41 3605.27,402.41  "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M3543.13,346.8c-0.27-0.65-0.54-0.99-1.24-1.72s-0.56-1.89-0.08-2.2c0.68-0.44,1.8,1.46,1.8,1.46 c-0.4-0.9-0.89-2.22-1.73-2.29c-0.84-0.07-1.05,0.84-1.13,1.39c-0.08,0.56,0.08,2.8,0.77,3.43c0.69,0.63,1-0.39,1.26,0.21 c0.26,0.6,0.46,1.11,0.46,1.11S3543.4,347.46,3543.13,346.8z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M3541.19,347.47C3541.19,347.47,3540.9,346.98,3541.19,347.47c0.3,0.49,0.73,1.33,0.62,2.43 c-0.12,1.1,0.33,1.56,0.52,0.88c0.19-0.68,0.47-2.35,0.15-2.68C3542.16,347.79,3541.74,348.19,3541.19,347.47z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M3534.21,349.49c0.77,0.4,1.38,0.91,1.11-0.17c-0.22-0.91-1.15-1.95-1.45-2.27 c-0.06-0.06-0.1-0.1-0.1-0.1c-0.27,0.72-0.12,1.64,0.14,2.16C3534,349.29,3534.1,349.43,3534.21,349.49z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M3549.7,373.05c-0.01-0.14-0.02-0.27-0.04-0.4c-0.07-0.43-0.2-0.81-0.4-1.11 c-2.23-3.34-4.35-10.97-6.05-13.77s-2.97-8.48-2.76-9.97c0.21-1.49-1.32-4.22,0.03-6.24c1.61-2.42,6.37-1.9,6.56,5.21 c0.19,7.16,9.23,10.86,9.23,10.86s8.17-4.1,13.31-1.09c0,0,0,0,0.01,0c0,0,4.35-16.82,5.66-20.85 c1.31-4.02,0.82-12.15,0.82-12.15s-0.6,2.66-1.15,4.01c-0.54,1.35-1.07-7.26-1.07-7.26s-0.07,1.15-1.24,2.88 c-1.17,1.73-0.84-0.26-7.34-3.98c-4.28-2.45-8.91-3.88-13.12-4.22c-2.19-0.17-4.26-0.05-6.12,0.38c0,0,4.35,0.29,6.69,0.75 c-0.75-0.13-8.11-1.13-17.7,8.46c0,0-3.53,4.86-5.49,10.89c0,0,1.72-2.91,3.11-4.01c0,0-1.55,5.02-1.55,9.1 c0,0,0.94-2.52,1.67-3.56c0.06-0.09,0.12-0.12,0.18-0.13c0.69-0.02,1.56,4.73,4.24,6.46c2.93,1.89-0.83,7.9-0.98,10.2 c-0.14,2.21,1.29,7.01,1.03,10.01c-0.01,0.12-0.02,0.24-0.03,0.36c-0.41,2.97,0.96,3.84,2.01,6.7c1.05,2.85,0.98,9.26,5.71,8.03 c1.85-0.48,3.08-1.42,3.84-2.48c0.22-0.82,0.5-1.76,0.85-2.8C3549.61,373.24,3549.66,373.15,3549.7,373.05z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3543.13,322.06c0,0,5.81-0.47,11.13,0.27c0.05,0.01,0.09,0.01,0.14,0.02c-2.64-0.05-8.91,0.43-14.82,4.52 c0,0,7.63,4.06,7.53,10.06c-0.1,6,12.24,15.97,14.07,18.74c0.05,0.08,0.1,0.16,0.15,0.23c1.7,2.67,2.16,4.84,2.16,4.84 s0.3,2.84-1.66,6.5c-1.41,2.65-4,5.72-8.74,8.47c-1.51,0.88,10.92-4.82,23.1-4.77c4.98,0.02,8.65,2.01,8.65,2.01 c-2.06-0.83-3.38-1.87-5.92-2.57c-3.3-0.91-3.53-1.52-4.18-3.21c0,0-0.32-1.74-3.08-2.5c-0.26-0.07-0.46-0.12-0.59-0.25 c-0.07-0.06-0.12-0.14-0.15-0.25c-0.02-0.08-0.05-0.17-0.07-0.25c-0.39-1.32-0.95-3.1-1.27-5.45c-0.08-0.61,0.03-1.27-0.01-1.95 c0,0,0.1-0.07,0.12-0.24c0.09-0.92,0.84-3.14,1.58-5.97c0.22-0.85,0.52-2.26,0.89-3.63c1.17-4.34,2.72-9.53,3.46-12.56 c0.9-3.67,0.43-10.59,0.43-10.59l-1.11,3.75c-0.11,0.55-0.33,0.41-0.37,0.11l-0.75-7.11c0,0,0.07,0.14,0.02,0.35 c-0.15,0.61-0.35,1.45-1.26,2.53c-0.44,0.51-0.33,1.34-1.9-0.15c-1.45-1.37-4.29-2.5-5.65-2.99c-0.44-0.16-0.87-0.36-1.29-0.57 C3561.97,318.55,3555.58,316.31,3543.13,322.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 3476.6743,
    y1: 490.1361,
    x2: 3482.2759,
    y2: 490.1361
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.3
    }
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_56_)",
    d: "M3478.96,490.14c0-2.88,1.48-5.22,3.31-5.22h-2.29c-1.83,0-3.31,2.34-3.31,5.22 c0,2.88,1.48,5.22,3.31,5.22h1.26h1.03C3480.45,495.35,3478.96,493.02,3478.96,490.14z"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3367.63,743.26c0.02,0.07,0.09,0.2,0.24,0.38c-0.07-0.27-0.11-0.55-0.11-0.83 C3367.63,743.04,3367.61,743.2,3367.63,743.26z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3512.54,782.18c0.55-1.38-0.24-3.1-2.34-5.11c-11.28-10.79-37.5-14.58-65.67-17.81 c-8.41-0.96-17.38-1.78-26.05-2.57c-6.02-0.55-11.49-1.06-16.44-1.57c16.77,2.17,53.39,7.15,74.81,11.83 c15.06,3.29,36.65,11.59,33.45,17.73C3511.7,783.64,3512.3,782.77,3512.54,782.18z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3424,723.81c-20.89,4.09-44.57,8.73-54.79,17.37c-0.87,0.73-1.28,1.28-1.46,1.63 c0,0.28,0.04,0.56,0.11,0.83c0.66,0.76,3.07,2.38,11.84,4.07c-3.98-5.5,6.37-12.41,26.46-17.65 c24.19-6.31,67.55-15.15,79.6-17.27c16.14-2.84,6.13-5.51-3.75-3.58c-4.58,0.89-10.14,1.73-16.76,3.04 c-4.93,2.38-10.54,4.48-16.95,6.25C3441.55,720.37,3433.03,722.04,3424,723.81z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3304.32,839.66c-0.08,0.21-7.62-3.59-8.17-4.04c-0.55-0.46-1.19-0.91-1.86-1.35 c-1.35-0.87-2.85-1.67-4.4-2.42c-3.11-1.49-6.41-2.77-9.76-3.93c-6.71-2.3-13.66-4.2-20.6-5.57 c-5.45-1.04-10.91-2.17-16.35-3.52c14.05,5.23,40.4,15.64,45.6,22.04c0.44-0.11,3.24,6.61,2.35,6.84 c-1.86,0.49-3.71,0.89-5.56,1.25c-7.38,1.41-14.72,2.19-22.05,2.82c-7.33,0.61-14.65,1.03-21.97,1.33 c-14.62,0.6-29.26,0.77-43.83,0.8l-43.69,0.17l-43.69,0.18l-5.46,0.02l-2.73,0.01c-0.94,0-1.89,0-2.85-0.03 c-3.82-0.1-7.75-0.4-11.78-1.37c-2.01-0.5-4.03-1.18-5.99-2.12c-1.91-0.92-3.75-2.08-5.39-3.48 c-17.79,2.21-26.21,8.51-6.78,11.34c26.86,3.91,152.07,5.54,214.75-1.16c18.55-1.98,23.96-6.45,24.43-11.17 C3308.88,842.84,3306.84,840.52,3304.32,839.66z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3297.66,837.36C3297.67,837.37,3297.67,837.37,3297.66,837.36L3297.66,837.36z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3222.97,804.57C3222.96,804.58,3222.96,804.58,3222.97,804.57L3222.97,804.57z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3517.02,783.28c0,0-0.09,0.06-0.25,0.16c-0.04,0.13-0.09,0.26-0.14,0.38c-1.4,3.49-5.68,6.34-13.07,8.73 c-5.75,1.85-13.43,3.43-22.84,4.7c-5.35,0.72-10.81,1.28-16.06,1.71c-2.3,0.2-4.6,0.38-6.91,0.54 c-7.31,0.49-14.61,0.84-21.97,0.89l-21.85,0.09l-87.38,0.35l-87.38,0.35c-3.47,0.01-6.93,0.3-10.21,0.99 c-1.62,0.35-3.22,0.81-4.5,1.42c-0.48,0.23-0.91,0.49-1.19,0.71c0.08,0.08,0.17,0.18,0.27,0.27c0.26,0.24,0.59,0.49,0.95,0.74 c2.65-0.41,6.88-0.88,13.6-1.37c11.68-0.85,109.58,1.4,130.78,1.4s84.16,4.2,134.21-6.42 C3533.88,792.36,3517.02,783.28,3517.02,783.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C1C",
    d: "M3223.27,804.28c0.28-0.22,0.71-0.48,1.19-0.71c1.28-0.61,2.88-1.07,4.5-1.42 c3.28-0.69,6.74-0.98,10.21-0.99l87.38-0.35l87.38-0.35l21.85-0.09c7.36-0.06,14.66-0.4,21.97-0.89 c2.3-0.16,4.61-0.34,6.91-0.54c5.25-0.43,10.71-0.99,16.06-1.71c9.41-1.27,17.09-2.85,22.84-4.7c7.4-2.38,11.67-5.24,13.07-8.73 c0.05-0.12,0.09-0.25,0.14-0.38c0.75-2.22,0.64-5.59-3.52-9.57c-12.27-11.74-39.27-15.69-68.22-19.01 c-8.47-0.97-17.46-1.79-26.16-2.58c-13.41-1.22-26.08-2.37-35.72-3.96c-1.25-0.21-2.39-0.41-3.45-0.62 c-8.77-1.7-11.18-3.31-11.84-4.07c-0.15-0.17-0.21-0.3-0.24-0.38c-0.02-0.06,0-0.22,0.13-0.46c0.18-0.36,0.59-0.9,1.46-1.63 c10.22-8.63,33.9-13.27,54.79-17.37c9.02-1.77,17.55-3.44,24.29-5.3c6.41-1.77,12.02-3.87,16.95-6.25 c36.09-17.4,35.16-49.74,34.32-78.68c-0.12-4.33-0.25-8.8-0.25-13.07c0-4.77-0.7-39.23-1.31-69.64 c-0.47-23.35-0.88-43.52-0.88-45.65c0-6.52-1.75-11.35-5.19-14.35c-4.33-3.77-9.68-3.08-9.9-3.05c-1.2,0.17-2.04,1.27-1.88,2.48 c0.16,1.2,1.27,2.04,2.47,1.9c0.04-0.01,3.66-0.43,6.45,2.04c2.41,2.13,3.63,5.82,3.63,10.98c0,2.17,0.41,22.36,0.88,45.73 c0.61,30.38,1.31,64.82,1.31,69.55c0,4.34,0.13,8.84,0.26,13.2c0.47,16.34,0.96,33.23-4.94,47.55 c-6.6,16.01-20.69,26.8-43.09,33c-6.58,1.82-15.02,3.48-23.96,5.23c-21.42,4.2-45.69,8.95-56.79,18.33 c-2.67,2.25-3.66,4.54-2.95,6.79c1.74,5.52,13.42,7.93,38.62,10.52c4.95,0.51,10.42,1.02,16.44,1.57 c8.67,0.79,17.64,1.6,26.05,2.57c28.17,3.23,54.39,7.02,65.67,17.81c2.1,2.01,2.89,3.73,2.34,5.11 c-0.24,0.6-0.83,1.47-2.25,2.49c-3.35,2.41-11.31,5.67-30.15,8.2c-4.17,0.56-8.4,1.02-12.55,1.4 c-3.37,0.29-6.74,0.54-10.11,0.75c-7.23,0.43-14.48,0.71-21.69,0.71l-21.84-0.09l-87.38-0.35l-87.38-0.35 c-3.8-0.02-7.64,0.25-11.5,1.03c-1.94,0.41-3.88,0.92-5.9,1.84c-1.01,0.49-2.07,1.05-3.15,2.08c-0.53,0.52-1.1,1.2-1.5,2.14 c-0.41,0.93-0.55,2.14-0.35,3.16c0.2,1.02,0.62,1.83,1.05,2.46c0.44,0.64,0.9,1.12,1.35,1.55c0.91,0.85,1.82,1.47,2.71,2.02 c1.79,1.09,3.57,1.9,5.36,2.64c3.56,1.45,7.14,2.56,10.72,3.57c1.74,0.48,3.47,0.94,5.21,1.37c5.44,1.35,10.9,2.48,16.35,3.52 c6.94,1.37,13.89,3.27,20.6,5.57c3.35,1.16,6.65,2.45,9.76,3.93c1.55,0.74,3.05,1.54,4.4,2.42c0.67,0.43,1.31,0.89,1.86,1.35 c0.55,0.46,1.01,0.93,1.28,1.31c0.09,0.12,0.14,0.21,0.18,0.29c-0.03,0.03-0.06,0.07-0.1,0.12c-0.26,0.27-0.76,0.64-1.37,0.97 c-0.6,0.34-1.3,0.66-2.04,0.95c-1.66,0.64-3.46,1.17-5.32,1.62c-1.49,0.36-3.03,0.68-4.56,0.97 c-6.94,1.27-14.12,1.98-21.29,2.55c-7.19,0.54-14.42,0.9-21.65,1.14c-14.49,0.48-28.99,0.53-43.54,0.45l-43.69-0.17l-43.69-0.18 l-5.46-0.02l-2.73-0.01c-0.88-0.01-1.75-0.02-2.61-0.04c-3.45-0.11-6.82-0.43-9.87-1.2c-3.06-0.77-5.72-2.03-7.86-3.9 c-2.15-1.86-3.83-4.38-5.12-7.28c-1.29-2.91-2.21-6.15-2.9-9.5c-0.69-3.35-1.15-6.82-1.49-10.32 c-0.67-7.02-0.84-14.19-0.83-21.37l0.17-43.68l0.35-87.38l0.17-43.69l0.01-2.75c0-0.96-0.01-1.93-0.04-2.9 c-0.06-1.95-0.19-3.93-0.45-5.95c-0.26-2.03-0.64-4.11-1.3-6.26c-0.67-2.14-1.63-4.4-3.21-6.52c-1.55-2.12-3.78-3.96-6.1-5.09 c-2.32-1.15-4.63-1.72-6.76-2.08c-2.14-0.35-4.16-0.49-6.1-0.57c-1.95-0.08-3.82-0.09-5.67-0.1l-0.04,0 c-3.05,0.01-5.52,2.48-5.51,5.53c0.01,3.05,2.48,5.52,5.53,5.51h0.01c3.58-0.01,7.1-0.01,10.02,0.45 c1.46,0.22,2.72,0.58,3.67,1.04c0.96,0.47,1.61,1.01,2.23,1.82c1.25,1.59,2.11,4.51,2.52,7.66c0.21,1.58,0.34,3.24,0.41,4.93 c0.03,0.85,0.05,1.7,0.06,2.56l0.01,2.71l0.17,43.69l0.35,87.38l0.17,43.7c0.05,7.38,0.28,14.79,1.05,22.27 c0.4,3.74,0.92,7.5,1.73,11.27c0.81,3.77,1.9,7.58,3.58,11.32c0.86,1.87,1.86,3.72,3.11,5.47c1.24,1.76,2.71,3.42,4.4,4.86 c0.05,0.04,0.09,0.07,0.14,0.11c1.65,1.4,3.49,2.56,5.39,3.48c1.96,0.94,3.99,1.62,5.99,2.12c4.02,0.98,7.96,1.28,11.78,1.37 c0.95,0.02,1.91,0.03,2.85,0.03l2.73-0.01l5.46-0.02l43.69-0.18l43.69-0.17c14.57-0.03,29.2-0.19,43.83-0.8 c7.32-0.3,14.64-0.72,21.97-1.33c7.33-0.64,14.67-1.42,22.05-2.82c1.85-0.36,3.7-0.76,5.56-1.25c1.86-0.49,3.73-1.05,5.63-1.82 c0.95-0.39,1.91-0.82,2.9-1.38c0.98-0.56,1.99-1.23,3-2.27c0.5-0.53,1-1.17,1.4-1.98c0.1-0.19,0.18-0.39,0.26-0.6 c0.26-0.67,0.42-1.43,0.44-2.19c0.03-1-0.19-1.94-0.49-2.71c-0.31-0.78-0.7-1.42-1.1-1.98c-0.81-1.1-1.67-1.89-2.52-2.6 c-0.85-0.7-1.71-1.29-2.57-1.84c-1.72-1.09-3.45-1.98-5.19-2.8c-3.48-1.63-6.99-2.95-10.52-4.15 c-7.08-2.37-14.23-4.26-21.59-5.65c-7.13-1.3-14.18-2.74-21.07-4.59c-3.43-0.93-6.83-1.97-10.02-3.24 c-1.58-0.64-3.13-1.34-4.45-2.14c-0.26-0.15-0.5-0.31-0.73-0.47c-0.36-0.25-0.69-0.5-0.95-0.74 C3223.44,804.46,3223.35,804.37,3223.27,804.28z M3297.66,837.36C3297.67,837.37,3297.67,837.37,3297.66,837.36L3297.66,837.36z  M3222.97,804.57C3222.96,804.58,3222.96,804.58,3222.97,804.57L3222.97,804.57z"
  }))), /*#__PURE__*/React.createElement("g", null, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3003.81,357.87c4.55-1.19,36.93-10.75,36.93-10.75s-57.78-7.03-59.53-7.29c-1.75-0.27-5.54,0.22-5.13,3.06 c0.13,0.91,0.44,2.98,0.79,5.23l0.02,0l1.28,8.25c3.64,0.54,6.77,0.96,9.47,1.26C2993.93,358.26,3000.97,358.62,3003.81,357.87z "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M2914.7,353.35l5.7,5.66l7.9,7.85c0,0,6.47-2.06,10.1-3.14c3.62-1.08,5.8-1.64,5.8-4.31 c0-0.3-0.08-0.76-0.2-1.34L2914.7,353.35z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M2938.34,340.94c-5.89,1.44-18.56,4.13-25.26,5.54c0.01,0,13.81,2.05,28.74,4.3 C2940.19,345.93,2938.34,340.94,2938.34,340.94z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M2908.71,347.4L2908.71,347.4l0.02,0C2908.71,347.4,2908.71,347.4,2908.71,347.4z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M3071.49,335.51c-7.79-1.25-109.25-16.72-122.55-17.25c-13.3-0.53-21.88,3.34-25.87,4.62 c-3.99,1.28-39.54,11.18-42.22,12.56c-4,2.05-5.48,6.52-5.79,8.38c0,0,0.01-0.01,0.01-0.01c0.04-0.39,0.43-0.77,1.15-1.12 c4.03-1.99,35.01-10.16,41.48-12.28c6.48-2.12,14-6.5,30.45-5.57c16.45,0.93,115.87,14.79,124.44,16.25 c5.15,0.88,6.82,2.04,6.55,3.17c0.01,0.01,0.02,0.02,0.03,0.03C3079.19,344.28,3080.49,336.96,3071.49,335.51z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2942.78,872.87l-4.02-0.39c-0.69-0.03-1.39-0.11-2.08-0.19l-22.65-2.18c-5.41-0.52-9.47-3.94-9.47-8 v-2.89c-48.17,6.72-96.75,13.49-99.26,13.78c-5.03,0.58-14.53,1.86-6.55,6.66c9.25,5.57,26.77,15.73,32.09,18.08 c5.32,2.36,8.69,2.69,13.94,1.79c34.12-5.88,163.98-27.51,189.21-32.41l-88.89,5.78 C2944.34,872.96,2943.55,872.94,2942.78,872.87z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B0B0",
    d: "M3042.23,864.78c1.42-0.75,2.1-1.55,2.28-2.37C3043.95,863.3,3043.18,864.11,3042.23,864.78z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3072.61,341.08c-8.58-1.46-107.99-15.32-124.44-16.25c-16.45-0.93-23.98,3.45-30.45,5.57 c-6.48,2.12-37.46,10.29-41.48,12.28c-0.72,0.36-1.11,0.73-1.15,1.12c-0.18,1.74,6.58,3.88,22.81,6.67 c4.3,4.46,25.98,31.73,32.09,39.43l8.13-0.81c2.04-0.26,5.31-0.26,5.84-0.37l1.79,0.13c0.68,0,1.28,0.03,1.75,0.1l36.1,2.56 l0.02,0.02l0.02,0.01l0-0.01l0-0.02l0.14,0.01l-4.65-29.28c0,0,0.73,0.09,1.94,0.24c2.08,0.27,5.91,0.81,11.84,1.76 c3.2,0.51,12.66,1.94,18.06,1.19c5.2-0.73,13.53-2.86,20.88-5.11c7.35-2.26,40.96-12.34,44.63-13.94 c1.47-0.64,2.52-1.38,2.7-2.14C3079.44,343.12,3077.76,341.95,3072.61,341.08z M2943.65,356.58l-0.03,0l-30.2-4.5l-0.13-0.02 l-4.58-4.66l0,0c0,0,0.01,0,0.02,0l4.34-0.91l0,0c6.7-1.41,19.38-4.11,25.26-5.54c0,0,1.85,4.99,3.48,9.84 c0.06,0.01,0.11,0.02,0.17,0.03L2943.65,356.58z M2938.4,363.72c-3.62,1.08-10.1,3.14-10.1,3.14l-7.9-7.85l-5.7-5.66l29.3,4.72 c0.13,0.58,0.2,1.04,0.2,1.34C2944.2,362.08,2942.03,362.64,2938.4,363.72z M3046.69,350.57c-2.8,1.46-22.4,6.64-34.83,10.49 c-12.43,3.85-16.1,2.65-22.4,1.86c-1.28-0.16-5.14-0.69-10.5-1.42l-0.8-5.13c2.18,0.4,5.69,0.88,9.47,1.26 c-2.7-0.3-5.83-0.71-9.47-1.26l-1.28-8.25l-0.02,0c-0.34-2.25-0.66-4.31-0.79-5.23c-0.41-2.84,3.38-3.32,5.13-3.06 c1.75,0.27,59.53,7.29,59.53,7.29C3045.99,348.05,3049.49,349.11,3046.69,350.57z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M2945.74,388.86l-1.79-0.13c-0.53,0.11-3.8,0.11-5.84,0.37C2940.6,389.07,2943.59,388.84,2945.74,388.86 z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M2983.59,391.51l-36.1-2.56c-0.47-0.07-1.07-0.09-1.75-0.1l37.87,2.67L2983.59,391.51z"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "2983.62,391.53 2983.76,391.54 2983.76,391.52 2983.62,391.51  "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M2983.62,391.53l0,0.01l-0.02-0.01l-37.87-2.67c-2.15-0.01-5.14,0.22-7.62,0.24l-8.13,0.81l-18.36,1.83 l22.99-2.22c3.95-0.34,5.87-0.33,7.59,0.43c4.29,1.9,4.65,4.38,4.65,10.57s-0.25,459.32-0.25,462.72c0,8.27-3.77,9.45-7.84,9.25 l4.02,0.39c0.77,0.07,1.56,0.09,2.34,0.04l88.89-5.78l1.64-0.11c2.57-0.17,4.85-0.99,6.59-2.24c0.94-0.68,1.72-1.48,2.28-2.37 c0.66-1.04,1.04-2.21,1.04-3.43V403.2c0-3.87-3.7-7.2-8.82-7.92l-52.98-3.74L2983.62,391.53z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 2904.5715,
    y1: 630.8427,
    x2: 3045.5547,
    y2: 630.8427
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1019,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2683,
    style: {
      stopColor: "#222221",
      stopOpacity: 0.2268
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3384,
    style: {
      stopColor: "#161616",
      stopOpacity: 0.2038
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4571,
    style: {
      stopColor: "#090909",
      stopOpacity: 0.1648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6143,
    style: {
      stopColor: "#020202",
      stopOpacity: 0.1132
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9595,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_57_)",
    d: "M2983.62,391.53l0,0.01l-0.02-0.01l-37.87-2.67c-2.42-0.23-5.03-0.05-7.62,0.24l-8.13,0.81 l-18.36,1.83l22.99-2.22c3.95-0.34,5.75-0.55,7.46,0.21c4.29,1.9,4.77,4.6,4.77,10.79s-0.25,459.32-0.25,462.72 c0,8.27-3.77,9.45-7.84,9.25l4.02,0.39c0.77,0.07,1.56,0.09,2.34,0.04l88.89-5.78l1.64-0.11c2.57-0.17,4.85-0.99,6.59-2.24 c0.94-0.68,1.72-1.48,2.28-2.37c0.66-1.04,1.04-2.21,1.04-3.43V403.2c0-3.87-3.7-7.2-8.82-7.92l-52.98-3.74L2983.62,391.53z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B0B0",
    d: "M2936.68,872.3c0.69,0.08,1.39,0.16,2.08,0.19l-24.72-2.37L2936.68,872.3z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M2914.04,870.11l24.72,2.37c4.08,0.2,7.84-0.97,7.84-9.25c0-3.4,0.25-456.53,0.25-462.72 s-0.36-8.67-4.65-10.57c-1.72-0.76-3.64-0.77-7.59-0.43l-22.99,2.22c-4.24,1.18-7.05,4.19-7.05,7.55v459.93v2.89 C2904.57,866.17,2908.62,869.6,2914.04,870.11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 2904.5715,
    y1: 630.9042,
    x2: 3045.5547,
    y2: 630.9042
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1019,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2683,
    style: {
      stopColor: "#222221",
      stopOpacity: 0.2268
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2761,
    style: {
      stopColor: "#2C2C2B",
      stopOpacity: 0.2355
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3148,
    style: {
      stopColor: "#585857",
      stopOpacity: 0.2788
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3575,
    style: {
      stopColor: "#80807F",
      stopOpacity: 0.3266
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4033,
    style: {
      stopColor: "#A2A2A2",
      stopOpacity: 0.3778
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4531,
    style: {
      stopColor: "#BFBFBF",
      stopOpacity: 0.4335
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5081,
    style: {
      stopColor: "#D7D7D7",
      stopOpacity: 0.4951
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5707,
    style: {
      stopColor: "#E9E9E9",
      stopOpacity: 0.565
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6452,
    style: {
      stopColor: "#F6F6F5",
      stopOpacity: 0.6484
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7436,
    style: {
      stopColor: "#FDFDFD",
      stopOpacity: 0.7585
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9595,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_58_)",
    d: "M2914.04,870.11l24.72,2.37c4.08,0.2,7.84-0.97,7.84-9.25c0-3.4,0.25-456.53,0.25-462.72 s-0.36-8.67-4.65-10.57c-1.72-0.76-3.64-0.77-7.59-0.43l-22.99,2.22c-4.24,1.18-7.05,4.19-7.05,7.55v459.93v2.89 C2904.57,866.17,2908.62,869.6,2914.04,870.11z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2914.04,870.11l24.72,2.37c4.08,0.2,7.84-0.97,7.84-9.25c0-3.4,0.25-456.53,0.25-462.72 s-0.16-8.9-4.45-10.79c-1.72-0.76-3.83-0.54-7.79-0.21l-22.99,2.22c-4.24,1.18-7.05,4.19-7.05,7.55v459.93v2.89 C2904.57,866.17,2908.62,869.6,2914.04,870.11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 2908.7087,
    y1: 352.7448,
    x2: 3047.6807,
    y2: 352.7448
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_59_)",
    d: "M3006.9,357.11c2.98-0.66,33.84-9.99,33.84-9.99s-32.38,9.56-36.93,10.75 c-2.84,0.74-9.88,0.38-16.18-0.25C3002.63,359.31,3004.38,357.67,3006.9,357.11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 2908.7087,
    y1: 351.5274,
    x2: 3047.6807,
    y2: 351.5274
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_60_)",
    d: "M2913.07,346.48c-2.5,0.53-4.16,0.87-4.34,0.91l-0.02,0l4.71,4.68l30.2,4.5 c-0.45-1.63-1.11-3.69-1.81-5.79C2926.88,348.54,2913.08,346.48,2913.07,346.48z"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E5D5B",
    points: "2913.28,352.06 2913.42,352.08 2908.71,347.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 2908.7087,
    y1: 349.7363,
    x2: 3047.6807,
    y2: 349.7363
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_61_)",
    points: "2913.28,352.06 2913.42,352.08 2908.71,347.4  "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M3040.74,347.12c0,0-30.87,9.32-33.84,9.99c-2.52,0.56-4.26,2.2-19.27,0.51 c-3.78-0.38-7.29-0.86-9.47-1.26l0.8,5.13c5.36,0.74,9.22,1.26,10.5,1.42c6.3,0.8,9.98,1.99,22.4-1.86 c12.43-3.85,32.03-9.03,34.83-10.49C3049.49,349.11,3045.99,348.05,3040.74,347.12z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 2908.7087,
    y1: 355.4319,
    x2: 3047.6807,
    y2: 355.4319
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_62_)",
    d: "M3040.74,347.12c0,0-30.87,9.32-33.84,9.99c-2.52,0.56-4.26,2.2-19.27,0.51 c-3.78-0.38-7.29-0.86-9.47-1.26l0.8,5.13c5.36,0.74,9.22,1.26,10.5,1.42c6.3,0.8,9.98,1.99,22.4-1.86 c12.43-3.85,32.03-9.03,34.83-10.49C3049.49,349.11,3045.99,348.05,3040.74,347.12z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M2943.62,356.57l0.03,0l-1.67-5.77c-0.06-0.01-0.11-0.02-0.17-0.03 C2942.52,352.88,2943.17,354.95,2943.62,356.57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 2908.7087,
    y1: 353.6778,
    x2: 3047.6807,
    y2: 353.6778
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_63_)",
    d: "M2943.62,356.57l0.03,0l-1.67-5.77c-0.06-0.01-0.11-0.02-0.17-0.03 C2942.52,352.88,2943.17,354.95,2943.62,356.57z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5D5B",
    d: "M2913.07,346.48l-4.34,0.91C2908.91,347.36,2910.58,347.01,2913.07,346.48L2913.07,346.48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 2908.7087,
    y1: 346.9386,
    x2: 3047.6807,
    y2: 346.9386
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2766,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3554,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5743,
    style: {
      stopColor: "#1C1C1B",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7365,
    style: {
      stopColor: "#1E1E1D",
      stopOpacity: 0.9381
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#252524",
      stopOpacity: 0.9518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    style: {
      stopColor: "#30302F",
      stopOpacity: 0.9616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    style: {
      stopColor: "#414140",
      stopOpacity: 0.9695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#575756",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9248,
    style: {
      stopColor: "#727272",
      stopOpacity: 0.9823
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    style: {
      stopColor: "#939392",
      stopOpacity: 0.9878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.9928
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#E1E1E1",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_64_)",
    d: "M2913.07,346.48l-4.34,0.91C2908.91,347.36,2910.58,347.01,2913.07,346.48L2913.07,346.48z"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1351.43,
    y: 190,
    fill: "#659896",
    width: 430,
    height: 770
  }), /*#__PURE__*/React.createElement("g", {
    id: "scribble_2_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#27BAE1",
    d: "M803.4,491.57l-2.62,0.23l-1.31,0.13l-0.67,0.07c-0.12,0.02-4.07,0.22-4.22,0.25l0.25,0.92l0.04,1.46 c0.13-0.03,3.98-0.77,4.22-0.82l0.63-0.13l1.28-0.24l2.57-0.46l5.16-0.89l10.33-1.74l-10.45,0.8L803.4,491.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27BAE1",
    d: "M600.16,449.99c-0.26,0.95-0.6,1.95-0.97,2.79l-0.07,0.16l-0.03,0.12c-0.9,3.35-2.11,6.77-3.36,10.11 c-1.27,3.34-2.63,6.66-4.17,9.85c-0.79,1.59-1.59,3.11-2.57,4.52c-0.97,1.44-2.04,2.74-3.29,3.72c-2.47,1.99-5.98,2.46-9.5,2.56 l-21.82,0.22l-5.46,0.05l-0.68,0.01c-0.18-0.01-0.3-0.04-0.46-0.04c-0.15-0.03-0.3-0.1-0.46-0.14c-0.16-0.06-0.31-0.16-0.47-0.24 c-0.63-0.38-1.24-0.94-1.8-1.56c-2.22-2.59-3.85-5.85-5.46-9.05l-0.28-0.56l-0.59,0.04c-1.66,0.1-3.27,0.29-4.91,0.63 c-0.41,0.08-0.82,0.18-1.23,0.3c-0.09,0.02-0.23,0.07-0.38,0.13c-0.15,0.05-0.26,0.13-0.39,0.2c-0.23,0.15-0.43,0.31-0.61,0.47 c-0.69,0.65-1.15,1.33-1.62,1.99c-0.92,1.32-1.79,2.6-2.83,3.71c-1.03,1.11-2.23,2.02-3.6,2.53c-0.68,0.26-1.4,0.41-2.14,0.47 l-0.55,0.03l-0.6,0.01l-1.2,0.01c-1.6,0.01-3.2,0.01-4.79-0.03c-3.18-0.07-6.37-0.26-9.48-0.8c-1.56-0.26-3.1-0.61-4.58-1.12 c-1.48-0.5-2.93-1.13-4.17-2.01c-1.25-0.89-2.26-2.08-3.01-3.42c-0.76-1.35-1.26-2.83-1.63-4.36c-0.37-1.52-0.59-3.09-0.79-4.66 l-0.64-4.72c-0.37-3.15-0.58-6.32-0.69-9.49l-0.01-0.33l-0.28,0.17c-1.36,0.86-2.75,1.69-4.17,2.46 c-1.42,0.77-2.85,1.54-4.38,2.02c-0.75,0.24-1.58,0.14-2.39,0.14c-0.81-0.02-1.62-0.08-2.42-0.16c-1.6-0.19-3.05-0.39-4.72-1.08 c1.5,0.62,3.1,0.95,4.71,1.17c0.81,0.1,1.61,0.18,2.43,0.21c0.41,0.03,0.81,0.03,1.22,0.04c0.4,0.03,0.84-0.03,1.22-0.14 c1.57-0.46,3.02-1.21,4.46-1.95c1.34-0.7,2.65-1.45,3.95-2.23c0.05,3.08,0.2,6.15,0.5,9.22l0.55,4.74 c0.17,1.58,0.37,3.17,0.72,4.75c0.35,1.57,0.84,3.14,1.62,4.59c0.77,1.45,1.85,2.77,3.19,3.77c1.35,1,2.86,1.67,4.39,2.23 c1.54,0.56,3.12,0.95,4.72,1.25c3.19,0.61,6.42,0.86,9.64,1c1.61,0.07,3.22,0.1,4.83,0.12l1.2,0.01l0.6,0.01l0.65-0.02 c0.86-0.05,1.73-0.22,2.55-0.51c1.65-0.58,3.08-1.64,4.24-2.84c1.17-1.2,2.12-2.55,3.05-3.83c0.46-0.63,0.93-1.26,1.42-1.7 c0.12-0.11,0.24-0.2,0.34-0.26c0.05-0.02,0.11-0.07,0.15-0.07c0.04-0.01,0.08-0.03,0.19-0.06c0.36-0.09,0.73-0.18,1.11-0.25 c1.31-0.25,2.68-0.39,4.03-0.47c1.49,3.09,2.99,6.22,5.3,9.03c0.64,0.73,1.35,1.44,2.27,2.02c0.25,0.13,0.47,0.28,0.74,0.39 c0.28,0.09,0.55,0.2,0.84,0.27c0.3,0.04,0.63,0.09,0.9,0.1l0.68,0.01l5.46,0.05l21.87,0.19c1.87-0.02,3.77-0.14,5.7-0.53 c1.92-0.38,3.88-1.19,5.52-2.42c1.63-1.24,2.9-2.77,3.99-4.3c1.11-1.55,2.04-3.22,2.88-4.85c1.68-3.29,3.12-6.65,4.49-10.04 c1.32-3.36,2.58-6.69,3.62-10.24c0.48-1.08,0.83-2.08,1.16-3.15c0.32-1.11,0.6-2.23,0.75-3.41c0.15-1.18,0.23-2.39,0.09-3.65 c-0.02-0.13-0.04-0.27-0.06-0.4l0.88-0.17l2.02-0.39l8.11-1.53c5.41-1.01,10.82-1.98,16.24-2.94 c10.83-1.95,21.67-3.79,32.53-5.47l8.15-1.23c2.49-0.39,4.99-0.7,7.58-1.21l-0.01,0.12c6.67,0.48,13.38,1.01,20,1.78 c0.83,0.09,1.65,0.2,2.47,0.31l1.22,0.18l0.61,0.09l0.54,0.1c1.43,0.3,2.8,0.9,4.07,1.73c1.27,0.83,2.42,1.87,3.45,3.04 c0.74,0.84,1.45,1.79,2.05,2.74c-7.18,4.84-14.6,9.44-22.24,13.53c-2.01,1.07-4.05,2.1-6.1,3.05c-2.03,0.92-4.16,1.65-6.33,2.26 c-4.35,1.22-8.86,1.97-13.39,2.49c-4.54,0.51-9.11,0.76-13.68,0.79c-4.57,0.02-9.16-0.14-13.68-0.71 c-4.51-0.54-8.84-2.13-12.97-4.06c-2.07-0.97-4.09-2.04-6.07-3.18c-0.99-0.57-1.97-1.16-2.95-1.75l-1.46-0.9 c-0.45-0.27-0.86-0.54-1.36-0.79l4.4-8.44l-4.76,8.43l-0.08,0.14l0.17,0.09c0.95,0.51,1.92,1.2,2.88,1.8 c0.97,0.62,1.94,1.23,2.92,1.83c1.97,1.19,3.98,2.31,6.04,3.34c4.12,2.04,8.49,3.76,13.12,4.43c4.58,0.69,9.2,0.95,13.81,1.04 c4.62,0.07,9.24-0.07,13.85-0.48c4.61-0.42,9.21-1.08,13.73-2.23c2.26-0.58,4.5-1.29,6.67-2.22c2.14-0.93,4.22-1.92,6.29-2.96 c8.25-4.18,16.16-8.86,23.92-13.88l1.04-0.67l-0.55-1.11c-0.43-0.88-0.87-1.59-1.37-2.34c-0.49-0.74-1.03-1.45-1.6-2.13 c-1.15-1.36-2.46-2.62-3.98-3.67c-1.51-1.04-3.24-1.86-5.09-2.3l-0.7-0.15l-0.63-0.11l-1.27-0.21c-0.84-0.13-1.68-0.26-2.52-0.38 c-3.74-0.52-7.47-0.96-11.2-1.36l7.36-2.6c5.2-1.82,10.34-3.77,15.54-5.4c5.21-1.64,10.5-3.08,15.82-4.39 c10.64-2.67,21.45-4.74,32.24-6.95c5.4-1.1,10.8-2.18,16.16-3.54c2.67-0.68,5.34-1.42,7.95-2.34c1.3-0.47,2.6-0.95,3.85-1.53 c0.63-0.29,1.25-0.6,1.85-0.94c0.59-0.36,1.2-0.71,1.65-1.23c-0.48,0.49-1.1,0.81-1.7,1.13c-0.61,0.3-1.24,0.58-1.88,0.83 c-1.27,0.51-2.59,0.91-3.9,1.31c-2.64,0.76-5.31,1.39-8,1.94c-5.38,1.1-10.82,1.96-16.24,2.87c-10.87,1.76-21.75,3.59-32.55,5.94 c-5.4,1.2-10.77,2.54-16.09,4.1c-5.34,1.56-10.55,3.37-15.75,5.14l-7.8,2.65c-2.44,0.8-4.86,1.59-7.26,2.12 c-0.05,0-0.1-0.01-0.14-0.01l0,0.05c-0.11,0.02-0.22,0.05-0.32,0.08c-2.56,0.51-5.32,0.8-8.05,1.2 c-2.74,0.36-5.46,0.78-8.19,1.17c-10.91,1.64-21.79,3.44-32.65,5.35c-5.43,0.98-10.85,1.98-16.26,3.01l-8.12,1.57l-2.03,0.4 l-1.01,0.2l-0.37,0.07l-0.28-0.44c-0.42-0.63-0.87-1.23-1.36-1.82c-0.99-1.16-2.15-2.24-3.59-3.07 c-0.71-0.42-1.52-0.73-2.35-0.96c-0.83-0.22-1.81-0.27-2.42-0.29c-2.77-0.11-5.53-0.19-8.29-0.25 c-5.52-0.13-11.04-0.19-16.57-0.16c-2.77,0.02-5.53,0.06-8.3,0.17c-2.78,0.13-5.53,0.21-8.39,0.6c-2.83,0.38-5.64,1.08-8.32,2.18 c-1.34,0.56-2.64,1.23-3.87,2.03c-0.61,0.41-1.21,0.85-1.79,1.34c-0.14,0.13-0.29,0.25-0.43,0.39l-0.28,0.27 c-0.04,0.04-0.12,0.07-0.2,0.08l-3.39-0.12l-0.09,0l-0.03,0c-0.18,0.02-0.37-0.08-0.45-0.23c-0.01,0.04-0.13-0.45-0.24-0.77 c-0.12-0.34-0.24-0.69-0.4-1.02c-0.59-1.33-1.53-2.7-3.02-3.49c-0.72-0.4-1.61-0.58-2.26-0.65c-0.69-0.09-1.36-0.16-2.03-0.21 c-1.34-0.11-2.66-0.18-3.98-0.24c-5.29-0.24-10.57-0.28-15.86-0.21c-1.32,0.02-2.64,0.05-3.97,0.11 c-1.31,0.03-2.75,0.2-4.05,0.63c-1.31,0.42-2.56,1.04-3.66,1.83c-0.56,0.39-1.08,0.82-1.58,1.28c-0.25,0.23-0.48,0.47-0.71,0.72 c-0.25,0.28-0.39,0.46-0.61,0.57c-0.45,0.23-1,0.2-1.47-0.16c-0.56-0.35-1.12-0.72-1.7-1.04c-1.14-0.68-2.33-1.26-3.54-1.81 c-2.23-1-4.56-1.8-6.95-2.26c0.34-0.45,0.69-0.88,1.08-1.3c2.53-2.64,5.63-4.74,8.87-6.51c3.25-1.78,6.68-3.24,10.16-4.56 c6.96-2.65,14.17-4.68,21.42-6.48c7.25-1.83,14.58-3.37,21.94-4.77c14.72-2.82,29.55-5.07,44.42-7.1c3.71-0.52,7.44-1,11.16-1.49 l5.58-0.7l2.81-0.36c1-0.14,1.99-0.31,2.98-0.56c1.97-0.49,3.89-1.23,5.67-2.16c1.78-0.94,3.43-2.07,4.97-3.26 c1.54-1.19,2.98-2.46,4.38-3.7l4.21-3.72c5.6-4.96,11.25-9.82,17.07-14.46c5.84-4.61,11.84-9.01,18.09-13.02 c6.25-4.01,12.76-7.61,19.53-10.62c3.37-1.52,6.85-2.81,10.37-4c3.52-1.2,7.1-2.23,10.7-3.18c7.22-1.89,14.55-3.39,21.93-4.66 c7.38-1.25,14.82-2.23,22.27-3.08c7.46-0.84,14.94-1.49,22.43-2c7.49-0.49,15-0.9,22.51-1.23c-15.04-0.07-30.08,0.42-45.1,1.59 c-7.51,0.57-15,1.43-22.47,2.49c-1.06,0.16-2.13,0.32-3.19,0.49c-1.81,0.22-3.63,0.45-5.44,0.7c-2.55,0.37-5.11,0.75-7.65,1.19 c-1.52,0.24-3.04,0.51-4.56,0.79c0.47-0.23,0.94-0.46,1.42-0.69l23.92-11.45l11.99-5.71c3.98-1.95,8.01-3.78,11.97-5.83 c-8.52,2.55-16.91,5.53-25.15,8.86c-8.27,3.26-16.37,6.92-24.38,10.76c-4.52,2.18-9,4.46-13.43,6.82 c-4.03,0.9-8.05,1.82-12.06,2.81c-5,1.25-9.98,2.6-14.94,3.97c-2.48,0.69-4.95,1.45-7.42,2.18c-2.47,0.73-4.93,1.49-7.39,2.26 c-4.91,1.57-9.78,3.23-14.65,4.9c-4.84,1.78-9.67,3.54-14.46,5.47c5.04-1.13,10.02-2.43,15-3.71l7.48-1.9l7.45-1.95 c5-1.2,9.93-2.61,14.92-3.82c4.33-1.1,8.65-2.24,13-3.3c-5.68,2.63-11.16,5.66-16.45,8.96c-6.43,4.01-12.6,8.39-18.52,13.06 c-5.92,4.67-11.65,9.56-17.28,14.51c-5.73,4.85-10.86,10.47-17.65,12.03c-0.84,0.22-1.69,0.37-2.55,0.49l-2.78,0.36l-5.6,0.72 c-3.73,0.51-7.46,1-11.19,1.54c-7.46,1.04-14.89,2.26-22.31,3.51c-7.42,1.27-14.83,2.62-22.2,4.2 c-14.72,3.16-29.45,6.73-43.48,12.46c-3.49,1.45-6.92,3.1-10.18,5.05c-3.25,1.96-6.35,4.24-8.9,7.11 c-2.51,2.94-4.65,7.33-5.51,10.98c-0.82,3.67-1.58,10.84-0.05,11.56c-0.06-3.73,0.29-8.63,1.29-12.19 c0.83-2.99,2.1-5.89,3.96-8.33c2.36,0.6,4.63,1.52,6.78,2.62c1.16,0.6,2.3,1.25,3.39,1.96c0.56,0.34,1.08,0.73,1.62,1.09 c0.55,0.47,1.51,0.66,2.25,0.29c0.19-0.09,0.36-0.2,0.51-0.34l0.36-0.36c0.23-0.22,0.46-0.44,0.7-0.65 c0.48-0.41,0.99-0.79,1.53-1.13c1.06-0.69,2.23-1.2,3.44-1.53c1.23-0.33,2.43-0.44,3.75-0.43c1.31-0.01,2.62,0.01,3.93,0.03 c5.25,0.12,10.51,0.38,15.74,0.76c1.3,0.1,2.61,0.21,3.9,0.35c0.64,0.07,1.29,0.15,1.9,0.25c0.65,0.1,1.07,0.21,1.51,0.46 c0.85,0.47,1.49,1.38,1.92,2.44c0.11,0.26,0.2,0.54,0.29,0.81c0.11,0.3,0.08,0.47,0.34,1.1c0.48,1.04,1.62,1.71,2.76,1.66 l-0.12,0l3.5,0.22l0.05,0l0.07,0c0.6-0.02,1.2-0.22,1.7-0.6l0.82-0.72c0.48-0.39,1-0.75,1.53-1.1c1.08-0.68,2.25-1.24,3.46-1.72 c1.21-0.47,2.47-0.84,3.75-1.16c1.29-0.28,2.58-0.53,3.9-0.67c2.61-0.3,5.37-0.33,8.1-0.4c2.73-0.04,5.48-0.05,8.22-0.04 c5.49,0.04,10.98,0.17,16.47,0.37c2.74,0.1,5.49,0.21,8.22,0.35c0.76,0.04,1.17,0.07,1.68,0.2c0.49,0.15,0.98,0.33,1.45,0.61 c0.95,0.55,1.83,1.35,2.61,2.28c0.39,0.47,0.76,0.96,1.09,1.48l0.24,0.37l-0.06,0.03c0.37,0.67,0.62,1.46,0.74,2.34 c0.12,0.88,0.07,1.83-0.03,2.78C600.64,448.06,600.42,449.03,600.16,449.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27BAE1",
    d: "M724.79,531.67c-0.33,12.3,2.12,23.97,6.9,32.85c4.96,9.21,11.85,14.39,19.41,14.6 c0.16,0,0.31,0.01,0.46,0.01c7.39,0,14.37-4.79,19.71-13.53c5.26-8.61,8.33-20.13,8.67-32.43c0.33-12.3-2.12-23.97-6.9-32.85 c-4.96-9.21-11.85-14.39-19.41-14.6c-7.56-0.2-14.73,4.6-20.18,13.53C728.2,507.85,725.13,519.37,724.79,531.67z M731.36,510.52 l1.69,11.72l-3.18,0.16l2.87,2l-5.03,8.69c0-0.44,0.01-0.89,0.02-1.33C727.93,524.17,729.18,516.92,731.36,510.52z  M734.38,563.72c-0.09-0.17-0.18-0.36-0.27-0.53l4.45,0.95l-0.99,3.4l2.29-1.78l2.49,7.73 C739.39,571.28,736.68,567.99,734.38,563.72z M762.36,572.36l2.69-9.75l2.7,1.64l-1.51-3.51l5.83-2.82 C769.54,564.06,766.2,569.05,762.36,572.36z M773.47,519.64l0.88-8.62c1.47,5.03,2.36,10.55,2.62,16.32l-3.15-5.72l2.3-1.65 L773.47,519.64z M753.57,488.05c2.68,0.07,5.27,0.94,7.72,2.52l-6.56,5.52l-1.17-5.63l-1.22,5.84l-7.55-5.58 c2.69-1.75,5.53-2.67,8.41-2.67C753.33,488.04,753.45,488.05,753.57,488.05z M741.71,493.14l11.92,8.81l10.68-8.99 c2.21,2.1,4.25,4.82,6.04,8.15c0.34,0.64,0.67,1.3,0.99,1.97l-1.88,18.48l7.47,13.58c-0.34,6.48-1.45,12.58-3.16,18.01l-0.1-0.22 l-11.41,5.52l-4.68,17c-1.94,0.87-3.96,1.34-6.03,1.34c-0.12,0-0.25,0-0.38-0.01c-1.37-0.04-2.71-0.29-4.03-0.73l-4.81-14.97 l-10.18-2.18c-2.22-5.55-3.65-11.92-4.2-18.68l9.22-15.92l-2.97-20.63c0.6-1.21,1.24-2.37,1.91-3.48 C737.83,497.36,739.71,495.01,741.71,493.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27BAE1",
    d: "M856.55,600.77l-13.25-1.36l-26.5-2.72c-17-1.68-34.01-3.34-51.02-4.94c6.94-1.24,13.89-2.46,20.82-3.77 c15.79-2.92,31.56-5.98,47.26-9.4c-15.97,1.87-31.87,4.11-47.75,6.49c-6.79,0.98-13.57,2.07-20.35,3.13 c3.71-2.93,7.16-6.92,10.2-11.91c6.76-11.08,10.78-25.83,11.37-41.63l3.05-1.12l-3-0.96c0.28-15.84-2.93-30.83-9.09-42.28 c-6.48-12.03-15.45-18.8-25.27-19.07c-0.6-0.02-1.2-0.01-1.79,0.02l0-0.13l-24.43,0.39c2.89-3.53,6.8-6.05,11.07-7.82 c4.43-1.83,9.23-2.89,14.06-3.67c2.44-0.3,4.87-0.68,7.34-0.85c1.23-0.1,2.46-0.22,3.68-0.31l1.79-0.06 c0.59-0.01,1.18,0.04,1.78,0.06c2.36,0.15,4.69,0.62,6.89,1.46c2.2,0.83,4.25,2.03,6.08,3.53c3.69,2.99,6.43,7.1,8.46,11.5 c2.04,4.42,3.41,9.16,4.38,13.99c0.49,2.42,0.91,4.85,1.21,7.29c0.28,2.45,0.51,4.91,0.64,7.38c0.29,4.94,0.27,9.9-0.06,14.84 c-0.68,9.87-2.65,19.7-6.35,28.91l-0.26,0.65l0.68-0.13l25.01-4.71l-24.47,3.86c3.79-9.04,5.96-18.71,6.87-28.46 c0.46-4.99,0.6-10.02,0.43-15.04c-0.06-2.51-0.27-5.02-0.52-7.52c-0.26-2.51-0.66-5-1.12-7.47c-0.93-4.95-2.26-9.87-4.33-14.54 c-2.06-4.65-4.91-9.11-8.95-12.49c-2-1.68-4.28-3.07-6.73-4.03c-2.45-0.97-5.05-1.53-7.65-1.74c-0.65-0.03-1.3-0.09-1.95-0.09 l-1.95,0.03c-1.27,0.07-2.51,0.17-3.77,0.26c-2.51,0.13-5.02,0.48-7.52,0.76c-5,0.74-10.02,1.75-14.84,3.65l-1.8,0.74 c-0.6,0.26-1.16,0.6-1.74,0.89c-0.57,0.31-1.16,0.59-1.72,0.94l-1.64,1.1l-0.82,0.55c-0.26,0.2-0.51,0.42-0.76,0.63l-1.52,1.27 c-0.48,0.45-0.92,0.94-1.39,1.41l-0.69,0.71c-0.23,0.24-0.42,0.51-0.62,0.76l-1.23,1.54c-0.38,0.53-0.73,1.08-1.09,1.62 l-0.54,0.81c-0.17,0.27-0.32,0.56-0.49,0.84l-0.96,1.68c-1.19,2.26-2.28,4.56-3.29,6.85l-0.76,1.72l-0.73,1.77 c-0.5,1.18-0.94,2.36-1.37,3.54c-0.9,2.36-1.67,4.74-2.49,7.11c-3.14,9.51-5.96,19.08-8.7,28.68c-2.6,9.17-5.12,18.34-7.57,27.55 c-5.84,0.38-11.7,0.68-17.55,0.93c-6.29,0.28-12.59,0.47-18.87,0.52c-3.14,0.02-6.28,0.01-9.4-0.09 c-3.11-0.1-6.25-0.31-9.39-0.51c-6.28-0.42-12.57-0.95-18.86-1.47c-25.16-2.12-50.31-4.54-75.48-6.79l-18.88-1.66 c-6.3-0.55-12.59-1.03-18.84-1.75c-6.25-0.71-12.48-1.6-18.62-2.85c-3.07-0.63-6.11-1.37-9.08-2.3 c-2.97-0.92-5.89-2.02-8.54-3.53c-1.32-0.75-2.57-1.62-3.63-2.64c-1.05-1.02-1.92-2.21-2.36-3.56c-0.23-0.67-0.37-1.37-0.39-2.09 c-0.03-0.74-0.03-1.56-0.04-2.34l-0.06-4.74l-0.23-18.95l-0.23-18.95c-0.07-3.15,0.06-6.29,0.65-9.39 c0.58-3.09,1.47-6.15,2.96-8.94c-1.58,2.74-2.57,5.79-3.26,8.88c-0.69,3.09-0.94,6.29-0.96,9.45l-0.23,18.95l-0.23,18.95 l-0.06,4.74c0,0.8-0.03,1.55-0.02,2.39c0,0.86,0.15,1.73,0.41,2.57c0.51,1.68,1.53,3.14,2.71,4.33c1.18,1.21,2.54,2.17,3.95,3 c2.83,1.65,5.84,2.83,8.88,3.83c1.64,0.54,3.3,1.01,4.97,1.45c3.71,15.31,9.07,24.23,17.59,28.52c-1.12-0.08-2.24-0.17-3.36-0.25 l-9.54-0.56l-13.44-0.83l-14.44-0.49l13.24,1.43l13.25,1.36l10.77,0.93c11.23,1.11,22.45,2.2,33.68,3.29 c-3.83,0.4-7.65,0.79-11.47,1.25c-5.2,0.58-10.38,1.24-15.57,1.93c-5.18,0.73-10.37,1.42-15.53,2.38 c10.47-0.27,20.92-0.72,31.36-1.38c5.22-0.28,10.43-0.7,15.65-1.05l15.39-1.24c17.52,1.68,35.05,3.24,52.57,4.85l53.07,4.69 l49.92,4.22c0.58,0.11,1.17,0.22,1.78,0.31l28.25,2.57l-22.47,3.87c-7.9,1.43-15.81,2.8-23.7,4.31 c-7.9,1.46-15.78,2.99-23.66,4.55c-7.87,1.6-15.75,3.16-23.58,5c15.94-2.03,31.85-4.24,47.72-6.65 c7.94-1.16,15.87-2.46,23.8-3.68l23.77-3.88l15-2.58c3.12,0.25,6.24,0.49,9.36,0.73c17.7,1.4,35.41,2.73,53.12,4.04l26.57,1.87 l13.29,0.93l13.29,0.86L856.55,600.77z M752.94,474.34c17.98,0.49,31.9,27.02,31.03,59.15c-0.43,15.74-4.33,30.42-10.99,41.33 c-6.45,10.57-14.66,16.28-23.17,16.05l-2.18-0.2c-16.93-2.44-29.73-28.11-28.89-58.95c0.43-15.74,4.33-30.42,10.99-41.33 c6.33-10.37,14.38-16.05,22.71-16.05C752.61,474.33,752.77,474.33,752.94,474.34z M697.68,557.03l0.34-1.3 c5.07-19.24,10.35-38.47,16.35-57.39c1.55-4.72,3.13-9.36,5.11-13.85c0.99-2.28,2.02-4.49,3.13-6.65l0.89-1.57 c0.15-0.26,0.29-0.53,0.45-0.78l0.09-0.13l15.62-0.25c-4.75,2.98-9.13,7.63-12.9,13.81c-6.92,11.34-10.97,26.51-11.41,42.72 c-0.44,16.21,2.79,31.58,9.08,43.27c3.26,6.06,7.16,10.79,11.49,14.02l-26.4-2.4c-12.26-1.77-18.74-9.67-23.3-28.78 c3.37-0.19,6.75-0.39,10.12-0.62L697.68,557.03z M544.91,549.08c10.52,1.11,21.05,2.15,31.57,3.19 c-6.47,12.75-15.72,20.15-25.13,19.89l-2.39-0.22c-9.52-1.51-18.01-10.55-23.26-24.84c0.12,0.01,0.24,0.02,0.36,0.04 L544.91,549.08z M488.28,541.93c0.04,0.01,0.08,0.02,0.12,0.03c6.22,1.37,12.5,2.35,18.79,3.16c4.78,0.62,9.57,1.1,14.35,1.57 c3.72,10.93,9.27,19.25,15.84,24.17l-26.05-2.43C499.36,566.71,492.77,559.21,488.28,541.93z M657.66,581.98l-53.08-4.48 c-11.91-0.96-23.82-1.95-35.73-2.9c4.76-0.5,9.53-0.96,14.29-1.53c10.39-1.18,20.77-2.48,31.12-4.16 c-10.48,0.11-20.93,0.6-31.37,1.22c-5.22,0.27-10.43,0.69-15.65,1.04l-1.56,0.13c5.71-3.96,10.84-10.32,14.83-18.61 c0.7,0.07,1.41,0.14,2.11,0.21c12.58,1.23,25.15,2.49,37.75,3.59c6.3,0.54,12.6,1.08,18.92,1.53c3.16,0.21,6.32,0.43,9.53,0.54 c3.19,0.11,6.37,0.13,9.54,0.12c8.03-0.05,16.02-0.31,24.02-0.71c2.85,12.3,6.78,21.93,14.27,27.47L657.66,581.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27BAE1",
    d: "M486.63,526.31c-0.72,0.49-1.6,0.86-2.47,1.19c-1.77,0.66-3.62,1.17-5.46,1.7 c-1.78,0.58-3.71,0.54-5.54,0.04c-1.83-0.49-3.58-1.33-5.15-2.43c1.5,1.19,3.21,2.14,5.06,2.74c1.83,0.61,3.89,0.78,5.79,0.26 c1.86-0.45,3.74-0.88,5.59-1.47c0.93-0.3,1.85-0.63,2.75-1.18c0.43-0.3,0.92-0.62,1.18-1.3c0.13-0.33,0.12-0.73,0.02-1.06 c-0.1-0.34-0.28-0.58-0.46-0.81l-0.03-0.04l-0.07-0.06l-13.82-10.25l-0.01-0.01l-0.05-0.03c-0.38-0.25-0.63-0.68-0.64-1.12 l-0.02-2.18l-0.03-2.24c0-0.42,0.25-0.84,0.59-1.06c0.17-0.11,0.35-0.17,0.53-0.18c0.09-0.01,0.18,0.01,0.27,0.02l0.55,0.11 c0.74,0.15,1.48,0.29,2.23,0.42c1.49,0.26,2.98,0.51,4.47,0.71c5.97,0.86,11.94,1.43,17.92,1.99c5.98,0.53,11.95,1.02,17.93,1.46 c5.98,0.42,11.96,0.81,17.94,1.19c5.98,0.36,11.96,0.74,17.95,1.05l17.95,0.91l17.95,0.84l17.96,0.73l17.96,0.69l4.49,0.15 l0.56,0.02c0.12,0,0.11,0.01,0.17,0.02c0.09,0.02,0.17,0.06,0.24,0.12c0.05,0.05,0.04,0.03,0.11,0.13l0.33,0.46l0.65,0.92 l1.3,1.83l0.32,0.46l0.16,0.23c0.07,0.1,0.07,0.11,0.09,0.13c0.06,0.09,0.07,0.15,0.08,0.21c0.01,0.11-0.06,0.35-0.32,0.55 c-0.06,0.05-0.13,0.1-0.21,0.14c-0.04,0.02-0.08,0.04-0.12,0.06l-0.06,0.03l-0.12,0.04l-1.04,0.37 c-5.6,1.95-11.34,3.69-17.04,5.54c-2.85,0.92-5.7,1.84-8.57,2.83c-0.72,0.25-1.43,0.5-2.17,0.8l-0.56,0.23 c-0.22,0.1-0.45,0.21-0.7,0.37c-0.12,0.07-0.27,0.19-0.4,0.29c-0.16,0.16-0.29,0.26-0.45,0.52c-0.14,0.2-0.28,0.55-0.31,0.88 c-0.04,0.36,0.04,0.69,0.14,0.95c0.23,0.52,0.48,0.72,0.7,0.95c0.22,0.19,0.43,0.34,0.63,0.47c0.4,0.25,0.77,0.44,1.14,0.62 c0.74,0.35,1.46,0.63,2.17,0.9l2.1,0.79l1.01,0.4c0.36,0.14,0.78,0.31,1.18,0.42c1.62,0.5,3.27,0.59,4.83,0.57 c1.56-0.03,3.06-0.15,4.53-0.22c1.45-0.05,2.96-0.11,4.45-0.19l17.97-0.87c11.98-0.6,23.95-1.24,35.91-1.98 c-11.98,0.03-23.96,0.16-35.93,0.33l-17.95,0.28c-1.5,0.03-2.98,0.05-4.53,0.05c-1.52,0.03-3.02,0.1-4.45,0.09 c-1.43-0.03-2.81-0.15-4.04-0.57c-0.32-0.09-0.59-0.22-0.93-0.35l-1.07-0.45l-2.08-0.83c-0.68-0.28-1.35-0.56-1.96-0.86 c-0.09-0.05-0.18-0.09-0.27-0.14c0.63-0.23,1.3-0.45,1.96-0.67c2.82-0.91,5.69-1.76,8.56-2.62c5.74-1.72,11.47-3.42,17.21-5.32 l1.08-0.37l0.14-0.05l0.2-0.08c0.13-0.05,0.26-0.11,0.39-0.18c0.26-0.13,0.5-0.29,0.74-0.47c0.92-0.7,1.68-1.9,1.66-3.3 c-0.01-0.69-0.22-1.37-0.55-1.91c-0.2-0.33-0.26-0.4-0.38-0.57l-0.32-0.46l-1.28-1.85l-0.64-0.92l-0.32-0.46 c-0.14-0.2-0.38-0.51-0.62-0.72c-0.48-0.45-1.07-0.77-1.71-0.94c-0.3-0.09-0.69-0.13-0.94-0.14l-0.56-0.03l-4.49-0.21 l-17.95-0.77l-8.53-0.38l5.05-18.12c8.59-4.03,17.32-7.9,26.19-11.17c2.29-0.83,4.59-1.62,6.9-2.31 c1.15-0.35,2.31-0.65,3.46-0.93c1.16-0.27,2.26-0.46,3.49-0.63c4.78-0.7,9.62-1.06,14.47-1.09c2.43-0.02,4.85,0.04,7.28,0.18 c1.21,0.06,2.43,0.15,3.65,0.24c0.61,0.04,1.05,0.08,1.27,0.14c0.01,0.03,0.02,0.06,0.03,0.11c0.07,0.25,0.16,0.66,0.36,1.13 c0.2,0.47,0.53,0.97,0.91,1.34c0.78,0.77,1.6,1.09,2.33,1.34c1.46,0.46,2.78,0.58,4.09,0.67c1.31,0.09,2.58,0.09,3.85,0.07 l3.69-0.07c2.45-0.03,4.92-0.04,7.46-0.17c2.53-0.14,5.19-0.45,7.76-1.39c2.58-0.92,4.89-2.5,6.78-4.32 c1.91-1.82,3.5-3.84,4.96-5.91c0.73-1.03,1.42-2.1,2.09-3.14c0.65-1.01,1.32-2.01,2.02-2.99c1.4-1.95,2.91-3.83,4.52-5.6 c3.23-3.54,6.93-6.66,11-9.19c8.16-5.1,17.74-7.7,27.41-8.55c4.82-0.4,9.72-0.3,14.24,1.2c2.26,0.75,4.38,1.88,6.32,3.3 c1.94,1.41,3.71,3.09,5.4,4.86c1.66,1.76,3.3,3.72,5.35,5.22c1.02,0.76,2.16,1.39,3.38,1.78c1.23,0.39,2.51,0.53,3.76,0.52 c2.51-0.02,4.94-0.44,7.39-0.69c2.45-0.27,4.91-0.44,7.37-0.51c-2.47-0.06-4.94,0-7.4,0.15c-2.46,0.13-4.93,0.41-7.35,0.36 c-1.21-0.03-2.4-0.21-3.51-0.61c-1.11-0.41-2.14-1.02-3.07-1.77c-1.9-1.49-3.38-3.4-5.03-5.28c-1.65-1.86-3.41-3.66-5.4-5.22 c-1.98-1.57-4.22-2.87-6.62-3.76c-2.39-0.9-4.92-1.43-7.44-1.65c-2.52-0.24-5.05-0.22-7.55-0.08c-4.99,0.33-9.97,1.05-14.82,2.39 c-4.85,1.34-9.56,3.3-13.91,5.9c-4.36,2.59-8.33,5.82-11.81,9.5c-1.74,1.84-3.36,3.79-4.85,5.83c-0.75,1.02-1.46,2.06-2.16,3.11 c-0.67,1.02-1.34,2.02-2.04,2.99c-2.79,3.87-6.04,7.46-10.22,8.87c-2.08,0.74-4.38,1-6.77,1.1c-2.38,0.11-4.85,0.07-7.33,0.1 c-2.51,0.01-4.94,0.15-7.25-0.02c-1.15-0.08-2.3-0.22-3.19-0.51c-0.43-0.14-0.78-0.33-0.87-0.45c-0.1-0.11-0.12-0.1-0.3-0.82 c-0.09-0.33-0.24-0.92-0.69-1.5c-0.45-0.59-1.08-0.94-1.58-1.12c-0.49-0.16-0.94-0.25-1.32-0.29l-0.3-0.03l-0.23-0.02l-0.46-0.04 c-1.24-0.09-2.48-0.19-3.73-0.26c-2.49-0.15-5-0.22-7.5-0.21c-5.01,0.02-10.03,0.34-15.01,1.1c-1.22,0.17-2.54,0.41-3.79,0.7 c-1.25,0.3-2.47,0.63-3.68,1c-2.42,0.73-4.78,1.54-7.12,2.41c-4.67,1.73-9.26,3.63-13.8,5.61c-4.4,1.93-8.76,3.91-13.1,6.02 l-30.83-1.35l-31.29-1.27l-31.29-1.16l-31.11-0.95c-0.76-1.02-1.5-2.1-2.23-3.17l-2.29-3.39c-1.52-2.27-3-4.56-4.48-6.85 c1.35,2.37,2.72,4.74,4.11,7.09c0.7,1.18,1.4,2.35,2.12,3.51c0.73,1.16,1.45,2.31,2.24,3.46l0.1,0.15l0.22,0.01l31.23,2.06 l31.26,1.92l31.26,1.82l29.33,1.61l-1.42,17.66l-27.35-1.22l-35.88-1.68c-5.98-0.3-11.96-0.6-17.93-0.95 c-5.97-0.32-11.95-0.67-17.91-1.08c-5.96-0.43-11.92-0.88-17.84-1.53c-1.48-0.16-2.95-0.36-4.42-0.57 c-0.73-0.11-1.47-0.22-2.2-0.34l-0.55-0.09c-0.28-0.04-0.57-0.06-0.85-0.03c-0.57,0.06-1.11,0.27-1.55,0.59 c-0.88,0.65-1.42,1.69-1.41,2.77l0.09,2.25l0.09,2.31c0.07,1.06,0.69,2.05,1.6,2.57l-0.06-0.04l14.14,9.67 c0.23,0.27,0.32,0.51,0.25,0.71C487.28,525.76,486.97,526.07,486.63,526.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27BAE1",
    d: "M586.96,534.03c-1.34-0.45-2.76-0.84-4.27-1l-4.1-0.44c-5.46-0.6-10.93-1.05-16.4-1.56l-16.42-1.28 c-10.96-0.74-21.92-1.41-32.91-1.72c-5.5-0.16-10.98-0.29-16.54-0.07c-0.72,0.05-1.36,0.07-2.2,0.24 c-0.29,0.07-0.41,0.13-0.58,0.2l-0.48,0.19l-0.96,0.39c-1.28,0.52-2.55,1.07-3.8,1.66c-2.51,1.15-4.96,2.42-7.34,3.8 c2.54-1.05,5.12-1.99,7.71-2.88c1.3-0.43,2.59-0.86,3.9-1.26l0.98-0.29l0.49-0.14c0.16-0.05,0.36-0.11,0.41-0.1 c0.51-0.05,1.25-0.03,1.9-0.01c5.42,0.23,10.9,0.77,16.36,1.19l16.39,1.34l16.41,1.25l16.42,1.12c5.48,0.3,10.95,0.69,16.43,0.95 l4.11,0.22c1.23,0.05,2.49,0.34,3.77,0.66c2.57,0.67,5.13,1.6,7.66,2.6c5.08,1.97,10.07,4.26,15.07,6.55 c-4.58-3.05-9.36-5.79-14.3-8.29C592.17,536.11,589.64,534.96,586.96,534.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27BAE1",
    d: "M667.03,481.76c-0.37,0.01-0.78,0.01-1.21,0.01c-2.8,0-2.8,2.5-2.8,3.7c0,0.68,0.04,3.94,0.09,8.07 c0.09,6.83,0.21,16.19,0.21,19.4c0,5.45,0.74,6.59,2.75,9.68c0.61,0.94,1.02,1.67,1.32,2.2c0.68,1.22,1.17,2.09,2.66,2.09 c0.1,0,0.2,0,0.29,0.01c0.08,0,0.17,0,0.25,0c0.43,0,0.94-0.06,1.38-0.48c0.63-0.61,0.7-1.58,0.7-3.5v-34.42 c0-3.3-0.36-4.87-1.32-5.82C670.31,481.7,668.86,481.73,667.03,481.76z M670.39,522.95c0,0.9-0.03,1.41-0.06,1.7 c-0.13,0-0.31-0.01-0.38-0.01c-0.01,0-0.01,0-0.02,0c-0.12-0.12-0.35-0.53-0.57-0.93c-0.31-0.56-0.74-1.32-1.42-2.37 c-1.9-2.93-2.36-3.63-2.36-8.4c0-3.23-0.12-12.59-0.21-19.43c-0.05-4.12-0.09-7.38-0.09-8.04c0-1.1,0.12-1.35,0.14-1.38 c0,0,0.09-0.05,0.38-0.05c0.45,0,0.86-0.01,1.25-0.01c1.35-0.03,2.33-0.04,2.69,0.31c0.64,0.63,0.64,3.32,0.64,4.2V522.95z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clouds_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E1D9C8",
    d: "M1240.83,117.74c-15.61-22.95-49.18-50.26-87.31-32.78c-7.19,3.57-15.19,8.69-23.63,16.02 c0.66,0.16,1.33,0.34,1.99,0.55c10.51,3.3,15.42,10.43,15.42,10.43s32.71-2.62,42.95,25.14c0,0-16.45-26-44.89-20.92 c0,0-12.62-20.4-46.07-8.92c0,0,13.86-9.8,29.62-6.5c2.98-4.03,9.6-11.79,20.63-18.75c-18.14-23.43-39.59-30.55-54.89-32.96 c-41.35-6.52-85.66,7.45-121.82,28.79c-72.38,42.75-137.6,46.75-214.97,70.16l584.19-7.81 C1285.82,139.14,1262.79,104.38,1240.83,117.74z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "father_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1C6B0",
    d: "M247.8,530.77l-5.13-6.2c0,0-4.5-16.52-3.76-17.69c0.74-1.16,0.74-1.16,0.74-1.16l8.88-6.08l3.6,9.2 L247.8,530.77z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M295.08,980.55C294.98,980.77,294.99,980.76,295.08,980.55L295.08,980.55z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M295.18,980.33c-0.02,0.04-0.04,0.08-0.05,0.12c-0.02,0.04-0.03,0.07-0.05,0.1 c0.01-0.03,0.03-0.07,0.05-0.1C295.14,980.41,295.16,980.38,295.18,980.33C295.18,980.33,295.18,980.33,295.18,980.33z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F1C6B0",
    d: "M349.08,519.57c-0.11-0.72-0.25-1.43-0.43-2.11c-1.54-6.04-1.92-7.55-8.01-15.4 c1.58-1.15,2.91-3.27-2.14-12.43c-3.85-6.98-7.32-10.31-9.42-10.16c-0.71,0.05-1.26,0.5-1.61,1.34c0,0,0,0,0,0.01 c-0.17,0.42-1.87,2.61-3.38,0.77c0,0-1.61-3.37-6.53-7.21c-4.92-3.84-12.93-9-15.49-9.72c-2.56-0.72-18.93-9.32-21.85-8.56 s-0.48,7.88-7.44,10.37c-6.96,2.48-16.45,3.68-20.05,5.56c-1.79,0.93-3.94,2.88-5.75,4.85c-0.73-1.92-1.29-2.98-1.25-1.81 c-0.2-0.3,0.03,0.83,0.48,2.67c-1.47,1.7-2.63,3.31-3,4.21c-0.88,2.08-2.76,8.68-2.64,8.72c0.12,0.04-1.85,12.49-1.85,12.49 l0.19,3.72l4.28-2.97c0.62,5.03,1.9,9.98,3.79,14.69c-0.63-1.07-1.27-2.14-1.9-3.2c0.55,1.52,1.1,3.05,1.65,4.57 c-1.33-1.91-2.51-3.93-3.52-6.03c1.46,4.11,3.07,8.16,4.82,12.14c-2.47-3.74-4.65-7.66-6.52-11.73 c1.9,5.49,3.85,11.05,6.85,16c-0.05,0.04-0.1,0.07-0.15,0.11c-2.15-3.02-4.1-6.18-5.82-9.46c0,0.01,0.01,0.02,0.01,0.03 c1.66,3.29,3.39,6.63,5.4,9.74c-0.28,0.21-0.54,0.42-0.8,0.61c-0.14,0.11-0.28,0.21-0.42,0.32c-2.19,1.67-2.82,4.07-2.12,6.11 c0.14,0.55,0.59,1.19,0.59,1.19s-3.73,3.06-2.26,6c0.32,1.53,1.93,1.74,1.93,1.74s-2.65,1.98-1.09,4.76 c0.23,0.4,0.63,0.97,0.63,0.97s0.77,1.28,1.49,1.23c3.33-0.23,10.71,0.51,10.02,0.92c-0.09,0.13-0.41,0.22-1.01,0.22 c-1.56,0.01-4.73-0.43-6.83,0.14c-2.1,0.57-2.99,2.44-3.11,4.04c-0.13,1.6,1.83,2.37,3.14,3.49c1.31,1.12,1.6,1.36,4.13,1.76 c2.53,0.4,4.42,0.32,5.6,0.7c1.17,0.38,2.91,2.48,4.92,2.93c2,0.45,3.89,3.28,6.83,4.34c2.94,1.06,5.56,1.73,8.75,1.27 c0,0,1.53,1.8,4.65,5.8c0.77,0.99,1.57,1.91,2.32,2.72c3.62-2.35,15.85-19.13,17.65-25.66c0,0,3.09-2.86,7.84-0.61 c2.62,1.24,4.15,2.63,6.87,2.13c1.04-0.19,3.66,1.2,7.13,3.59c0.37-0.16,0.74-0.33,1.11-0.5c2.34-2.33,4.63-5.39,6.79-10.57 c7.78-18.71,14.78-25.14,23.11-26.93C351.14,523.25,349.95,521.7,349.08,519.57z M325.83,486.68 c-0.02-0.03-0.05-0.06-0.07-0.08l-0.05-0.25C325.76,486.46,325.79,486.57,325.83,486.68z M244.23,503.19l1.76-1.22 c1.16,5.49,1.71,8.14,4.54,14.62C248.06,512.32,245.95,507.83,244.23,503.19z M246.64,501.53l1.55-1.08 c0.83,2.81,1.7,5.6,2.61,8.39C248.52,504.85,247.85,504.06,246.64,501.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M287.49,322.63c-0.67,1.06-1.44,2.05-2.3,2.97c-0.98,1.05-1.91,1.92-2.78,2.65 c0.53,1.33,1.04,2.68,1.54,4.06C285.3,330.1,286.79,326.87,287.49,322.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M243.31,526.06c0.05,0.01,0.1,0.02,0.15,0.04c-0.27-0.5-0.54-1.01-0.79-1.53 c-2.4-3.09-3.94-6.84-4.35-10.73c0.11,1.95,0.23,3.89,0.34,5.84c-0.92-4.5-1.18-9.13-0.75-13.7c-0.15,1.66-0.47,3.31-0.95,4.9 c0.46-4.11,0.4-8.27-0.15-12.36c-0.02,1.57-0.04,3.13-0.05,4.7c0.01-0.5-0.22-1.1-0.3-1.6c-0.09-0.55-0.18-1.11-0.25-1.67 c-0.14-1.09-0.24-2.19-0.29-3.29c-3.89,0.19-7.4,2.02-10.52,4.87c-0.39,9.3-0.04,17.95,1.93,22.63l-0.39,0.02 c0.21,0.01,0.41,0.01,0.62,0.02c4.45-0.14,9.55,0.35,15.66,1.83c-0.15-0.21-0.3-0.42-0.45-0.63 C242.94,525.63,243.12,525.85,243.31,526.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M211.19,525.2c0.29-0.04,0.59-0.08,0.88-0.11l-0.85,0.05C211.21,525.16,211.2,525.18,211.19,525.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M284.58,434.01c0,2.43,0.06,8.32,1.14,9.68c0.53-2.85,1.71-5.79,1.71-7.12c0-1.05-0.52-1.73-0.86-2.06 c0.02-0.1,0.04-0.2,0.06-0.3c2.07-0.41,1.42-1.82,0.73-4.08c0.09-0.51,0.17-1.02,0.25-1.53c-0.19,0.06-0.39,0.13-0.6,0.23 C285.21,429.59,284.58,428.99,284.58,434.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M286.01,370.4c0.07-0.05,0.24-0.07,0.46-0.09c1.18-2.38,2.39-4.92,2.92-8.59 c-0.25,0.46,0.2-4.91,0.26-4.93c-0.15-5.22-1.49-12.31-5.04-22.62c-0.11-0.32-0.23-0.64-0.34-0.96 c-0.32-0.89,0.34,0.96-0.32-0.89c-0.5-1.38-1.01-2.74-1.54-4.06c-12.25,10.28-14.11-7.75-20.33,19.94 c-1.61,7.18-1.98,14.34-1.84,21.08c0.5,2.84,0.98,6.34,1.42,10.68c2.91,28.95,18.94,43.27,27.01,39.26 c0.04,0.01,0.08,0.03,0.12,0.05c0.01-0.17,0.03-0.34,0.04-0.51c0.81-0.65,1.65-1.34,2.27-1.76c-1.34,0.83-2.1,1.51-2.1,1.51 c0.19-8.62-0.05-13.06-2.98-21.83c-2.94-8.77-2.33-12.26-2.44-16.11c0.86,7.31,2.85,11.25,4.12,15.77 c1.27,4.52,1.07,11.1,3.12,14.28c2.05,3.17,10.07,2.82,6.09,3.85c-2.15,0.56-3.96,1.43-5.31,2.23 c0.07-0.03,0.13-0.06,0.19-0.08c8.48-2.35,10.66-4.07,5.12-13.96c-4.41-7.87-10.26-20.66-12.82-26.36 c0.42-1.81,1.1-3.36,1.85-4.9 M290.81,410.61c-2.05-3.17-1.85-9.76-3.12-14.28c-1.27-4.52-3.25-8.46-4.12-15.77 c0.11,3.85-0.5,7.34,2.44,16.11c2.94,8.77,3.18,13.21,2.98,21.83c0,0,0.76-0.68,2.1-1.51c0.16-0.1,0.33-0.2,0.5-0.3 c1.35-0.79,3.16-1.67,5.31-2.23C300.88,413.43,292.86,413.79,290.81,410.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M238.84,478.15c-0.04,0.09-0.09,0.18-0.13,0.27c-0.18,0.44-0.36,0.89-0.55,1.33 c-0.01,0.08-0.01,0.16-0.02,0.23c0.19-0.53,0.39-1.05,0.61-1.57C238.79,478.32,238.82,478.24,238.84,478.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M223.1,373.14c4.15,0.84,7.24,6.34,3.31,11.13c-3.93,4.79-5.34,6.85-6.21,10.54 c-0.87,3.69,1.78,7.08,1.78,7.08s0.55-2.83,1.44-6.25c0.89-3.42,5.04,1.24,9.02-2.99c3.98-4.23,1.24-15.69-0.37-18.34 c-1.61-2.65-4.72-6.84-10.9-5.2s-7.52,8.99-8.86,14.11C212.32,383.24,217.28,371.96,223.1,373.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M231.75,402.12c-1.79,2.1,3.22,10.02,5.85,13.14c2.63,3.12,5.14,0.12,2.32-5.21 c-2.82-5.33-0.95-6.6,0.38-9.49c1.33-2.9-0.11-3.61-0.11-3.61C237.41,401.36,233.55,400.02,231.75,402.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M233.65,424.5c0,0-14.11-15.22-15.24-28.49C218.41,396.01,220.01,419.53,233.65,424.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M419.73,422.4c5.97,2.13,11.14,4.18,13.35,4.92c3.51,1.17,9.37,6.07,13.53,8.63 c4.15,2.56,8.2,6.6,9.9,8.41c1.63,1.73,1.6,4.91-0.17,6.12c-0.51-0.39-1.09-0.84-1.73-1.32c0.3-0.87,0.34-1.98-0.02-3.42 c0.43,2.24-0.43,3.62-2.56,3.51c-2.13-0.11-2.09-3.1-1.81-5.33c0.07-0.52-1.01-1.5-1.94-2.67c-0.73-0.91-1.2-2.31-2.1-1.37 c-3.73,3.83-14.8,0.85-20.87,3.41c-6.07,2.56-15.87,4.37-23.64,8.41c-7.58,3.95-20.32,10.42-31.62,18.94 c-3.92-4.78-8.08-7.41-9.82-8.38c2.34-1.94,4.72-3.99,6.07-5.34c3.3-3.3,7.99-9.37,14.16-14.8 c6.18-5.43,11.08-12.78,14.06-17.36c2.33-3.57,3.75-6.95,8.92-6.9L419.73,422.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M446,451.86c0.05,0.01,0.11,0.02,0.16,0.03c1.17,0.2,2.91,0.38,4.47,0.06 c1.76-0.35,3.38-1.1,3.98-2.79c0.3-0.87,0.34-1.98-0.02-3.42c0.43,2.24-0.43,3.62-2.56,3.51c-2.13-0.11-2.09-3.1-1.81-5.33 c0.07-0.52-1.01-1.5-1.94-2.67c-0.73-0.91-1.2-2.31-2.1-1.37c-3.73,3.83-14.8,0.85-20.87,3.41 c-6.07,2.56-15.87,4.37-23.64,8.41c-7.58,3.95-20.32,10.42-31.62,18.94c4.31,5.26,8.33,13.12,8.48,24.21 c2.7-2.83,3.83-3.44,5.45-4.17c2.13-0.96,2.02-0.96,3.3-2.24c1.28-1.28,6.92-0.11,11.18-3.73c4.26-3.62,8.95-10.12,9.37-10.44 c0.43-0.32,2.56-0.85,3.2-1.28c0.64-0.43,4.26,0.32,6.82,1.38c2.56,1.07,5.01,1.6,6.71,2.24c1.7,0.64,4.05,1.17,6.28-0.43 c2.24-1.6,2.66-3.83,0.85-5.64c-1.81-1.81-3.83-3.62-4.9-4.79c-1.07-1.17-5.01-2.02-7.46-3.41c0,0,0-0.01,0-0.01 c-2.78,2.26,6.66-5.51,1.86-1.53c0.49,0.19,1.12,0.56,2.08,0.9c1.81,0.64,4.37,0.75,6.6,2.56c2.24,1.81,2.88,1.92,4.05,4.05 c1.17,2.13,3.41,5.01,6.18,3.3c2.77-1.7,2.88-4.15,2.24-6.39c-0.64-2.24-0.75-3.83-1.07-4.37c-0.32-0.53-2.02-2.02-3.09-2.77 c-1.07-0.75-3.62-3.09-3.62-3.09s3.83,2.02,4.79,3.2c0.96,1.17,2.66,3.73,4.15,4.58c1.49,0.85,4.15,0.43,5.22-1.7 c1.07-2.13,0.32-5.64-1.28-7.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M418.05,461.82c-4.9,3.51-12.03,8.31-23.43,13.1c0,0,11.5-3.51,17.25-7.03 c1.94-1.19,4.69-3.29,7.47-5.55c0.62-0.5,1.24-1.02,1.86-1.53c4.8-3.98,9.2-7.94,9.2-7.94 C428.59,453.84,422.95,458.31,418.05,461.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M338.51,489.64c5.05,9.16,3.72,11.27,2.14,12.43c6.09,7.85,6.46,9.36,8.01,15.4 c0.17,0.68,0.31,1.38,0.43,2.11c0.87,2.13,2.06,3.68,6.58,3.9c2.35-0.5,4.8-0.64,7.41-0.57c1.34-0.13,2.75-0.18,4.21-0.15 c5.72-15.54,11.24-25.97,11.24-25.97c0.02-0.65,0.02-1.29,0.01-1.92c-0.16-11.1-4.17-18.95-8.48-24.21 c-3.92-4.78-8.08-7.41-9.82-8.38c-0.53-0.3-0.83-0.44-0.83-0.44c-6.86,0.62-11.95,2.43-30.31,17.66 C331.18,479.33,334.66,482.66,338.51,489.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M325.76,560.97c-0.37,0.17-0.74,0.33-1.11,0.5c0.11,0.08,0.23,0.16,0.34,0.24 C325.25,561.47,325.51,561.22,325.76,560.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M327.48,480.82c-0.24,0.2-0.5,0.42-0.75,0.63c0.12,0.16,0.25,0.32,0.37,0.49 C327.18,481.61,327.3,481.24,327.48,480.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M243.67,526.5c-0.07-0.13-0.14-0.27-0.21-0.4c-0.05-0.01-0.1-0.02-0.15-0.04 C243.43,526.21,243.55,526.36,243.67,526.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M149.31,531.09c29.37,0,47.34-3.96,62.15-5.89c0.01-0.02,0.02-0.04,0.02-0.06l0.85-0.05l14.87-0.89 l0.39-0.02c-1.97-4.68-2.32-13.34-1.93-22.63c3.13-2.85,6.63-4.69,10.52-4.87c0-0.02-0.03-0.06,0-0.07 c1.77-0.39,7.82-10.2,10.12-11.03c12.1-4.39,6.31-14.06,6.8-14.91c7.02-12.17,27.44-6.86,27.52-7.24 c0.13-1.07-42.17,16.26-42.17,16.18c-0.51,1.24-1.03,2.64-1.54,3.88c0.46-1.31,0.97-2.61,1.54-3.88 c1.29-15.04,6.35-31.86,6.91-41.82c0.22-3.96,0.39-7.59,0.51-10.93c0.58-0.87,1.04-2.06,1.31-3.63 c1.04-6.05-0.22-10.57-1.33-19.54c-0.22-4.08-0.58-7.55-1.02-10.76c-0.06-0.44-0.11-0.88-0.12-1.31 c-1.76-11.48-6.82-30.11-21-25.44c-15.78,5.19-12.24,25.45-18.18,63.8c-6.45,41.7-48.46,60.56-85.68,39.28 c0,0-0.19-1.04-0.56-2.83c0.1,6.58-0.61,12.39-1.79,17.45c-2.33,6.79-6.9,14.06-11.12,18.84c-0.04,0.05-0.08,0.09-0.12,0.14 c-2.77,3.17-4.12,6.07-4.15,8.76C104.39,516.53,114.08,531.09,149.31,531.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1C6B0",
    d: "M245.02,538.95c-0.07-0.11-0.25-0.43-0.55-1.12C244.61,538.22,244.79,538.6,245.02,538.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M238.91,477.95c-0.06,0.15-0.13,0.31-0.19,0.46c0.04-0.09,0.09-0.18,0.13-0.27 C238.87,478.08,238.89,478.02,238.91,477.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M238.18,479.58c-0.56,1.27-1.08,2.56-1.54,3.88c0.51-1.24,1.01-2.47,1.52-3.71 c0.18-0.44,0.36-0.89,0.55-1.33C238.53,478.8,238.36,479.19,238.18,479.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C16032",
    d: "M363.07,522.89c-2.61-0.06-5.06,0.07-7.41,0.57c-8.33,1.79-15.33,8.22-23.11,26.93 c-2.16,5.18-4.45,8.23-6.79,10.57c-0.25,0.25-0.51,0.5-0.76,0.74c-0.11-0.08-0.23-0.16-0.34-0.24 c-3.47-2.4-6.09-3.78-7.13-3.59c-2.72,0.5-4.26-0.89-6.87-2.13c-4.74-2.25-7.84,0.61-7.84,0.61 c-1.8,6.53-14.02,23.32-17.65,25.66c-0.13,0.08-0.24,0.15-0.35,0.19c-0.43,4.61,5.41,8.19,4.84,11.05 c-0.57,2.86,4.46,7.05,10.82,16.88c2.83,4.39,10.69,12.8,19.41,20.58c-0.18-1.1-0.06-1.38,0.41-0.7 c0.75,1.08,1.51,2.1,2.28,3.06c7.03,6.04,14.33,11.38,19.84,13.71c6.35,1.62,10.83,0.54,10.83,0.54s-1.27,3.62,3.23,11.28 c15.73,26.75,35.07,70.11,44.16,91.07l0.86-0.07c13.03-29.34,32.36-31.5,37.44-41.74c5.08-10.23,10.79-28.74,17.64-33.31 c0.43-0.29,0.87-0.54,1.3-0.77c-0.01-0.25-0.02-0.5-0.04-0.74c-0.34-2.4-0.8-6.34-0.61-8.43c0.29-3.13,2.3-4.92,3.69-6.8 c1.39-1.88,1.44-4.68,1.71-8.27c0.27-3.59,1.41-5.05,2.38-6.63c0.02-0.03,0.03-0.05,0.04-0.08 c-3.85-9.31-8.6-18.42-12.87-27.53c-8.63-18.43-24.18-36.88-33.36-49.77c-6.86-9.63-9.72-17.37-15.86-24.61 c-10.84-12.78-24.77-17.93-35.68-18.2C365.82,522.71,364.41,522.76,363.07,522.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1C6B0",
    d: "M244.72,546.73c-0.24-0.04-0.45-0.12-0.64-0.21C244.46,546.74,244.72,546.73,244.72,546.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M495.34,670.79c0,0.06,0,0.13,0,0.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M497.74,687.04c0.51-3.37,2-6.59,0.97-9.7c-0.32-0.97-0.75-1.81-1.21-2.58 c-0.07-0.67-1.66-2.16-2.16-3.76c-0.04-0.19-0.07-0.38-0.06-0.58c-0.19-2,1.21-4.04-1.19-8.55c-0.75-1.4-2.23-1.82-3.27-3.3 c0,0-1.37-1.68-1.2-3.29c0.37-3.39-1.82-7.66-5.98-9.77c-1.27-0.64-2.99-1.28-4.78-1.87c-0.64-7.18-5.02-10.1-9.14-8.11 c-0.83,0.4-1.42,0.8-1.87,1.23c-0.85,0.75-1.03,1.22-1.03,1.22c-0.35,1.47-0.35,1.47-0.74,2.48l-0.43,1.24l-0.59,1.16 c0,0-1.13,0.09-2.15,4.7c-0.39,1.79-0.46,4.32-0.9,7.72c-0.34,2.61-3.42,4.6-4.46,7.58c-1.52,4.36,0.32,10.94,0.32,10.94 s2.39-1.22,4.36-1.27c1.97-0.05,4.85,0.18,8.46,1.27c3.62,1.09,5.14,1.44,5.14,1.44c10.81,2.09,19.26,14.94,22.34,26.25 c0.88-2.45,2.27-5.67,2.2-7.58c-0.08-2.1-1.87-4.93-2.67-6.38c0,0,0.01,0.02,0.03,0.05 C497.72,687.4,497.71,687.22,497.74,687.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M457.88,673.8c0.02-0.01,0.04-0.02,0.06-0.03c-0.03-0.22-0.07-0.45-0.1-0.71 C457.86,673.3,457.87,673.55,457.88,673.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M498.24,701.68c-0.02-0.06-0.04-0.13-0.05-0.19c-0.01,0.04-0.03,0.08-0.04,0.13 c0-0.28-0.71-2.46-0.71-2.46c0-0.02,0-0.04,0.01-0.06c-3.85-11.57-11.17-21.61-21.6-23.85c-0.1-0.02-0.21-0.05-0.31-0.07 c-4.75-0.94-11.17-4.63-17.58-1.4c-0.02,0.01-0.04,0.02-0.06,0.03c-0.44,0.22-0.87,0.48-1.3,0.77 c-6.85,4.57-12.56,23.08-17.64,33.31c-5.08,10.23-24.41,12.39-37.44,41.74l-0.86,0.07c-9.09-20.96-28.43-64.32-44.16-91.07 c-4.5-7.66-3.23-11.28-3.23-11.28s-4.48,1.08-10.83-0.54c-5.51-2.33-12.81-7.67-19.84-13.71c-0.76-0.96-1.53-1.97-2.28-3.06 c-0.47-0.68-0.59-0.4-0.41,0.7c-8.72-7.79-16.58-16.2-19.41-20.58c-6.35-9.83-11.39-14.02-10.82-16.88 c0.57-2.86-5.27-6.44-4.84-11.05c0.1-0.05,0.22-0.11,0.35-0.19c-0.76-0.82-1.55-1.73-2.32-2.72c-3.12-4-4.65-5.8-4.65-5.8 c-3.19,0.46-5.8-0.22-8.75-1.27c-2.94-1.05-4.83-3.89-6.83-4.34c-2-0.45-3.74-2.55-4.92-2.93c-1.17-0.38-3.07-0.3-5.6-0.7 c-2.53-0.4-2.82-0.65-4.13-1.76c-1.31-1.12-3.27-1.88-3.14-3.49c0.13-1.6,1.01-3.47,3.11-4.04c2.1-0.57,5.27-0.13,6.83-0.14 c0.59,0,0.92-0.1,1.01-0.22c-0.06,0.03-0.12,0.06-0.18,0.09c0,0,0.43-0.48-1.15-0.7c-0.11-0.02-0.24-0.03-0.37-0.05 c-1.67-0.2-4.55-0.43-5.77-0.69c-1.32-0.28-1.6,0.18-2.43,0.23c-1.08,0.06-1.5-0.72-1.62-1.03c-0.2-0.25-0.4-0.57-0.63-0.97 c-1.57-2.78,1.09-4.76,1.09-4.76s-0.26,0.01-0.64-0.21c-1-0.49-1.29-1.53-1.29-1.53c-1.47-2.93,2.26-6,2.26-6 s-0.01-0.02-0.03-0.05c-0.23-0.35-0.42-0.73-0.55-1.12c0-0.01-0.01-0.02-0.01-0.02c-0.7-2.03-0.07-4.44,2.12-6.11 c0.14-0.1,0.28-0.21,0.42-0.32c-1.26-1.78-2.53-3.56-3.79-5.34c-6.1-1.47-11.2-1.96-15.66-1.83 c-0.21-0.01-0.41-0.02-0.62-0.02l-14.87,0.89c-0.29,0.04-0.58,0.07-0.88,0.11c-14.81,1.93-32.77,5.89-62.15,5.89 c-35.22,0-44.91-14.55-47.19-19.5c0.03-2.69,1.38-5.59,4.15-8.76c-11.92-1.41-25.59,1.01-40.8,11.78 c-36.37,25.76-37.96,98.57-27.85,149.13c8.29,41.43,15.74,23.57,40.15,214.79c5.62,44.01,0,89.78,0,89.78 s158.91,30.31,249.73,4.09c0,0-10.97-90.54-5.6-156.24c22.06,29.32,30.4,39.52,50.51,44.31c0.05,0.02,0.09,0.04,0.14,0.06 c6.44,2.53,13.55,3.03,20.93,1.94c9.55-0.77,18.37-3.93,24.92-8.91c27.71-15.19,53.04-45.86,55.67-70.66 c1.1-10.4,25.48-48.64,26.56-60.24C500.99,716.21,500.25,708.75,498.24,701.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M497.44,699.09c0,0.02,0,0.04-0.01,0.06c0,0,0.7,2.18,0.71,2.46c0.01-0.04,0.03-0.08,0.04-0.13 c0.64-1.85,1.28-3.44,1.71-4.85c0.54-1.8,0.72-3.32,0.06-4.75c-0.08-0.16-0.15-0.32-0.22-0.47c-0.29-0.62-0.56-1.16-0.79-1.62 c-0.67-1.34-1.09-2.05-1.19-2.23c-0.02-0.03-0.03-0.05-0.03-0.05C497.12,690.48,498.01,694.83,497.44,699.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M106.9,432.77c0.37,1.3,0.58,2.05,0.58,2.05C107.32,434.16,107.12,433.47,106.9,432.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M433.26,451.42c0,0,2.04-1.29,3.9-1.02c1.74,0.25,8.04,1.71,9.49,2.67c0.17,0.11,0.28,0.17,0.35,0.19 c0.45,0.13-0.94-1.38-0.94-1.38c-0.02-0.01-0.05-0.02-0.07-0.02c-2.4-0.88-6.37-1.25-8.37-1.83 C435.37,449.37,433.26,451.42,433.26,451.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M281.1,374.8c-0.72,1.2-2.26,1.06-2.26,1.06C277.27,374.8,279.94,378.01,281.1,374.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M281.16,375.15l-1.77,1.93C281.04,376.46,281.16,375.15,281.16,375.15z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M230.32,481.64c-0.73-6.9-1.22-10.8-1.56-12.98c-0.48,3.19-1.14,7.92-1.76,13.34 c-0.4,5.22-0.88,10.87-1.4,15.49c-0.08,1.35-0.15,2.7-0.21,4.04c0.56-0.59,1.58-1.53,3.36-2.69c1.6-1.05,4.42-2.09,7.18-2.23 c-0.01-0.14-0.02,0.21-0.03,0.08c-0.01-0.27-0.02-1.02-0.02-1.3C231.04,493.12,231.23,490.25,230.32,481.64z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M328.82,527.12c0.35,0.81,0.31,1.72-0.19,1.96l-0.01,0.12l-0.25,0.84c0.1-0.26,0.45-0.74,0.64-0.91 c0.91-0.79,2.6-0.64,2.6-0.64"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M319.71,547.06c-0.82,0.6-1.58,1.08-2.19,1.3c0,0,3.66-1.47,3.36-1.02c-0.76,1.15-0.97,2.28-0.34,1.79 c0.63-0.49,1.21-1.31,3.84-4.22c2.77-3.07,6.96-5.35,5.43-5.18c-1.52,0.17-2.14,1.38-2.06,0.52c0.08-0.86,0.2-2.12-0.2-1.44 c-0.3,0.51-0.51,0.98-1.32,2.01c-0.26,0.33-0.59,0.71-1,1.18C324.05,543.31,321.71,545.58,319.71,547.06z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M247.49,531.11c2.52-1.92,5.67-4.2,8.08-4.12c2.76,0.09,7.12,0.33,9.08,1.11s2.65,2.97,5.05,3.12 c5.82,0.37,8.24,2.71,12.38,5.8c4.13,3.09,8.17,10.36,12.1,12.58c1.64,0.93,3.58,2.54,5.2,4.02l6.25,1.58 c1.29-0.24,2.95-0.18,4.89,0.74c0.68,0.32,1.29,0.66,1.87,0.96l0.56,0.14c0,0-0.77-0.94-1.91-2.59 c-1.13-1.66-1.54-3.31-0.83-3.96l-0.1-0.02l-0.07-0.41l-0.12-0.01c0,0-0.76,1.46-0.09,3.42c0.16,0.46,0.41,0.9,0.71,1.3 c-1.66-1.52-3.81-3.38-5.17-4.12c-2.47-1.35-7.63-0.45-11.22-3.14c-2.57-1.93-4.79-6.57-5.84-9.06 c-0.25-0.59-0.43-1.06-0.54-1.34c-0.07-0.19-0.11-0.3-0.11-0.3c-7.62,1.41-8.32-4.12-8.32-4.12s0.68,0.39-0.06-0.32 c-0.25-0.24-0.67-0.61-1.33-1.17c-0.46-0.38-1.03-0.85-1.75-1.43c-10.65-8.57-17.38-8.38-26.81-10.85 c-1.03-0.27-1.97-0.57-2.83-0.9c-0.07-0.03-0.14-0.06-0.21-0.08c-0.21-0.08-0.43-0.17-0.64-0.25 c-0.34-0.14-0.66-0.29-0.97-0.44c-0.22-0.11-0.44-0.23-0.65-0.35c-0.93-0.52-1.73-1.09-2.42-1.72 c-0.04-0.03-0.08-0.07-0.11-0.1c-1.78-1.69-2.78-3.83-3.29-6.54c-0.32-1.7-0.51-3.35-0.67-4.81l-0.36,5.82l-0.09,1.55 l0.26-2.32l0.12-1.02c-0.02,0.2-0.04,0.43-0.05,0.67c-0.05,1.16,0.03,2.72,0.18,4.31c0.31,3.48,0.89,7.13,0.89,7.13l0.18-0.87 l-0.45-3.82c0.08,0.69,0.32,1.54,0.65,2.49c0.51,1.45,1.24,3.1,1.99,4.66c0.71,1.46,1.43,2.83,1.98,3.86 c0.59,1.09,0.99,1.79,0.99,1.79l1.13,0.98L247.49,531.11z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M469.23,673.37c-3.28-1.01-2.97-0.92-4.09-1c0,0-2.97-0.34-6.65,1.22c-0.2,0.08-0.4,0.18-0.59,0.29 c-0.02,0.01-0.04,0.02-0.06,0.03c-0.01-0.25-0.02-0.49-0.04-0.72c-0.34-2.4-0.8-6.34-0.61-8.43c0.29-3.13,2.3-4.92,3.69-6.8 c1.39-1.88,1.44-4.68,1.71-8.27c0.27-3.59,1.41-5.05,2.38-6.63c0.04-0.06,0.07-0.13,0.11-0.19l-2.55-5.78 c0,0-0.03-0.02-0.09-0.04c-0.41-0.16-2.13-0.62-2.76,2.74c-0.72,3.84,1.1,5.27-0.59,8.64c-2.6,5.19-1.22,7.31-1.93,9.7 c-0.72,2.4-3.91,5.27-3.43,9.1c0.14,1.09,0.5,2.34,0.85,3.72c-1.11,3.63-5.22,11.73-9.92,16.88 c-5.36,5.87-5.02,9.01-7.32,17.43c-1.59,5.84-6.3,9.93-10.56,13.33c-0.67-0.65-1.32-1.3-1.96-1.95l0.11-0.09 c0,0-12.35-17.07-14.36-20.17c-3.89-5.98-3.06-9.22-3.88-17.88c-0.61-6.49-2.09,4.35-0.93,10.06s-1.51-0.34-3.66-9.63 c-2.15-9.28-2.48-0.25-0.16,5.39c2.33,5.64,2.63,4.65-1.3,3.34c-7.62-2.53,1.22,0.51,6.17,6.27c1.22,1.7,3.36,4.71,5.76,8.27 c3.65,5.65,7.61,12.17,9.26,14.91c0.36,0.67,0.71,1.32,1.03,1.96c-1.89,1.06-10.08,5.98-15.96,14.42 c-9.61-1.63-10.61-13.85-13.11-18.49c-5.3-9.85-11.74-12.88-10.23-20.46c1.52-7.58-12.12-23.11-15.91-33.34 c-3.79-10.23,3.59-37.1,0.83-29.2c-0.58,1.67-1.31,3.16-2.13,4.52c1.65-3.18,2.05-5.77,2.05-5.77 c-12.71,14.51-16.47-0.51-19.04-7.78c-2.58-7.32-4.31-12.49-4.31-6.89s3.44,17.66-2.58,8.18c-6.03-9.47-21.1-23.68-30.14-36.17 c-8.56-11.83-13.9-21.12-14.44-22.08c-0.03-0.05-0.05-0.09-0.05-0.09c-0.3,0.54-0.61,1.07-0.93,1.6 c-1.15,1.91-2.4,3.78-3.65,5.52l1.72-2.66l2.62-4.06c-2.84,1.8-4.94,2.06-10.55-2.02c-5.17-3.75-15.17-1.72-20.24-3.9 c-5.26-2.27-15.63,0.1-20.85-1.15c-0.61-0.15-0.94-0.38-1.09-0.63c0.25-1.47,1.16-3.04,3.05-3.55c2.1-0.57,5.27-0.13,6.83-0.14 c0.59,0,0.92-0.1,1.01-0.22c-0.06,0.03-0.12,0.06-0.18,0.09c0,0,0.43-0.48-1.15-0.7c-0.11-0.01-0.24-0.03-0.37-0.05 c-1.67-0.2-4.55-0.43-5.77-0.69c-1.32-0.28-1.6,0.18-2.43,0.23c-1.08,0.06-1.5-0.72-1.62-1.03c-0.2-0.25-0.4-0.57-0.63-0.97 c-1.57-2.78,1.09-4.76,1.09-4.76s-0.26,0.01-0.64-0.21c-1-0.49-1.29-1.53-1.29-1.53c-1.47-2.93,2.26-6,2.26-6 s-0.01-0.02-0.03-0.05c-0.88-1.33-1.08-2.96-0.53-4.49h-0.01c0,0-1.41,3.05-1.17,4.7c0.23,1.64-2.58,3.76-1.64,6.11 c0.94,2.35-0.7,3.99,0.47,6.57c1.17,2.58,1.88,5.64,1.41,7.75c-0.08,0.37-0.05,0.88,0.1,1.47c0.04,0.32,0.15,0.63,0.32,0.94 c1.1,2.65,4.15,6.05,8.97,6.05c6.57,0,9.16,2.58,11.51,4.46c2.35,1.88,8.45,3.76,11.74,3.05c3.29-0.7,6.34,6.34,8.45,9.39 c0.33,0.48,0.82,1.07,1.4,1.72l3.62,6.6c0,0,1.42,3.06,4.16,7.6c1.34,2.22,2.99,4.78,4.95,7.52 c5.25,9.05,11.41,18.77,17.47,26.24c15.22,18.76,29.21,23.9,39.95,23.99c0.64,1.3,1.36,2.67,2.16,4.12 c5.26,11.37,12.6,25.69,24.98,52.44c11.57,25.01,17.19,43.73,16.84,62.3c0,0,4.71-12.05,0.57-26.74c0,0,0.01,0.02,0.03,0.04 l4.23,9.2c2.38,6.95,4.56,17.55,2.82,30.94c-3.17,24.4,3.25,5.49,5.41-17.17c1.46-15.35-2.03-21.04-4.43-23.12 c3.77,2.4,11.61,8.76,13.63,20.93c2.7,16.18,9.95-19.77-8.93-23.55c-18.88-3.78,0.27-10.95,15.37-4.47 c0,0,3.24-6.47-11.33-5.93c-14.57,0.54,7.55-12.95,16.72-17.26c8.72-4.1-10.01-0.96-20.25,9.87c1.05-1.23,2.14-2.43,3.29-3.59 c1.53-1.55,3.14-3,4.82-4.31c-0.13,0.12-0.26,0.24-0.38,0.35c-0.16,0.15-0.29,0.28-0.4,0.4c-3.17,3.36,10.87-4.68,14.18-9.84 c0.38-0.6,0.87-1.43,1.44-2.42c1.18-2.08,2.69-4.9,4.28-7.91c3.6-6.86,7.58-14.74,8.89-17.35c4.39-5.33,8.41-6.24,11.68-7.28 c5.61-1.79,18.27-1.89,18.27-1.89c-0.79-0.3-2.06-0.75-3.66-1.24C473.26,674.32,472.3,674.31,469.23,673.37z M285,583.18 c-0.08,0.08-0.15,0.16-0.21,0.23c-0.02-0.19-0.03-0.37-0.03-0.56C284.84,582.96,284.92,583.07,285,583.18z M349.27,647.94 c0.43-0.05,0.85-0.11,1.25-0.17c1.85-0.3,3.53-0.76,5.03-1.36c-1.42,0.72-2.35,1.03-2.35,1.03S351.94,648.1,349.27,647.94z  M402.24,753.6c0.69,1.37,1.54,3.24,2.38,5.57C404.03,757.79,403.23,755.9,402.24,753.6z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M385.79,604.47c1.12-4.89,2.15-32.69,0.65-38.62c-1.53,4.02-3.36,8.36-5.49,13.04 c-0.41,0.9-0.78,1.83-1.12,2.79c-0.27,0.85-0.55,1.72-0.83,2.59c-3.67,12.77-2.75,29.13-7.41,41.45 c18.5-12.83,37.9,3.39,52.75,13.35c15.2,10.2,20.65,10.34,17.49,9.12c-3.16-1.22,5.31,3.73-18.99-14.75 c-27.64-21.01-28.88-17.41-28.66-24.94c0.04-1.23,0.52-9.27,3.85-16.89C400.46,586.07,384.37,610.7,385.79,604.47z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M311.32,869.84c-2.06-49.63,7.73-57.51,7.73-57.51c-16.5-31.17-78.3-131.08-77.39-160.42 c0.92-29.34-7.33,18.33-6.42,42.17c0.92,23.83-11-14.67-14.67-36.67c-3.67-22,4.58,27.5,5.5,37.59 c0.92,10.08-11.92-11.92-23.83-14.67c-11.92-2.75,14.89,23.62,23.15,52.95c8.25,29.34,11.99,37.82,9.24,74.49 c-2.75,36.67,70.8,62.03,39.64,80.37c-31.17,18.33-101.21,26.43-131.46,26.43s42.02,25.93,89.69,10.35 c47.67-15.58,6.93,21.9-49.9,24.65c-53.07,2.57,46.51,21.92,9.19,25.22c-1.41-0.34-3.04-0.7-4.88-1.08 c-45.97-9.43-104.31-25.37-86.06-56.58c15.28-26.12,7.86-53.71-10.9-108.15c-1.7-4.92-3.51-10.08-5.41-15.41l0.41,0.41 c-0.66-1.53-1.3-3.09-1.94-4.67c-2.34-6.5-4.79-13.23-7.31-20.1c-10.09-30.77-17.5-66.58-23.12-99.35 c-6.89-40.19-6.3-39.37-3.23,4.7c0.84,12.06-2.64,12.15-6.41,5.69c-0.35-0.98-0.69-1.95-1.04-2.91 c-3.71-15.69-6.47-26.51-6.73-25.05c-0.06,0.31,0,1.17,0.19,2.66c0.63,5.03,1.67,9.76,2.9,13.89c0.64,2.13,1.32,4.1,2.03,5.88 c1.64,5.85,3.81,13.73,6.18,22.75c0.26,1,0.53,2.01,0.8,3.04c4.11,18,8.44,37.46,11.57,51.6c1.81,8.17,3.21,14.56,3.93,17.85 c0.63,3.84,1.15,7.51,1.56,10.94c4.38,36.82,10.21,65.74,13.74,103.86c0.39,4.25,0.76,8.61,1.09,13.11 c0.16,2.2,0.32,4.42,0.46,6.69c2.86,44.72-2.25,63.96-2.25,63.96s8.94,1.17,22.75,3.8c3.12,0.59,6.48,1.26,10.04,2 c10.18,2.13,27.26,3.81,43.78,4.77c4.83,0.28,9.62,0.5,14.16,0.64c6.46,0.86,15.18,1.7,24.25,2.37 c11.45,0.84,23.46,1.42,32.14,1.42c5.04,0,10.21-0.1,15.36-0.28c26.6-0.89,52.25-3.64,52.43-3.65 C294.31,974.94,313.75,928.15,311.32,869.84z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M349.06,583.67c5.87,6.85,7.51,10.77,8.16,13.38s0.93-2.06-2.28-6.53c-3.21-4.46,2.04-0.35,4.65,2.86 c2.61,3.21,4.02-1.81-2.41-5.02c-3.18-1.59-9.09-6.57-14.27-11.21C345.08,579.3,347.27,581.58,349.06,583.67z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M342.9,577.15c-4.95-4.89-9.83-9.15-9.83-9.15S337.6,572.4,342.9,577.15z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M324.64,562.11l8.43,5.89c0,0,0.46-4.41,1.05-10.63c0.59-6.22,6.37-22.44,5.92-21.62 c-1.1,2.02-3.19,5.61-5.42,9.83c-1.36,2.58-2.78,5.39-4.06,8.24c-0.76,1.7-1.5,3.05-2.18,4.14 C326.23,561.41,324.64,562.11,324.64,562.11z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M450.66,451.88c-1.57,0.31-3.3,0.14-4.47-0.06c2.26,1.81,3.78,3.02,4.24,3.41 c9.48,8.17,15.56,9.25,16.33,9.49c0.17,0.05,0.35,0.07,0.51,0.04c0.18,0.15,0.38,0.31,0.58,0.42c0.55,0.32,0.69-0.14,0.46-0.46 c-0.16-0.23-0.31-0.41-0.43-0.55c0.04-0.33-0.08-0.81-0.48-1.46c-1.08-1.77-2.89-4.87-11.03-12.29 c-0.48-0.43-1.09-0.84-1.73-1.32C454.04,450.79,452.42,451.53,450.66,451.88z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M286.53,359.13c-1.48,2.18-3.31,8.99-3.31,8.99s2.78-2.47,5.31-4.82c0.36-0.33,0.66-0.75,0.91-1.21 c1.18-2.16,1.23-5.29,0.26-4.93c-0.06,0.02-0.12,0.05-0.18,0.09C289.52,357.26,288,356.96,286.53,359.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M285.92,368.25c0,0-2.74,2.63-4.27,5.75c-0.09,0.13-0.18,0.26-0.27,0.4c0,0,0.02,0.02,0.06,0.05 c-0.04,0.08-0.06,0.12-0.06,0.12c0.02-0.04,0.04-0.08,0.06-0.12c0.29,0.24,1.63,1.28,2.5,1.16c0,0,0.71-2.28,0.63-3.89 c0.42-0.17,0.89-0.32,1.42-0.43c0.03-0.01,0.06-0.01,0.08-0.02c3.65-0.7,3-1.01,3-1.01s-1.69-0.11-2.55-0.04 c-0.22,0.02-0.39,0.04-0.46,0.09C285.74,370.51,285.92,368.25,285.92,368.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M290.81,410.63c-2.05-3.17-1.85-9.76-3.12-14.28c-1.27-4.52-3.25-8.46-4.12-15.77 c0.11,3.85-0.5,7.34,2.44,16.11c2.94,8.77,3.01,13.46,2.82,22.08c0,0,0.98-0.85,2.27-1.76c0.15-0.11,0.33-0.2,0.5-0.3 c1.35-0.79,3.16-1.67,5.31-2.23C300.88,413.45,292.86,413.81,290.81,410.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M233.06,424.87c0,0-14.11-15.22-15.24-28.49C217.82,396.39,219.42,419.91,233.06,424.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M227.53,375.3c4.15,0.84,7.24,6.34,3.31,11.13c-3.93,4.79-5.34,6.85-6.21,10.54 c-0.87,3.69,1.78,7.08,1.78,7.08s0.55-2.83,1.44-6.25c0.89-3.42,5.04,1.24,9.02-2.99c3.98-4.23,1.24-15.69-0.37-18.34 c-1.61-2.65-4.72-6.84-10.9-5.2c-6.17,1.64-7.52,8.99-8.86,14.11C216.75,385.4,221.71,374.12,227.53,375.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M231.8,402.49c-1.79,2.1,3.22,10.02,5.85,13.14c2.63,3.12,5.14,0.12,2.32-5.21 c-2.82-5.33-0.95-6.6,0.38-9.49c1.33-2.9-0.11-3.61-0.11-3.61C237.46,401.73,233.6,400.39,231.8,402.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M418.45,430.25c-4.34-2.69-5.09-0.75-4.34,1.94c0.75,2.69,3.44,5.53,2.24,5.83 c-1.2,0.3-5.98,2.09-3.74,1.79c0.21-0.03,0.44-0.06,0.67-0.1c2.09-0.7,4.63-1.34,7.7-1.59c0.81-0.07,1.55-0.13,2.22-0.18 c1.64-0.22,3.46-0.38,4.47-0.46c-2.78-2.22-5.67-4.51-8.55-6.81C418.9,430.53,418.67,430.39,418.45,430.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M427.68,437.49c0.04,0.03,0.08,0.06,0.12,0.1c2.21-0.21,3.49-0.43,5.86-1.05 c1.03-0.27,2.06-0.53,3.08-0.73c-5.42-4.16-11.29-8.67-16.96-13.02c-14.91-11.45-28.45-21.86-28.9-22.21 c-1-0.77-0.93,0.31-1.23,0s-3.24-2.78-4.86-1.08c-1.62,1.7,2.31,4.4,2.62,4.71s-0.83,0.68-0.22,1.07c0,0,6.98,5.55,16.31,12.97 c4.8,3.82,10.22,8.13,15.64,12.44C422.02,432.98,424.9,435.27,427.68,437.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB9996",
    d: "M327.31,531.5c-0.66,1.8-1.38,2.13-3.16,3.24c-1.78,1.11-3.13,1.86-4.42,3.02 c-1.29,1.15-0.54,2.6-2.42,3.7c-1.87,1.1-2.02,1.58-2.8,3.57c-0.78,1.99-0.84,2.57-2.4,3.51s-2.17,1.08-2.49,2.42 c1.09-1.31,1.46-1.27,2.29-1.75c0.84-0.47,1.45-0.45,2.71-1.22c1.25-0.76,3.88-0.16,5.53-1.33c3.81-2.7,6.03-5.51,7.2-7.65 c1.13-2.08,0.7-5.07,0.73-6.34c0.02-1.28,1.17-4.02,1.17-4.02C328.42,529.15,327.97,529.7,327.31,531.5z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M331.61,528.51c-2.41-0.92-3.15-2.2-2.8-1.39"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M310.05,550.06l0.13,0.34l-0.07,0.06c0,0,0.01-0.09,1.69-1.17c1.98-1.27,2.7-1.12,3.13-2.23 s0.48-1.42,2.89-3.17c2.41-1.75,2.92-2.56,4.29-5.19c1.37-2.63,3.28-2.79,4.65-4.47c1.32-1.62,1.48-3.67,1.83-5.01 c0.01-0.05,0.03-0.1,0.04-0.15c0,0-0.07,0.1-0.16,0.26c-0.23,0.38-0.66,1.08-0.95,1.6c-0.07,0.12-0.13,0.25-0.19,0.38 c-0.29,0.63-0.49,1.31-0.94,1.87c-0.23,0.29-0.84,0.63-1.66,1.19c-1.1,0.76-2.4,1.56-3.4,2.18c-0.26,0.16-0.57,0.36-0.77,0.49 c-0.96,0.64-1.42,1.24-1.63,1.86c-0.04,0.13-0.08,0.28-0.11,0.43c-0.1,0.53-0.25,0.87-0.49,1.18c-0.23,0.29-0.55,0.56-1.01,0.94 c-0.2,0.16-0.61,0.37-0.82,0.54c-0.63,0.49-1.07,0.97-1.52,1.8c-0.11,0.21-0.22,0.43-0.31,0.69c-0.02,0.07-0.05,0.13-0.07,0.2 c-0.51,1.49-0.7,2.03-1.15,2.73c-0.29,0.45-2.02,1.45-2.81,2.02C310.1,549.83,310.07,550.13,310.05,550.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M308.54,537.28c-1.41,0.3-2.72,0.8-3.65,2.22c-1.03,1.57,0.08,1.19,1.15,0.31 c0.79-0.65,2.03-1.77,2.62-2.31C308.75,537.41,308.66,537.25,308.54,537.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M312.62,530c-1.26,0.79-2.08,2.84-2.03,4.44c0,0.1,0.14,0.13,0.19,0.04c0.32-0.65,1.09-2.13,2-3.09 C313.98,530.13,313.97,529.15,312.62,530z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M302.06,542.21c-0.67-0.28-1.17-0.91-1.39-1.62c-0.11-0.32-0.17-0.82-0.34-1.24 c-0.16-0.43-0.38-0.86-0.68-1.21c-0.58-0.72-1.3-1.22-2.05-1.67c0.51,0.71,1.1,1.35,1.5,2.05c0.19,0.35,0.36,0.71,0.46,1.09 c0.12,0.39,0.15,0.75,0.29,1.25c0.29,0.91,1.01,1.76,2,2c0.48,0.12,0.99,0.07,1.42-0.1c0.43-0.18,0.79-0.46,1.09-0.78 c-0.41,0.17-0.8,0.32-1.2,0.37C302.78,542.39,302.4,542.34,302.06,542.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M312.04,527.27c0.74-0.01,1.5,0.27,1.97,0.82c0.23,0.28,0.4,0.63,0.47,1.02c0.07,0.4,0.05,0.82,0.01,1.26 c0.22-0.38,0.37-0.81,0.41-1.28c0.03-0.46-0.08-0.96-0.34-1.39c-0.53-0.87-1.55-1.3-2.51-1.3c-0.52,0.02-0.88,0.1-1.28,0.11 c-0.4,0.02-0.78-0.03-1.18-0.1c-0.79-0.17-1.58-0.53-2.41-0.8c0.66,0.57,1.35,1.11,2.22,1.44c0.43,0.17,0.9,0.25,1.36,0.28 C311.21,527.36,311.7,527.27,312.04,527.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M308.01,497.01c2.97-2.37,4.14-3.9,4.14-3.9s-2.82-0.05-8.75,5.46s-8.18,12.67-6.7,10.58 C298.8,506.2,303.29,500.77,308.01,497.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M304.71,515.17c0.05,0.14,0.1,0.28,0.15,0.42c0.07-0.27,0.15-0.53,0.22-0.8c0.13,0.1,0.23,0.24,0.29,0.39 c0.03-0.27,0.11-0.54,0.25-0.78c0.07,0.11,0.17,0.21,0.29,0.27c-0.01-0.26,0.06-0.52,0.19-0.74c0.13,0.27,0.33,0.5,0.57,0.66 c0-0.35,0.04-0.7,0.14-1.04c0.16,0.18,0.31,0.35,0.47,0.53c0.01-0.32,0.01-0.65,0.02-0.97c0.15,0.19,0.31,0.38,0.46,0.57 c-0.03-0.32-0.06-0.64-0.1-0.97c0.21,0.31,0.47,0.58,0.75,0.83c-0.1-0.53-0.16-1.07-0.21-1.62c0.56,0.26,1.1,0.73,1.51,1.16 c-0.4-0.52-0.72-1.11-0.97-1.73c0.01-0.01,0.03-0.02,0.04-0.03c0.52,0.4,1.04,0.8,1.56,1.2c-0.4-0.52-0.7-1.13-0.88-1.78 c0.01-0.01,0.01-0.01,0.02-0.02c0.42,0.24,0.84,0.49,1.27,0.73c-0.26-0.4-0.46-0.84-0.61-1.3c0.05-0.04,0.1-0.09,0.15-0.13 c0.35,0.17,0.72,0.28,1.1,0.33c-0.25-0.23-0.45-0.52-0.57-0.85c0.08-0.08,0.15-0.17,0.23-0.25c0.28-0.04,0.55-0.08,0.83-0.12 c-0.15-0.11-0.29-0.24-0.42-0.38c0.04-0.05,0.07-0.09,0.11-0.14c0.71,0.08,0.92,0.2,1.73-0.06c-0.71-0.12-1.08-0.27-1.36-0.45 c0,0,0,0,0,0c0.8-0.02,1.59-0.21,2.33-0.55c-0.63-0.05-1.26-0.09-1.88-0.14c0.02-0.04,0.05-0.07,0.07-0.11 c0.65-0.13,1.29-0.34,1.9-0.63c-0.5,0.07-1,0.04-1.49-0.06c0.12-0.22,0.25-0.45,0.38-0.7c0.31-0.16,0.61-0.33,0.9-0.54 c-0.21,0.02-0.42,0.02-0.63,0c0.07-0.14,0.14-0.29,0.2-0.44c0.45-0.19,0.88-0.41,1.29-0.68c-0.33,0.01-0.67,0.02-1,0.02 c0.03-0.08,0.07-0.16,0.1-0.24c0.22-0.13,0.43-0.29,0.61-0.48c-0.14,0-0.27,0-0.41,0c0.07-0.16,0.13-0.32,0.19-0.48 c0.1-0.07,0.2-0.15,0.3-0.24c-0.06-0.03-0.12-0.06-0.17-0.08c0.02-0.04,0.03-0.09,0.05-0.13c0.04-0.02,0.08-0.04,0.13-0.06 c0.24-0.09,0.47-0.18,0.71-0.27c-0.2,0.02-0.4,0.07-0.59,0.14c0.16-0.03,0.31-0.12,0.41-0.26c-0.11,0.01-0.22,0.03-0.33,0.04 c0.33-0.23,0.62-0.52,0.85-0.84c-0.24,0.11-0.48,0.22-0.71,0.33c0.25-0.18,0.49-0.39,0.71-0.62c-0.19,0.03-0.37,0.11-0.53,0.21 c0.26-0.19,0.48-0.43,0.64-0.7c-0.14,0.04-0.28,0.07-0.43,0.11c0.23-0.21,0.44-0.43,0.62-0.68c-0.13,0-0.25,0.05-0.35,0.13 c0.13-0.16,0.26-0.31,0.4-0.47c-0.06-0.05-0.16-0.04-0.22,0.02c0.1-0.12,0.2-0.25,0.3-0.37c-0.07-0.06-0.19-0.04-0.23,0.05 c0.28-0.5,0.43-1.08,0.44-1.65c0-0.11-0.02-0.24-0.13-0.26c-0.01,0-0.03,0-0.04,0c0.03-0.17,0.03-0.27,0.01-0.28 c-0.24-0.07-1.46,3.36-2.97,6.34c-1.51,2.98-2.94,5.02-5.64,7.6c-2.71,2.58-3.63,4.04-3.51,4.11c0.02,0.01,0.09-0.02,0.18-0.09 c0,0.23,0.1,0.48,0.12,0.69C304.59,515.6,304.65,515.38,304.71,515.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M307.48,515.32l-1.11,0.6c7.39-2.3,10.62-9.32,10.62-9.32C313.35,512.17,307.48,515.32,307.48,515.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M336.18,489.89c2.09,4.16,2.18,10.5,2.18,10.5C339.95,497.21,336.18,489.89,336.18,489.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M334.84,493.38c-0.68-0.42-1.14,0.47-2.4-0.53c0,0-0.14,0.39,0.6,1.11c0.74,0.71,1.29,0.87,1.71,2.83 c0.41,1.96,1.38,2.56,1.31,1.29C336,496.82,335.53,493.8,334.84,493.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M276.43,532.93c0.55,0.3,1.08,0.63,1.61,0.98c2.33-3.26,4.82-6.12,6.46-7.81 C286.13,524.42,280.7,527.22,276.43,532.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M290.34,534.01c-0.09-0.02-0.19-0.03-0.28,0.01c0.05-0.18,0.07-0.32,0.03-0.41c0,0-1.08,0.8-1.87,2.31 c-0.41,0.79-1.54,2.44-2.91,4.2c0.29,0.33,0.58,0.68,0.87,1.02c0.01-0.16,0.02-0.31,0.02-0.47c0.08,0.18,0.15,0.37,0.23,0.55 c-0.04-0.33-0.03-0.66,0.03-0.99c0.17,0.2,0.31,0.42,0.42,0.66c-0.01-0.35-0.03-0.71-0.04-1.06c0.09,0.13,0.19,0.25,0.28,0.38 c0-0.23-0.01-0.46-0.01-0.7c0.13,0.11,0.27,0.22,0.4,0.33c-0.03-0.29-0.06-0.58-0.1-0.87c0.16,0.13,0.32,0.25,0.49,0.38 c-0.05-0.26-0.1-0.53-0.15-0.79c0.16,0.15,0.32,0.31,0.48,0.46c-0.03-0.26-0.07-0.53-0.1-0.79c0.13,0.12,0.28,0.21,0.44,0.28 c-0.04-0.32-0.09-0.63-0.13-0.95c0.16,0.12,0.35,0.2,0.55,0.24c-0.15-0.2-0.29-0.4-0.44-0.6c0.24,0.07,0.46,0.17,0.67,0.31 c-0.11-0.18-0.21-0.36-0.32-0.55c0.14,0.08,0.28,0.17,0.43,0.25c-0.09-0.16-0.18-0.32-0.27-0.48c0.16,0.12,0.34,0.21,0.52,0.27 c-0.1-0.19-0.18-0.4-0.25-0.6c0.12,0.02,0.25,0.04,0.37,0.05c-0.12-0.17-0.27-0.31-0.45-0.42c0.22,0,0.43-0.03,0.63-0.1 c-0.11-0.06-0.23-0.1-0.36-0.13c0.13-0.16,0.36-0.25,0.57-0.22c-0.17-0.1-0.33-0.2-0.5-0.3c0.33-0.03,0.66-0.14,0.93-0.34 c-0.18-0.14-0.41-0.2-0.63-0.17c0.23-0.15,0.49-0.23,0.76-0.24c-0.25-0.07-0.51-0.1-0.77-0.09c0,0,0-0.01,0-0.01 c0.23-0.06,0.46-0.15,0.67-0.25c-0.17-0.02-0.34-0.04-0.52-0.05c0.28-0.01,0.55-0.02,0.83-0.03 C290.7,534.11,290.53,534.06,290.34,534.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M255.04,553.1l-7.26-1.16c-2.03,0.11-3.69-3.87-3.13-2.21c0.55,1.66,2.34,2.49,1.74,2.81 c-0.6,0.31-1.23,0.42-2.15-0.21c0,0,0.01,0.05,0.04,0.13c0.12,0.31,0.53,1.09,1.62,1.03c0.83-0.05,1.11-0.51,2.43-0.23 c1.23,0.26,4.1,0.49,5.77,0.69c0.13,0.02,0.26,0.03,0.37,0.05c1.58,0.22,1.15,0.7,1.15,0.7c0.07-0.03,0.13-0.06,0.18-0.09 C256.61,554.11,256.44,553.13,255.04,553.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M253.36,544.77c2.9,0.26,3.87,0.14,4.69,0.14l-5.7-0.95c-1.4-0.11-2.67-0.46-4.76,0.51 c-1.89,0.87-3.48,2.05-4.81,0.53c0,0,0.3,1.04,1.29,1.53c0.19,0.09,0.4,0.17,0.64,0.21c1.09-0.66,2.74-1.4,3.91-1.9 S250.47,544.51,253.36,544.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M255.5,535.37c1.67,0.4,5.41,1.58,6.41,2.12l-5.16-3.38c-1.46,0.1-4.3,0.15-5.46,0.85 c-1.16,0.7-3.73,2.34-4.89,3.03c-1.13,0.68-1.89-0.13-1.94-0.18c0,0.01,0.01,0.02,0.01,0.02c0.31,0.69,0.49,1.01,0.55,1.12 c0.02,0.03,0.03,0.05,0.03,0.05s1.38-0.79,3.75-2.14C252.48,534.77,254.22,535.07,255.5,535.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M462.64,649.56c-0.46,3.72-0.33,6.39-1.71,8.27c-1.39,1.88-3.23,3.19-3.76,6.29 c-0.64,3.69,0.22,6.73,0.56,9.14c0.04,0.25,0.13,0.32,0.16,0.54c6.41-3.23,12.89,0.43,17.65,1.37c0.11,0.02,0.21,0.05,0.31,0.07 c-1.89-3.2-4.18-6.61-5.18-9.63c-3.58-10.8-4.02-20.09-4.27-21.16c-0.37-1.63,0.11-3.04,3.3-4.31c3.19-1.27,6.36,0,6.36,0 c-7.45-3.83-9.38,1.91-8.9-0.12c0.47-1.96-0.08-2.11,0.7-3.26c0.03-0.04,0.05-0.08,0.08-0.12c0,0-0.95,0.6-1.33,1.9 c-0.38,1.28-0.61,2.76-1.54,4.31c-0.02,0.03-0.03,0.05-0.04,0.08C464.05,644.51,463.18,645.14,462.64,649.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M489.51,663.28c0.37,3.33,2.61-1.16,3.23-2.96c0,0-1.04-0.55-1.93-1.76c-0.58-0.8-1.09-1.88-1.2-3.29 C489.33,657.57,489.15,659.95,489.51,663.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M495.52,677.63c0.2,3.3,1.64-1.65,1.97-2.63c0.02-0.08,0.03-0.16,0.02-0.24 c-0.05-0.55-0.72-1.27-1.32-2.1c-0.37-0.52-0.7-1.07-0.84-1.67C495.37,672.67,495.4,675.7,495.52,677.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1A",
    d: "M205.27,429.96c5.94-38.35,2.4-58.61,18.18-63.8c14.18-4.67,19.24,13.96,21,25.44 c0.02,0.44,0.06,0.87,0.12,1.31c0.44,3.21,0.79,6.68,1.02,10.76c1.11,8.97,2.37,13.49,1.33,19.54c-0.27,1.57-0.73,2.76-1.31,3.63 c-0.12,3.35-0.29,6.97-0.51,10.93c-0.56,9.96-5.61,26.78-6.91,41.82c0.06-0.13,19.37-4.9,23.76-7.16 c4.76-2.45,12.72-5.8,16.48-7.69c4.72-2.37,6.37-9.21,6.73-9.25c0.05-1.49,0.02-2.5-0.16-3.19c0.45-0.9,0.85-2.19,1.12-3.89 c0.08-0.5,0.26-1.31,0.51-2.34c0.2-0.83-0.11-1.68-0.76-2.23c-0.05-0.04-0.09-0.09-0.14-0.15c-1.09-1.36-1.14-7.25-1.14-9.68 c0-5.02,0.63-4.42,2.43-5.19c0.21-0.09,0.41-0.16,0.6-0.23c1.4-0.46,2.18-0.3,2.86-2.34c0.04-0.12,0.08-0.19,0.11-0.24 c0.21-3.48-0.2-6.12-1.79-6.76c-0.04-0.02-0.07-0.04-0.12-0.05c-8.07,4.01-24.1-10.31-27.01-39.26 c-0.44-4.34-0.92-7.85-1.42-10.68c-0.13-6.74,0.23-13.9,1.84-21.08c6.22-27.69,8.08-9.66,20.33-19.94 c0.87-0.73,1.8-1.6,2.78-2.65c0.86-0.92,1.62-1.91,2.3-2.97c-0.71,4.24-2.19,7.47-3.55,9.68c-1.45,2.39-2.75,3.59-2.75,3.59 s1.1-0.56,3.07-2.7c1.49-1.62,3.47-4.14,5.85-8c4.39-7.14,4.6-15.16,2.26-21.58c2.14,3.13,3.31,5.47,3.31,5.47 c-1.34-9.36-5.21-15.78-9.07-19.98c-0.58-1.09-1.21-2.15-1.88-3.16c5.09,2.76,6.63,5.16,6.63,5.16 c-4.35-8.46-11.47-13.98-20.25-16.59c-2.29-0.87-4.73-1.4-7.32-1.51c-0.35-0.02-0.68-0.04-1.01-0.06 c-0.17-0.02-0.35-0.02-0.53-0.03c-5.35-0.43-9.29-1.83-12.88-3.9c9.79,1.51,18.23,1.43,10.74-0.14 c-10.83-2.28-19.56-7.23-19.56-7.23l20.8,3.6c0,0-8.19-2.13-19.48-9.78c-11.26-7.62-29.34-11.77-37.61-11.17 c-15.88-0.91-31.61,7.51-56.95,8.36c-15.03,0.51-28.56,7.06-38.53,17.18c-7.64,6.78-16.2,16.58-20.41,30.75 c-5.56,18.69-7.58,28.28-7.58,28.28s5.8-14.9,9.43-23.21c3.63-8.31-1.3,6.49-4.67,20.77c-3.38,14.28,1.3,42.84,1.3,42.84 S84,347.1,92.45,324.92c-2.21,11.8-6.45,30.04-3.79,54.39c0.72,6.57,2.05,12.55,3.71,18.01c0.48,1.57,0.98,3.1,1.5,4.59 c4.57,13.07,10.57,22.96,13.04,30.86c-1.8-6.37-7.4-26.24-11.01-39.47c-0.49-1.79-0.77-3.77-0.91-5.86 c3.54,13.89,8.18,26.43,12.38,36.82c5.75,14.24,10.17,34.71,11.67,42.14c0.36,1.8,0.56,2.83,0.56,2.83 C156.81,490.52,198.82,471.65,205.27,429.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M282.48,454.29c-2.7,0.11-5.38,0.68-7.89,1.68c0.59-1.13,1.18-2.27,1.77-3.4 c-1.73,1.35-3.46,2.71-5.19,4.06c0.55-1.04,1.1-2.08,1.65-3.12c-1.86,1.14-3.75,2.23-5.64,3.32c0.37-0.57,0.62-1.19,0.57-1.86 c-0.61,0.88-1.41,1.61-2.34,2.14c0.65-0.95,1.08-2.05,1.25-3.19c-0.77,2.05-2.34,3.78-4.31,4.73c0.92-1.34,1.85-2.67,2.77-4.01 c-2.01,2.18-4.02,4.36-6.19,6.37c0.9-1.29,1.51-2.77,1.79-4.32c-0.49,1.41-1.22,2.73-2.13,3.91c-0.01-0.08-0.02-0.17-0.03-0.25 c-0.06,0.06-0.12,0.12-0.18,0.19c0.02-0.15,0.05-0.3,0.07-0.45c-0.14,0.26-0.28,0.53-0.41,0.8c-0.13,0.13-0.25,0.26-0.38,0.38 c0.18-0.67,0.35-1.35,0.53-2.02c-0.49,0.66-1.05,1.25-1.69,1.76c-0.02-0.07-0.04-0.14-0.06-0.21c0.06-0.32,0.12-0.63,0.18-0.95 c-0.06,0.28-0.13,0.56-0.2,0.84c-0.08-0.37-0.09-0.76-0.02-1.14c-0.4,0.74-0.85,1.46-1.33,2.16c0.14-1.24,0.2-2.48,0.16-3.72 c-0.25,1.69-0.62,3.36-1.09,5c-0.05,0.06-0.09,0.12-0.13,0.18c0.23-1.03,0.29-2.1,0.2-3.15c-0.42,0.81-0.83,1.61-1.25,2.42 c-0.08-0.43-0.17-0.86-0.26-1.29c0.1-0.66,0.2-1.32,0.31-1.98c-0.18,0.33-0.35,0.67-0.51,1.01c-0.19-0.85-0.38-1.7-0.58-2.53 c-0.04,1.57-0.16,3.13-0.34,4.69c-0.19,0.51-0.35,1.03-0.5,1.56c-0.01-0.1-0.02-0.19-0.03-0.29c0.14-0.75,0.28-1.5,0.42-2.25 c-0.17,0.4-0.35,0.8-0.52,1.2c-0.08-0.83-0.17-1.65-0.25-2.48c0.07-0.4,0.15-0.79,0.22-1.19c-0.07,0.33-0.15,0.66-0.24,0.99 c-0.15-1.48-0.3-2.95-0.45-4.43c-0.02,0.46-0.05,0.91-0.07,1.37c-0.08-0.6-0.17-1.2-0.26-1.8c-0.15,1.35-0.35,2.7-0.6,4.04 c0.03-0.76,0.04-1.53,0.01-2.29c-0.24,1.61-0.58,3.21-0.99,4.78c-0.04-3.06-0.08-6.12-0.12-9.19c-0.48,3.81-1.13,7.6-1.92,11.36 c-0.07-0.29-0.15-0.57-0.23-0.86c0.04,0.51,0.06,1.03,0.09,1.54c-0.11,0.49-0.21,0.99-0.32,1.48c-0.14-0.52-0.28-1.04-0.42-1.56 c-0.02,1.21-0.43,2.41-1.16,3.37c-0.26-1.05-0.3-2.16-0.11-3.22c-0.55,1.33-0.87,2.77-0.94,4.21c0.25-2.77,0.1-5.58-0.47-8.31 c-0.08,5.21-1.27,9.95-2.47,15.07c-0.03,0.06-0.07,0.12-0.11,0.18l0.04-0.14c-0.32,0.58-0.62,1.17-0.9,1.77 c-0.15,0.3-0.29,0.59-0.43,0.89c-0.03,0.09-0.06,0.18-0.08,0.26c-0.22,0.52-0.42,1.04-0.61,1.57c-0.76,2.13-1.28,4.35-1.55,6.6 c-0.08,0.38-0.11,0.78-0.16,1.12c-0.16,0.97-0.29,1.95-0.38,2.93c-0.19,1.98-0.23,3.98-0.14,5.96c0,0.02,0,0.05,0,0.07 c0.05,1.1,0.15,2.2,0.29,3.29c0.07,0.56,0.15,1.11,0.25,1.67c0.09,0.5,0.31,1.1,0.3,1.6c0.02-1.57,0.04-3.13,0.05-4.7 c0.55,4.09,0.61,8.26,0.15,12.36c0.48-1.6,0.8-3.24,0.95-4.9c-0.42,4.57-0.17,9.2,0.75,13.7c-0.11-1.95-0.23-3.89-0.34-5.84 c0.41,3.89,1.95,7.64,4.35,10.73c0.25,0.52,0.51,1.03,0.79,1.53c0.07,0.13,0.14,0.27,0.21,0.4c-0.12-0.15-0.24-0.29-0.37-0.44 c-0.18-0.22-0.36-0.43-0.54-0.65c0.15,0.21,0.3,0.42,0.45,0.63c1.26,1.78,2.53,3.56,3.79,5.34c0.26-0.2,0.53-0.4,0.8-0.61 c-2.01-3.11-3.74-6.45-5.4-9.74c0-0.01-0.01-0.02-0.01-0.03c1.72,3.28,3.66,6.44,5.82,9.46c0.05-0.04,0.1-0.07,0.15-0.11 c-2.99-4.95-4.94-10.51-6.85-16c1.87,4.07,4.06,7.99,6.52,11.73c-1.76-3.99-3.36-8.04-4.82-12.14c1.01,2.1,2.19,4.12,3.52,6.03 c-0.55-1.52-1.1-3.05-1.65-4.57c0.63,1.07,1.27,2.14,1.9,3.2c-2.51-6.23-3.93-12.89-4.19-19.59c1.93,6.12,4.54,12.03,7.74,17.59 c-3.4-7.78-3.51-10.05-5.34-18.34c2.38,5.63,2.58,5.27,5.61,10.58c-1.99-6.12-3.82-12.3-5.46-18.53 c1.42,3.81,4.77,13.33,6.94,16.77c-2.57-6.54-2.81-9.98-3.65-12.3c0.73,1.53,1.62,2.98,2.68,4.3c-0.34-1.56-0.67-3.12-1.01-4.68 c0.82,1.22,1.64,2.44,2.45,3.66c-0.11-3.76-1.14-7.49-2.97-10.78c1.73,3.24,3.47,6.49,5.2,9.73c-1.19-4.33-2.38-8.65-3.57-12.98 c1.04,2.43,2.22,4.8,3.55,7.09c0-1.59-0.23-3.17-0.66-4.7c0.35,0.65,0.79,1.25,1.31,1.77c-0.04-1.46-0.25-2.92-0.61-4.33 c0.26,0.74,0.67,1.43,1.19,2.01c0.03-1.58,1.15-5.89,1.17-7.47c0.45-1.29-0.19,0.13,0.27-1.16c0.19,1.39-0.42,6.56,0.93,6.16 c-0.33-1.35,1.53-6.85,1.2-8.2c1.24,0.89,1.98,4.04,2.85,6.63c-0.21-0.74,0.82-7.17,0.17-7.59c1.49,0.87,3.32,1.78,3.87,4.76 c0.22-0.84,0.91-6.18,0.12-6.56c2.79,0.95,10.2-0.63,12.83-1.97c-1.5-0.58-6.96-0.49-7.5-2.01c4.38,0.88,9.93,0.01,15.67,2.65 c-0.22-0.61-2.48-2.79-3.61-3.44c2.06,0.83,2.66,0.82,5.05,1.49c3.8,1.06,7.88,2.15,7.88,2.15s-3.03-1.98-5.57-3.59 c2.16,0.91,4.7,1.64,6.02,1.82c3.32,0.44,5.45,0.1,7.46,0.06l-0.74,1.66c4.52,2.29,8.48,5.69,11.44,9.81 c-0.65-1.71-1.57-3.32-2.71-4.75c1.79,1.77,3.58,3.53,5.37,5.3c-0.97-1.01-1.71-2.23-2.17-3.55c1.69,1.64,3.38,3.28,5.07,4.93 c-0.83-1.08-1.43-2.33-1.77-3.65c2.19,2.38,4.31,4.83,6.35,7.35c-0.58-1.69-1.16-3.39-1.74-5.08c1.51,1.83,3.02,3.67,4.52,5.5 c-0.23-0.81-0.45-1.61-0.68-2.42c0.61,0.9,1.22,1.73,1.89,2.49c0.54,1.53,1.67,3.91,2.78,4.51c1.44,0.79,1.38-1.13,2.13-0.2 s1.34,1.71,1.34,1.71s-0.11-1.35-0.9-2.37c-0.79-1.01-1.4-1.46-2.93-2.43c-0.28-0.18-0.53-0.39-0.73-0.63 c-0.09-0.11-0.17-0.23-0.26-0.34c-0.68-1.01-0.77-2.25-0.33-2.8c0.84-1.07,3.67,1.73,3.67,1.73c-1.12-1.39-2.63-3.45-4.02-3.18 c-0.94,0.18-1.17,0.99-1.17,1.81c-0.69-0.92-1.38-1.83-2.06-2.72c-0.08-0.11-0.16-0.21-0.24-0.32c-0.13-0.16-0.25-0.33-0.37-0.49 c-1.95-2.52-3.81-4.64-6.23-6.83c-1.39-1.26-2.9-2.37-4.47-3.39c-3.69-4.86-7.8-9.46-13.31-11.9c0.78,0.59,1.56,1.18,2.33,1.77 c-3.19-1.78-3.52-2.08-4.72-2.46c0.76,0.24-4.13-1.99-3.59-1.41c2.93,2.11-2-0.3-5.87,0.53c1-0.26,3.2-1.35,4-1.47 c-2.58,0.19-5.15,0.38-7.73,0.58c0.44-0.67,1-1.28,1.63-1.77c-1.21,0.13-2.41,0.25-3.62,0.38c-1.36,0.14-2.73,0.29-4.09,0.43 C281.53,455.38,282.01,454.84,282.48,454.29z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "cloud-left",
    fill: "#E1D9C8",
    d: "M739.06,236.77c-41.13-4.57-46.52-35.5-87.53-26.32c-32.52,7.28-47.5-16.36-75.59,0.16 c-4.74,2.79-8.35,6.13-10.22,8.03c6.24,2.09,9.7,6.03,11.38,8.59c7.46-1.24,13.98,1.12,13.98,1.12c6.57-6.91,15.9-6.22,15.9-6.22 c-12.79,2.07-15.56,10.03-15.56,10.03c-17.29-7.95-30.43,6.57-30.43,6.57c3.92-6.9,9.38-9.98,14.56-11.19 c-10.35-7.27-22.67-10.93-40.06-6.29c-7.27,2.46-16.59,6.64-28.93,13.49c-20.49,11.39-79.1,17.63-122.22,18.81l415.65-5.98 C800.01,247.57,802.43,243.82,739.06,236.77z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "line",
    x: 917,
    y: 309.44,
    width: 1943,
    height: 15
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 2398.7646 390.417)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "24px"
  }, "\u2026 und mit "), /*#__PURE__*/React.createElement("tspan", {
    x: 115.9,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "30px"
  }, "MINUS 53% "), /*#__PURE__*/React.createElement("tspan", {
    x: 272.39,
    y: 0,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "24px"
  }, "sogar \xFCbertroffen!")))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "story-header-text-left"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 790.415 274.1221)",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "127px",
    letterSpacing: -2
  }, "gesagt"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 917 396.4404)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "24px"
  }, "Wir wollen die"), /*#__PURE__*/React.createElement("tspan", {
    x: 153.97,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "24px"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 158.31,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "30px"
  }, " CO2-EMISSIONEN"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 36,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "24px"
  }, "in der europ\xE4ischen Neufahrzeugflotte "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 72,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "24px"
  }, "zwischen 1995 und 2020 "), /*#__PURE__*/React.createElement("tspan", {
    x: 261.59,
    y: 72,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "30px"
  }, "HALBIEREN.")))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "story-header-text-right"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 2738.5669 267.3643)",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "127px",
    letterSpacing: -2
  }, "getan"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeDesktop);
export default __webpack_public_path__ + "static/media/large-desktop.5901599d.svg";
export { ForwardRef as ReactComponent };